(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightone-explorer-page-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const smooth = (value) => value * value * (3 - 2 * value);

    const scenes = [
      {
        id: 'hero',
        from: 0,
        to: 0.08,
        startFrame: 1,
        endFrame: 30,
        eyebrow: 'LightOne Explorer',
        title: '25GbE starts with one Thunderbolt cable.',
        body: 'LightOne is a Thunderbolt network dock built around dual SFP28, not ordinary Ethernet.',
        metric: '$399 25GbE path',
        metricNote: 'A Thunderbolt-to-SFP28 workstation path without buying a higher-priced network-only adapter first.',
        backword: 'LIGHTONE',
        ghostword: '25GbE'
      },
      {
        id: 'desk-io',
        marker: 'desk-io',
        from: 0.08,
        to: 0.16,
        startFrame: 31,
        endFrame: 39,
        eyebrow: 'Dock first, network next',
        title: 'Front I/O keeps the desk moving.',
        body: 'SD/TF card access, two USB-C ports, and two Thunderbolt ports keep the workstation usable even before you upgrade the network.',
        metric: 'SD/TF + USB-C',
        metricNote: 'Two Thunderbolt ports support an expandable daisy-chain desk setup.',
        backword: 'DOCK',
        ghostword: 'I/O'
      },
      {
        id: 'thunderbolt',
        marker: 'desk-io',
        from: 0.16,
        to: 0.3,
        startFrame: 40,
        endFrame: 100,
        easing: 'approach-hold',
        eyebrow: 'One cable in',
        title: 'Connect the workstation first.',
        body: 'Thunderbolt connects your workstation first. From there, LightOne adds desk I/O, power, and a path to faster networking.',
        metric: 'Thunderbolt host',
        metricNote: 'Use the dock as the center of a high-speed workstation path.',
        backword: 'THUNDER',
        ghostword: 'BOLT'
      },
      {
        id: 'power-network',
        marker: 'network-path',
        from: 0.3,
        to: 0.52,
        startFrame: 101,
        endFrame: 136,
        easing: 'fast-insert',
        eyebrow: 'Power and network paths',
        title: 'PD power, RJ45, and SFP28 paths come into view.',
        body: 'Rear I/O gives you power, copper Ethernet, and optical SFP28 paths as your setup grows.',
        metric: 'RJ45 or fiber',
        metricNote: 'DAC cables, optical modules, and RJ45 transceivers are selected separately to match the setup.',
        backword: 'POWER',
        ghostword: 'LINK'
      },
      {
        id: 'network-path',
        marker: 'network-path',
        from: 0.52,
        to: 0.68,
        startFrame: 137,
        endFrame: 189,
        eyebrow: 'Network path, not network lock-in',
        title: 'Start with 10GbE. Grow into 25GbE.',
        body: 'LightOne can make sense before you own a full 25GbE network. The same dock can sit in a current SFP+ workflow and a future SFP28 path.',
        metric: 'Dual SFP28',
        metricNote: 'Network upgrade path plus workstation I/O in one device.',
        backword: 'SFP28',
        ghostword: '25G'
      },
      {
        id: 'thermal',
        marker: 'thermal',
        from: 0.68,
        to: 0.91,
        startFrame: 190,
        endFrame: 273,
        easing: 'fast-fan',
        eyebrow: 'Improved fan, updated after early feedback',
        title: 'The revised fan is part of the upgrade.',
        body: 'Early feedback called out fan noise under heavier network loads. LightOne now uses an improved fan setup for sustained NAS transfers and 10/25GbE workstation workloads.',
        metric: 'Improved fan',
        metricNote: 'Revised after early feedback on fan noise.',
        backword: 'THERMAL',
        ghostword: 'FAN'
      },
      {
        id: 'return',
        marker: 'hero',
        from: 0.91,
        to: 1,
        startFrame: 274,
        endFrame: 277,
        eyebrow: 'Ready for the workstation',
        title: 'Your workstation is ready for today and tomorrow.',
        body: 'LightOne brings dock I/O, Thunderbolt, power, SFP networking, and cooling into one upgrade path.',
        metric: 'Build the path',
        metricNote: 'Buy LightOne, then choose the DAC cable, optical module, or RJ45 transceiver for your network.',
        backword: 'READY',
        ghostword: '25GbE'
      }
    ];

    const frameSegments = [
      { from: 0, to: 0.08, startFrame: 1, endFrame: 30 },
      { from: 0.08, to: 0.25, startFrame: 31, endFrame: 60, easing: 'approach-hold' },
      { from: 0.25, to: 0.36, startFrame: 61, endFrame: 100 },
      { from: 0.36, to: 0.62, startFrame: 101, endFrame: 170, easing: 'fast-insert' },
      { from: 0.62, to: 0.68, startFrame: 171, endFrame: 189 },
      { from: 0.68, to: 0.91, startFrame: 190, endFrame: 273, easing: 'fast-fan' },
      { from: 0.91, to: 1, startFrame: 274, endFrame: 277 }
    ];

    const thermalIdleLoop = {
      startFrame: 220,
      endFrame: 245,
      fps: 18,
      waitMs: 180
    };

    const preloadFrame = (cache, urls, frame) => {
      const index = clamp(frame - 1, 0, urls.length - 1);
      if (cache.has(index)) return cache.get(index);
      const image = new Image();
      image.decoding = 'async';
      image.src = urls[index];
      cache.set(index, image);
      return image;
    };

    const initScroll = (section) => {
      if (section.dataset.loxReady === 'true') return;
      section.dataset.loxReady = 'true';

      const frameData = section.querySelector('[data-lox-frames]');
      const imageEl = section.querySelector('[data-lox-frame-image]');
      const titleEl = section.querySelector('[data-lox-title]');
      const bodyEl = section.querySelector('[data-lox-body]');
      const eyebrowEl = section.querySelector('[data-lox-eyebrow]');
      const metricEl = section.querySelector('[data-lox-metric]');
      const metricNoteEl = section.querySelector('[data-lox-metric-note]');
      const backwordEl = section.querySelector('[data-lox-backword]');
      const ghostwordEl = section.querySelector('[data-lox-ghostword]');
      const markers = Array.from(section.querySelectorAll('[data-lox-marker]'));

      if (!frameData || !imageEl) return;

      let urls = [];
      try {
        urls = JSON.parse(frameData.textContent);
      } catch (error) {
        urls = [];
      }
      if (!urls.length) return;

      const cache = new Map();
      let raf = 0;
      let thermalRaf = 0;
      let activeSceneId = '';
      let activeFrame = 1;
      let copyTimer = 0;
      let lastScrollAt = 0;
      let thermalLoopStartedAt = 0;
      let allPreloadStarted = false;

      const now = () => {
        return window.performance && window.performance.now ? window.performance.now() : Date.now();
      };

      [1, 30, 40, 60, 61, 80, 100, 101, 136, 170, 171, 189, 190, 230, 273, 277].forEach((frame) => preloadFrame(cache, urls, frame));

      const sceneForProgress = (progress) => {
        return scenes.find((scene) => progress >= scene.from && progress <= scene.to) || scenes[scenes.length - 1];
      };

      const frameSegmentForProgress = (progress) => {
        return frameSegments.find((segment) => progress >= segment.from && progress <= segment.to) || frameSegments[frameSegments.length - 1];
      };

      const applySceneCopy = (scene) => {
        if (eyebrowEl && eyebrowEl.textContent !== scene.eyebrow) eyebrowEl.textContent = scene.eyebrow;
        if (titleEl && titleEl.textContent !== scene.title) titleEl.textContent = scene.title;
        if (bodyEl && bodyEl.textContent !== scene.body) bodyEl.textContent = scene.body;
        if (metricEl && metricEl.textContent !== scene.metric) metricEl.textContent = scene.metric;
        if (metricNoteEl && metricNoteEl.textContent !== scene.metricNote) metricNoteEl.textContent = scene.metricNote;
        if (backwordEl && backwordEl.textContent !== scene.backword) backwordEl.textContent = scene.backword;
        if (ghostwordEl && ghostwordEl.textContent !== scene.ghostword) ghostwordEl.textContent = scene.ghostword;

        const markerId = scene.marker || scene.id;
        markers.forEach((marker) => {
          marker.classList.toggle('is-active', marker.dataset.loxMarker === markerId);
        });
      };

      const setScene = (scene) => {
        if (activeSceneId === scene.id) return;
        const hadScene = Boolean(activeSceneId);
        activeSceneId = scene.id;
        section.dataset.scene = scene.id;
        window.clearTimeout(copyTimer);

        if (!hadScene || reduceMotion) {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
          return;
        }

        section.classList.add('is-changing');
        copyTimer = window.setTimeout(() => {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
        }, 120);
      };

      const frameForProgress = (progress) => {
        const segment = frameSegmentForProgress(progress);
        if (reduceMotion) return segment.endFrame;
        const local = clamp((progress - segment.from) / Math.max(segment.to - segment.from, 0.0001), 0, 1);
        let eased = smooth(local);

        if (segment.easing === 'fast-insert') {
          if (local < 0.7) {
            eased = Math.pow(clamp(local / 0.7, 0, 1), 0.62) * 0.88;
          } else {
            eased = 0.88 + ((local - 0.7) / 0.3) * 0.12;
          }
        }

        if (segment.easing === 'approach-hold') {
          if (local < 0.72) {
            eased = smooth(clamp(local / 0.72, 0, 1));
          } else {
            eased = 1;
          }
        }

        if (segment.easing === 'fast-fan') {
          eased = Math.pow(local, 0.55);
        }

        return Math.round(segment.startFrame + (segment.endFrame - segment.startFrame) * eased);
      };

      const sectionProgress = () => {
        if (reduceMotion) return 1;
        const rect = section.getBoundingClientRect();
        const travel = Math.max(rect.height - window.innerHeight, 1);
        return clamp(-rect.top / travel, 0, 1);
      };

      const swapFrame = (frame) => {
        const index = clamp(frame - 1, 0, urls.length - 1);
        if (frame === activeFrame && imageEl.src === urls[index]) return;
        activeFrame = frame;
        const cached = preloadFrame(cache, urls, frame);
        imageEl.src = cached.src;
        preloadFrame(cache, urls, clamp(frame - 2, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame - 1, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame + 1, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame + 2, 1, urls.length));
      };

      const preloadAll = () => {
        if (allPreloadStarted) return;
        allPreloadStarted = true;
        const schedule = window.requestIdleCallback
          ? (callback) => window.requestIdleCallback(callback, { timeout: 700 })
          : (callback) => window.setTimeout(callback, 32);

        const load = (index) => {
          if (index >= urls.length) return;
          preloadFrame(cache, urls, index + 1);
          schedule(() => load(index + 1));
        };
        load(0);
      };

      const stopThermalLoop = () => {
        section.classList.remove('is-thermal-live');
        thermalLoopStartedAt = 0;
        if (!thermalRaf) return;
        window.cancelAnimationFrame(thermalRaf);
        thermalRaf = 0;
      };

      const runThermalLoop = (timestamp) => {
        thermalRaf = 0;
        const progress = sectionProgress();
        const scene = sceneForProgress(progress);

        if (scene.id !== 'thermal' || document.hidden) {
          stopThermalLoop();
          return;
        }

        section.classList.add('is-thermal-live');

        if (timestamp - lastScrollAt > thermalIdleLoop.waitMs) {
          if (!thermalLoopStartedAt) thermalLoopStartedAt = timestamp;
          const loopLength = thermalIdleLoop.endFrame - thermalIdleLoop.startFrame + 1;
          const elapsedFrames = Math.floor(((timestamp - thermalLoopStartedAt) / 1000) * thermalIdleLoop.fps);
          const frame = thermalIdleLoop.startFrame + (elapsedFrames % loopLength);
          swapFrame(frame);
        } else {
          thermalLoopStartedAt = 0;
        }

        thermalRaf = window.requestAnimationFrame(runThermalLoop);
      };

      const requestThermalLoop = () => {
        if (reduceMotion || thermalRaf) return;
        thermalRaf = window.requestAnimationFrame(runThermalLoop);
      };

      const render = () => {
        raf = 0;
        const progress = sectionProgress();
        const scene = sceneForProgress(progress);
        const frame = frameForProgress(progress);
        section.style.setProperty('--lox-progress', progress.toFixed(4));
        setScene(scene);
        swapFrame(frame);
        if (scene.id === 'thermal' && !reduceMotion) {
          requestThermalLoop();
        } else {
          stopThermalLoop();
        }
        if (progress > 0.01) preloadAll();
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      const markUserRender = () => {
        lastScrollAt = now();
        thermalLoopStartedAt = 0;
        requestRender();
      };

      const handleVisibility = () => {
        if (document.hidden) {
          stopThermalLoop();
          return;
        }
        markUserRender();
      };

      window.addEventListener('scroll', markUserRender, { passive: true });
      window.addEventListener('resize', markUserRender);
      document.addEventListener('visibilitychange', handleVisibility);
      lastScrollAt = now();
      preloadAll();
      requestRender();
    };

    const initBridge = (bridge) => {
      if (bridge.dataset.loxBridgeReady === 'true') return;
      bridge.dataset.loxBridgeReady = 'true';

      const setProgress = (progress) => {
        const eased = smooth(clamp(progress, 0, 1));
        bridge.style.setProperty('--lox-bridge-photo-opacity', (0.34 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--lox-bridge-photo-scale', (1.08 - eased * 0.035).toFixed(3));
        bridge.style.setProperty('--lox-bridge-copy-y', `${(28 - eased * 42).toFixed(2)}px`);
        bridge.style.setProperty('--lox-bridge-copy-opacity', (0.72 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--lox-bridge-line', Math.min(1, eased * 1.06).toFixed(3));
      };

      if (reduceMotion) {
        setProgress(1);
        return;
      }

      let raf = 0;
      const render = () => {
        raf = 0;
        const rect = bridge.getBoundingClientRect();
        const distance = Math.max(rect.height - window.innerHeight, 1);
        const progress = clamp(-rect.top / distance, 0, 1);
        setProgress(progress);
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initReveal = (root) => {
      const items = Array.from(root.querySelectorAll('[data-lox-reveal]'));
      if (!items.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    };

    const initAll = (root) => {
      root.querySelectorAll('[data-lox-scroll]').forEach(initScroll);
      root.querySelectorAll('[data-lox-bridge]').forEach(initBridge);
      root.querySelectorAll('[data-lox-root]').forEach(initReveal);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightone-shop-page-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-lto-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.ltoReady === 'true') return;
      root.dataset.ltoReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantData = root.querySelector('[data-lto-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-lto-variant-id]');
      const priceEl = root.querySelector('[data-lto-price]');
      const compareEl = root.querySelector('[data-lto-compare]');
      const saveEl = root.querySelector('[data-lto-save]');
      const atcText = root.querySelector('[data-lto-atc-text]');
      const submitButton = root.querySelector('.lto-atc');
      const optionGroups = Array.from(root.querySelectorAll('[data-lto-option]'));
      const choices = Array.from(root.querySelectorAll('[data-lto-option-choice]'));

      const getState = () =>
        optionGroups.map((group) => {
          const selected = group.querySelector('[data-lto-option-choice].is-selected');
          const first = group.querySelector('[data-lto-option-choice]');
          return selected ? selected.dataset.ltoOptionValue : first ? first.dataset.ltoOptionValue : '';
        });

      const findVariant = (state) =>
        variants.find((variant) => variant.options.every((option, index) => option === state[index]));

      const hasVariantForChoice = (index, value, state) =>
        variants.some((variant) => {
          if (!variant.available) return false;
          return variant.options.every((option, optionIndex) => {
            if (optionIndex === index) return option === value;
            return option === state[optionIndex];
          });
        });

      const updateChoiceAvailability = (state) => {
        choices.forEach((choice) => {
          const index = Number(choice.dataset.ltoOptionIndex || 0);
          const value = choice.dataset.ltoOptionValue || '';
          const possible = hasVariantForChoice(index, value, state);
          choice.classList.toggle('is-unavailable', !possible);
          choice.setAttribute('aria-disabled', possible ? 'false' : 'true');
        });
      };

      const setVariant = () => {
        let state = getState();
        let variant = findVariant(state);

        if (!variant) {
          const fallback = variants.find((candidate) => candidate.available) || variants[0];
          if (fallback) {
            state = fallback.options;
            optionGroups.forEach((group, groupIndex) => {
              group.querySelectorAll('[data-lto-option-choice]').forEach((choice) => {
                const selected = choice.dataset.ltoOptionValue === state[groupIndex];
                choice.classList.toggle('is-selected', selected);
                choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
              });
            });
            variant = fallback;
          }
        }

        updateChoiceAvailability(state);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }
        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }
        if (atcText) atcText.textContent = variant.available ? 'Add LightOne to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);
      };

      choices.forEach((choice) => {
        choice.addEventListener('click', () => {
          if (choice.classList.contains('is-unavailable')) return;
          const group = choice.closest('[data-lto-option]');
          if (!group) return;
          group.querySelectorAll('[data-lto-option-choice]').forEach((sibling) => {
            const selected = sibling === choice;
            sibling.classList.toggle('is-selected', selected);
            sibling.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          setVariant();
        });
      });

      setVariant();

      const revealTargets = Array.from(root.querySelectorAll('.lto-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.14, rootMargin: '-4% 0px -8% 0px' }
        );
        revealTargets.forEach((target) => observer.observe(target));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightone-shop-page-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-lto-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.ltoReady === 'true') return;
      root.dataset.ltoReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantData = root.querySelector('[data-lto-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-lto-variant-id]');
      const priceEl = root.querySelector('[data-lto-price]');
      const compareEl = root.querySelector('[data-lto-compare]');
      const saveEl = root.querySelector('[data-lto-save]');
      const payLaterMessage = root.querySelector('[data-paypal-pay-later-message]');
      const atcText = root.querySelector('[data-lto-atc-text]');
      const stickyPrice = root.querySelector('[data-lto-sticky-price]');
      const submitButton = root.querySelector('.lto-atc');
      const optionGroups = Array.from(root.querySelectorAll('[data-lto-option]'));
      const choices = Array.from(root.querySelectorAll('[data-lto-option-choice]'));

      const getState = () =>
        optionGroups.map((group) => {
          const selected = group.querySelector('[data-lto-option-choice].is-selected');
          const first = group.querySelector('[data-lto-option-choice]');
          return selected ? selected.dataset.ltoOptionValue : first ? first.dataset.ltoOptionValue : '';
        });

      const findVariant = (state) =>
        variants.find((variant) => variant.options.every((option, index) => option === state[index]));

      const hasVariantForChoice = (index, value, state) =>
        variants.some((variant) => {
          if (!variant.available) return false;
          return variant.options.every((option, optionIndex) => {
            if (optionIndex === index) return option === value;
            return option === state[optionIndex];
          });
        });

      const updateChoiceAvailability = (state) => {
        choices.forEach((choice) => {
          const index = Number(choice.dataset.ltoOptionIndex || 0);
          const value = choice.dataset.ltoOptionValue || '';
          const possible = hasVariantForChoice(index, value, state);
          choice.classList.toggle('is-unavailable', !possible);
          choice.setAttribute('aria-disabled', possible ? 'false' : 'true');
        });
      };

      const setVariant = () => {
        let state = getState();
        let variant = findVariant(state);

        if (!variant) {
          const fallback = variants.find((candidate) => candidate.available) || variants[0];
          if (fallback) {
            state = fallback.options;
            optionGroups.forEach((group, groupIndex) => {
              group.querySelectorAll('[data-lto-option-choice]').forEach((choice) => {
                const selected = choice.dataset.ltoOptionValue === state[groupIndex];
                choice.classList.toggle('is-selected', selected);
                choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
              });
            });
            variant = fallback;
          }
        }

        updateChoiceAvailability(state);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;
        if (payLaterMessage && variant.price_amount) {
          payLaterMessage.setAttribute('data-pp-amount', variant.price_amount);
        }
        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }
        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }
        if (atcText) atcText.textContent = variant.available ? 'Add LightOne to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);
      };

      choices.forEach((choice) => {
        choice.addEventListener('click', () => {
          if (choice.classList.contains('is-unavailable')) return;
          const group = choice.closest('[data-lto-option]');
          if (!group) return;
          group.querySelectorAll('[data-lto-option-choice]').forEach((sibling) => {
            const selected = sibling === choice;
            sibling.classList.toggle('is-selected', selected);
            sibling.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          setVariant();
        });
      });

      setVariant();

      const revealTargets = Array.from(root.querySelectorAll('.lto-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.14, rootMargin: '-4% 0px -8% 0px' }
        );
        revealTargets.forEach((target) => observer.observe(target));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-pdp-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-lo26]');
    roots.forEach((root) => {
      /* Effects are switched on here, by the script itself, so a slow or failed script load
         never leaves content hidden. Content already on screen is marked revealed first. */
      const motion = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (motion) {
        /* Split headlines into masked words, and the statement into words that light up. */
        const splitWords = (el, cls) => {
          let i = 0;
          const walk = (parent) => {
            Array.from(parent.childNodes).forEach((node) => {
              if (node.nodeType === 1) {
                if (!node.classList.contains('lo26-visually-hidden')) walk(node);
                return;
              }
              if (node.nodeType !== 3 || !node.textContent.trim()) return;
              const frag = document.createDocumentFragment();
              node.textContent.split(/([ \n\t]+)/).forEach((part) => {
                if (!part) return;
                if (/^[ \n\t]+$/.test(part)) {
                  frag.appendChild(document.createTextNode(' '));
                  return;
                }
                const word = document.createElement('span');
                if (cls === 'lo26-w') {
                  const inner = document.createElement('span');
                  inner.textContent = part;
                  inner.style.setProperty('--lo-i', String(i));
                  word.appendChild(inner);
                } else {
                  word.textContent = part;
                  word.style.setProperty('--lo-i', String(i));
                }
                word.className = cls;
                i += 1;
                frag.appendChild(word);
              });
              parent.replaceChild(frag, node);
            });
          };
          walk(el);
          return i;
        };
        root.querySelectorAll('h2.lo26-title:not(.lo26-visually-hidden)').forEach((h2) => {
          splitWords(h2, 'lo26-w');
          h2.classList.add('lo26-words');
          const host = h2.closest('[data-lo-reveal]');
          if (!host) return;
          host.classList.add('lo26-reveal-words');
          Array.from(h2.parentElement.children).forEach((child) => {
            if (child !== h2 && !child.classList.contains('lo26-eyebrow')) child.classList.add('lo26-follow');
          });
          if (h2.parentElement !== host) {
            Array.from(host.children).forEach((child) => {
              if (!child.contains(h2)) child.classList.add('lo26-follow');
            });
          }
        });
        const statementText = root.querySelector('[data-lo26-statement-text]');
        if (statementText) {
          statementText.style.setProperty('--lo-n', String(splitWords(statementText, 'lo26-sw')));
          /* Each marked phrase draws its rule while its own words light up. */
          statementText.querySelectorAll('mark').forEach((mark) => {
            const words = mark.querySelectorAll('.lo26-sw');
            if (!words.length) return;
            mark.style.setProperty('--lo-is', words[0].style.getPropertyValue('--lo-i'));
            mark.style.setProperty('--lo-ml', String(words.length));
          });
        }
        root.querySelectorAll('.lo26-ticks > .lo26-frame').forEach((frame) => frame.classList.add('lo26-media'));
        root.querySelectorAll('[data-lo-reveal]').forEach((node) => {
          if (node.getBoundingClientRect().top < window.innerHeight) {
            node.classList.add('is-in');
            node.dataset.loSeen = '1';
          }
        });
        const poster = root.querySelector('[data-lo26-seq-poster]');
        if (poster && poster.dataset.lo26SeqStart) poster.src = poster.dataset.lo26SeqStart;
        root.classList.add('lo26-motion');
      }
      root.setAttribute('data-lo26-ready', '');
      const read = (selector) => {
        const node = root.querySelector(selector);
        try {
          return node ? JSON.parse(node.textContent) : [];
        } catch (error) {
          return [];
        }
      };
      const variants = read('[data-lo26-variants]');
      const accessories = read('[data-lo26-acc]');
      const seqFramesDesktop = read('[data-lo26-seq-frames]');
      const seqFramesPhone = read('[data-lo26-seq-frames-phone]');
      const $ = (selector) => root.querySelector(selector);
      const $$ = (selector) => Array.from(root.querySelectorAll(selector));
      const setText = (selector, text) => $$(selector).forEach((node) => { node.textContent = text; });
      const clamp = (v, min = 0, max = 1) => Math.min(max, Math.max(min, v));
      const isPhone = () => window.matchMedia('(max-width: 900px)').matches;
      const seqFrames = isPhone() && seqFramesPhone.length ? seqFramesPhone : seqFramesDesktop;

      /* ---------- Variant selection: finish x power plug ---------- */
      const idInput = $('[data-lo26-variant-id]');
      const submit = root.querySelector('.product-form__submit');
      const chosen = (n) => {
        const input = root.querySelector(`input[name="lo26_opt${n}"]:checked`);
        return input ? input.value : null;
      };
      const findVariant = (o1, o2) => variants.find((v) => v.o1 === o1 && (v.o2 === null || o2 === null || v.o2 === o2));
      /* Plug types that are sold out in the chosen finish are shown dimmed (still selectable). */
      const markAvailability = () => {
        $$('input[name="lo26_opt2"]').forEach((input) => {
          const v = findVariant(chosen(1), input.value);
          const label = input.closest('label');
          if (label) label.classList.toggle('is-soldout', !(v && v.available));
        });
      };
      const updateVariant = (variant) => {
        if (!variant) return;
        if (idInput) {
          idInput.value = variant.id;
          idInput.disabled = !variant.available;
        }
        setText('[data-lo26-price]', variant.price);
        setText('[data-lo26-sticky-price]', variant.price);
        setText('[data-lo26-final-price]', variant.price);
        setText('[data-lo26-opt-name="1"]', variant.o1);
        if (variant.o2) setText('[data-lo26-opt-name="2"]', variant.o2);
        setText('[data-lo26-sticky-finish]', variant.o1);
        setText('[data-lo26-final-finish]', variant.o1);
        const compare = $('[data-lo26-compare]');
        const save = $('[data-lo26-save]');
        if (compare) {
          compare.textContent = variant.compare || '';
          compare.classList.toggle('is-hidden', !variant.compare);
        }
        if (save) {
          save.textContent = variant.save ? `Save ${variant.save}` : '';
          save.classList.toggle('is-hidden', !variant.save);
        }
        const swatch = $('[data-lo26-sticky-swatch]');
        if (swatch) swatch.className = `lo26-swatch lo26-swatch--${variant.o1.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
        const atcText = $('[data-lo26-atc-text]');
        if (atcText) atcText.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (submit) submit.toggleAttribute('disabled', !variant.available);
        $$('[data-lo26-alt-atc]').forEach((button) => button.toggleAttribute('disabled', !variant.available));
        const stock = $('[data-lo26-stock]');
        if (stock) {
          stock.innerHTML = variant.available
            ? '<span class="lo26-stock__dot" aria-hidden="true"></span> In stock, ships now. Delivery estimate at checkout.'
            : '<span class="lo26-stock__dot is-out" aria-hidden="true"></span> This version is sold out.';
        }
        const payLater = root.querySelector('[data-paypal-pay-later-message]');
        if (payLater) payLater.setAttribute('data-pp-amount', variant.price_amount);
        markAvailability();
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (error) {
          /* URL updates are a convenience only */
        }
      };
      $$('[data-lo26-opt]').forEach((input) => {
        input.addEventListener('change', () => updateVariant(findVariant(chosen(1), chosen(2))));
      });
      markAvailability();

      /* ---------- Quantity ---------- */
      const qty = root.querySelector('input[name="quantity"]');
      $$('[data-lo26-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!qty) return;
          qty.value = Math.min(20, Math.max(1, (parseInt(qty.value, 10) || 1) + Number(button.dataset.lo26Qty)));
        });
      });

      /* ---------- Gallery ---------- */
      const track = $('[data-lo26-track]');
      const thumbs = $$('[data-lo26-thumb]');
      if (track) {
        const slides = Array.from(track.children);
        const goTo = (index) => {
          const clamped = (index + slides.length) % slides.length;
          track.scrollTo({ left: slides[clamped].offsetLeft, behavior: 'smooth' });
        };
        const current = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        const markActive = () => {
          const index = current();
          thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-active', i === index);
            if (i === index) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
        };
        let ticking = false;
        track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => {
            markActive();
            ticking = false;
          });
        }, { passive: true });
        thumbs.forEach((thumb) => thumb.addEventListener('click', () => goTo(Number(thumb.dataset.lo26Thumb))));
        const prev = $('[data-lo26-prev]');
        const next = $('[data-lo26-next]');
        if (prev) prev.addEventListener('click', () => goTo(current() - 1));
        if (next) next.addEventListener('click', () => goTo(current() + 1));
        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            goTo(current() + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goTo(current() - 1);
          }
        });
      }

      /* ---------- Count-up numbers ---------- */
      const countUp = (node) => {
        if (node.dataset.loCounted) return;
        node.dataset.loCounted = '1';
        const target = Number(node.dataset.loCount);
        if (!motion || !Number.isFinite(target)) return;
        const fmt = (v) => Math.round(v).toLocaleString('en-US');
        const start = performance.now();
        const duration = target > 999 ? 1400 : 900;
        const step = (now) => {
          const t = clamp((now - start) / duration);
          node.textContent = fmt(target * (1 - Math.pow(1 - t, 3)));
          if (t < 1) window.requestAnimationFrame(step);
        };
        node.textContent = '0';
        window.requestAnimationFrame(step);
      };

      /* ---------- Reveal on scroll ---------- */
      $$('[data-lo-stagger]').forEach((group) => {
        Array.from(group.children).forEach((child, i) => child.style.setProperty('--lo-d', `${i * 90}ms`));
      });
      const reveal = (node) => {
        node.classList.add('is-in');
        node.querySelectorAll('[data-lo-count]').forEach(countUp);
        /* Drop stagger delays once the entrance is over so hover effects respond at once. */
        if (node.hasAttribute('data-lo-stagger')) {
          window.setTimeout(() => {
            Array.from(node.children).forEach((child) => child.style.setProperty('--lo-d', '0ms'));
          }, 1600);
        }
      };
      if (motion && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal(entry.target);
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
        $$('[data-lo-reveal]').forEach((node) => {
          if (!node.dataset.loSeen) io.observe(node);
        });
        $$('.lo26-media').forEach((node) => {
          if (node.getBoundingClientRect().top < window.innerHeight) node.classList.add('is-in');
          else io.observe(node);
        });
      } else {
        $$('[data-lo-reveal]').forEach(reveal);
        $$('.lo26-media').forEach((node) => node.classList.add('is-in'));
      }

      /* ---------- Looping details run only while on screen ---------- */
      const loops = $$('.lo26-bento__grid, [data-lo26-linkmap], [data-lo26-flow]');
      if (loops.length && 'IntersectionObserver' in window) {
        const lio = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
            const svg = entry.target.matches('svg') ? entry.target : entry.target.querySelector('svg');
            if (svg && svg.pauseAnimations) {
              if (entry.isIntersecting) svg.unpauseAnimations();
              else svg.pauseAnimations();
            }
          });
        });
        loops.forEach((node) => lio.observe(node));
      }

      /* ---------- Feature list highlight ---------- */
      const features = $$('[data-lo26-features] li');
      if (motion && features.length && 'IntersectionObserver' in window) {
        const fio = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.target.classList.toggle('is-active', entry.isIntersecting));
        }, { rootMargin: '-38% 0px -38% 0px' });
        features.forEach((li) => fio.observe(li));
      }

      /* ---------- Pinned assembly sequence ---------- */
      const seq = $('[data-lo26-seq]');
      const canvas = $('[data-lo26-seq-canvas]');
      const ctx = canvas ? canvas.getContext('2d') : null;
      /* Every frame of the render shot is used (no skipped frames). Each is fetched once as a
         compressed blob; only frames near the current position are decoded to ImageBitmaps
         (rolling cache), so drawing never decodes and memory stays bounded. shown eases toward
         target. */
      const seqState = { blobs: [], frames: [], pending: new Set(), started: false, drawn: -1, target: 0, shown: 0, dir: 1, cssWidth: 0 };
      if (seq) seq.__lo26 = seqState;
      const keys = (() => {
        try {
          return JSON.parse(seq ? seq.getAttribute('data-lo26-seq-keys') : '{}') || {};
        } catch (error) {
          return {};
        }
      })();
      const last = seqFrames.length - 1;
      const K = {
        rear: keys.rear || 0,
        power: keys.power || 0,
        fiber: keys.fiber || 0,
        copper: keys.copper || 0,
        settled: keys.settled || last,
        fan: keys.fan || last,
      };
      const beats = $$('[data-lo-beat]');
      const hudPower = $('[data-lo26-hud-power]');
      const hudP1 = $('[data-lo26-hud-p1]');
      const hudP2 = $('[data-lo26-hud-p2]');
      const rail = $('[data-lo26-rail]');
      /* What is plugged in at a frame: 0 nothing, 1 power, 2 + fiber, 3 + copper. */
      const linksAt = (i) => (i >= K.copper ? 3 : i >= K.fiber ? 2 : i >= K.power ? 1 : 0);
      /* Scroll progress -> frame. Each plug gets an unhurried move and a short rest; the camera
         then settles on the rear, and the chassis fades away to the fan. */
      const curve = [
        [0, K.rear], [0.05, K.rear],
        [0.15, K.power], [0.19, K.power],
        [0.33, K.fiber], [0.37, K.fiber],
        [0.5, K.copper], [0.55, K.copper],
        [0.7, K.settled], [0.74, K.settled],
        [0.92, K.fan], [1, K.fan],
      ];
      const frameAt = (p) => {
        for (let k = 1; k < curve.length; k += 1) {
          const [p0, f0] = curve[k - 1];
          const [p1, f1] = curve[k];
          if (p <= p1) return Math.round(f0 + (f1 - f0) * (p1 === p0 ? 1 : (p - p0) / (p1 - p0)));
        }
        return curve[curve.length - 1][1];
      };
      const beatAt = (p) => (p >= 0.74 ? 4 : p >= 0.37 ? 3 : p >= 0.19 ? 2 : p >= 0.05 ? 1 : 0);

      const nearestReady = (index) => {
        for (let d = 0; d <= last; d += 1) {
          if (seqState.frames[index - d]) return index - d;
          if (seqState.frames[index + d]) return index + d;
        }
        return -1;
      };

      const paint = (index) => {
        if (!ctx || !seqState.started) return;
        const pick = nearestReady(index);
        if (pick < 0 || pick === seqState.drawn) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(seqState.frames[pick], 0, 0, canvas.width, canvas.height);
        seqState.drawn = pick;
        if (!seq.classList.contains('is-live')) seq.classList.add('is-live');
      };

      /* Rolling decode cache */
      const cacheMax = isPhone() ? 22 : 34;
      const decodeQueue = [];
      let decoding = 0;
      const decodeBlob = (blob) => {
        if ('createImageBitmap' in window) {
          const opts = canvas.width ? { resizeWidth: Math.min(canvas.width, 1000), resizeQuality: 'high' } : undefined;
          return createImageBitmap(blob, opts).catch(() => createImageBitmap(blob));
        }
        const img = new Image();
        img.src = URL.createObjectURL(blob);
        return img.decode().then(() => img);
      };
      const evict = () => {
        const held = [];
        seqState.frames.forEach((frame, i) => {
          if (frame) held.push(i);
        });
        if (held.length <= cacheMax) return;
        const center = seqState.shown;
        held.sort((a, b) => Math.abs(b - center) - Math.abs(a - center));
        held.slice(0, held.length - cacheMax).forEach((i) => {
          if (Math.abs(i - center) <= 4) return;
          const frame = seqState.frames[i];
          if (frame && frame.close) frame.close();
          seqState.frames[i] = null;
        });
      };
      const pump = () => {
        while (decoding < 2 && decodeQueue.length) {
          const i = decodeQueue.shift();
          if (seqState.frames[i] || seqState.pending.has(i) || !seqState.blobs[i]) continue;
          decoding += 1;
          seqState.pending.add(i);
          decodeBlob(seqState.blobs[i])
            .then((frame) => {
              seqState.frames[i] = frame;
              if (Math.abs(i - seqState.shown) <= 2 || seqState.drawn < 0) {
                seqState.drawn = -1;
                paint(Math.round(seqState.shown));
              }
              evict();
            })
            .catch(() => {})
            .then(() => {
              decoding -= 1;
              seqState.pending.delete(i);
              pump();
            });
        }
      };
      /* Decode around the current frame, mostly ahead in the scroll direction. */
      const schedule = () => {
        if (!seqState.started) return;
        const center = Math.round(seqState.shown);
        const ahead = isPhone() ? 12 : 18;
        const behind = 5;
        decodeQueue.length = 0;
        for (let k = 0; k <= ahead; k += 1) {
          const forward = center + seqState.dir * k;
          if (forward >= 0 && forward <= last && !seqState.frames[forward]) decodeQueue.push(forward);
          if (k > 0 && k <= behind) {
            const back = center - seqState.dir * k;
            if (back >= 0 && back <= last && !seqState.frames[back]) decodeQueue.push(back);
          }
        }
        pump();
      };

      let easing = false;
      const ease = () => {
        const diff = seqState.target - seqState.shown;
        seqState.shown = Math.abs(diff) < 0.04 ? seqState.target : seqState.shown + diff * 0.25;
        paint(Math.round(seqState.shown));
        schedule();
        if (seqState.shown !== seqState.target) window.requestAnimationFrame(ease);
        else easing = false;
      };
      const kick = () => {
        if (easing) return;
        easing = true;
        window.requestAnimationFrame(ease);
      };

      /* Size the canvas only when its width changes, so the phone address bar showing or
         hiding (a height-only resize) never clears and rebuilds it mid-scroll. */
      const sizeCanvas = (force) => {
        if (!canvas) return;
        const width = canvas.clientWidth;
        if (!width || (!force && Math.abs(width - seqState.cssWidth) < 2)) return;
        seqState.cssWidth = width;
        const dpr = Math.min(window.devicePixelRatio || 1, isPhone() ? 1.75 : 2);
        canvas.width = Math.round(width * dpr);
        canvas.height = Math.round(canvas.clientHeight * dpr);
        seqState.drawn = -1;
        paint(Math.round(seqState.shown));
      };

      /* Download order: resting states first, then fill gaps by halving, so coverage is even
         early. Phones and Save-Data skip every other in-between frame. */
      /* Resting states first, nearest to where the visitor is now (someone who lands mid-sequence
         sees the right frame first), then the in-between frames by halving. */
      const loadOrder = () => {
        const here = seqState.target;
        const order = [K.rear, K.power, K.fiber, K.copper, K.settled, K.fan]
          .filter((k, i, all) => all.indexOf(k) === i)
          .sort((a, b) => Math.abs(a - here) - Math.abs(b - here));
        const seen = new Set(order);
        const lean = isPhone() || (navigator.connection && navigator.connection.saveData);
        let step = 32;
        while (step >= (lean ? 2 : 1)) {
          for (let i = 0; i <= last; i += step) {
            if (!seen.has(i)) {
              seen.add(i);
              order.push(i);
            }
          }
          step = Math.floor(step / 2);
        }
        return order;
      };

      const startSeq = () => {
        if (seqState.started || !canvas || !seqFrames.length) return;
        seqState.started = true;
        sizeCanvas(true);
        let order = [];
        let cursor = 0;
        // fetch() sends a wildcard Accept header by default, and the Shopify CDN then answers
        // with PNG (about 8x larger). Ask for WebP explicitly, as an <img> request would.
        const accept = { headers: { Accept: 'image/webp,image/*;q=0.8' } };
        const fetchNext = () => {
          if (cursor >= order.length) return;
          const i = order[cursor];
          cursor += 1;
          fetch(seqFrames[i], accept)
            .then((response) => (response.ok ? response.blob() : null))
            .then((blob) => {
              if (!blob) return;
              seqState.blobs[i] = blob;
              if (seqState.drawn < 0 || Math.abs(i - seqState.shown) <= 20) schedule();
            })
            .catch(() => {})
            .then(fetchNext);
        };
        /* Wait one frame so the scroll handler has set the current target before ordering. */
        window.requestAnimationFrame(() => {
          order = loadOrder();
          for (let k = 0; k < 4; k += 1) fetchNext();
        });
      };

      let lastBeat = -1;
      let lastLinks = -1;
      let lastRail = -1;
      /* Called with layout values already read in onFrame; only writes here. */
      const updateSeq = (rectTop, rectHeight, vh) => {
        const p = clamp(-rectTop / Math.max(1, rectHeight - vh));
        const target = Math.min(last, frameAt(p));
        if (target !== seqState.target) seqState.dir = target > seqState.target ? 1 : -1;
        seqState.target = target;
        kick();
        const beat = beatAt(p);
        if (beat !== lastBeat) {
          lastBeat = beat;
          beats.forEach((node, i) => node.classList.toggle('is-active', i === beat));
        }
        const links = linksAt(seqState.target);
        if (links !== lastLinks) {
          lastLinks = links;
          if (hudPower) hudPower.textContent = links >= 1 ? '140 W' : '—';
          if (hudP1) hudP1.textContent = links >= 2 ? '25G FIBER' : '—';
          if (hudP2) hudP2.textContent = links >= 3 ? '10G COPPER' : '—';
        }
        const railP = Math.round(p * 500) / 500;
        if (rail && railP !== lastRail) {
          lastRail = railP;
          rail.style.transform = `scaleX(${railP})`;
        }
      };

      /* Frames load only after the page itself has loaded and the visitor starts scrolling
         (or the sequence is close), so visitors who never scroll never download them. */
      if (seq && motion) {
        let pageLoaded = document.readyState === 'complete';
        let wanted = false;
        const tryStart = () => {
          if (pageLoaded && wanted) startSeq();
        };
        const want = () => {
          wanted = true;
          tryStart();
        };
        if (!pageLoaded) {
          window.addEventListener('load', () => {
            pageLoaded = true;
            tryStart();
          }, { once: true });
          /* Some third-party scripts hold up the load event for a long time. */
          window.setTimeout(() => {
            pageLoaded = true;
            tryStart();
          }, 6000);
        }
        const onFirstScroll = () => {
          if (window.scrollY > 120) {
            window.removeEventListener('scroll', onFirstScroll);
            want();
          }
        };
        window.addEventListener('scroll', onFirstScroll, { passive: true });
        if ('IntersectionObserver' in window) {
          /* Reaching the sequence itself starts loading at once, even if the page load event is late. */
          const sio = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              startSeq();
              sio.disconnect();
            }
          }, { rootMargin: '0px 0px 25% 0px' });
          sio.observe(seq);
        } else {
          want();
        }
      }

      /* ---------- Scroll-linked effects ---------- */
      const zoom = $('[data-lo26-zoom]');
      const marquee = $('[data-lo26-marquee]');
      const marqueeHost = $('[data-lo26-marquee-host]');
      const parallax = $('[data-lo26-parallax]');
      const wordmark = $('[data-lo26-wordmark]');
      const statement = $('[data-lo26-statement-text]');
      const details = $('[data-lo26-details]');
      const detailsTrack = $('[data-lo26-details-track]');
      const panels = detailsTrack ? Array.from(detailsTrack.children) : [];
      const detailsN = $('[data-lo26-details-n]');
      let detailsTravel = 0;
      let panelCenters = [];
      let lastPanel = -1;
      let lastStatement = -1;
      /* Horizontal travel of the Details track; the section is made that much taller than the
         viewport so vertical scrolling drives it. */
      const measureDetails = () => {
        if (!motion || !details || !detailsTrack) return;
        detailsTravel = Math.max(0, detailsTrack.offsetWidth - document.documentElement.clientWidth);
        panelCenters = panels.map((panel) => panel.offsetLeft + panel.offsetWidth / 2);
        details.style.setProperty('--lo-gt', `${Math.round(detailsTravel)}px`);
      };
      measureDetails();
      const progress = $('[data-lo26-progress]');
      const sticky = $('[data-lo26-sticky]');
      const buybox = $('[data-lo26-buybox]');
      const final = $('[data-lo26-final]');
      const actions = buybox ? buybox.querySelector('.lo26-actions') || buybox : null;
      let shown = null;
      let queued = false;
      let docHeight = document.documentElement.scrollHeight;
      let marqueeTravel = marquee ? Math.max(0, marquee.scrollWidth - window.innerWidth * 0.6) : 0;
      const remeasure = () => {
        measureDetails();
        docHeight = document.documentElement.scrollHeight;
        marqueeTravel = marquee ? Math.max(0, marquee.scrollWidth - window.innerWidth * 0.6) : 0;
      };
      const visible = (r, vh) => r.bottom > -vh * 0.25 && r.top < vh * 1.25;
      const span = (r, vh) => clamp((vh - r.top) / (vh + r.height));

      /* Read every rectangle first, then write, so no write forces a second layout. */
      const onFrame = () => {
        queued = false;
        const vh = window.innerHeight;
        const scrollY = window.scrollY;
        const rSeq = motion && seq ? seq.getBoundingClientRect() : null;
        const rZoom = motion && zoom ? zoom.getBoundingClientRect() : null;
        const rMarquee = motion && marquee && marqueeHost ? marqueeHost.getBoundingClientRect() : null;
        const rParallax = motion && parallax ? parallax.parentElement.getBoundingClientRect() : null;
        const rWord = motion && wordmark ? wordmark.getBoundingClientRect() : null;
        const rStatement = motion && statement ? statement.getBoundingClientRect() : null;
        const rDetails = motion && details && detailsTrack ? details.getBoundingClientRect() : null;
        const vw = window.innerWidth;
        const rActions = sticky && actions ? actions.getBoundingClientRect() : null;
        const rFinal = sticky && final ? final.getBoundingClientRect() : null;

        if (rSeq && visible(rSeq, vh)) updateSeq(rSeq.top, rSeq.height, vh);
        if (rZoom && visible(rZoom, vh)) zoom.style.setProperty('--lo-zoom', (1.18 - 0.18 * clamp(span(rZoom, vh) * 1.6)).toFixed(4));
        if (rMarquee && visible(rMarquee, vh)) marquee.style.setProperty('--lo-x', `${(-span(rMarquee, vh) * marqueeTravel).toFixed(1)}px`);
        if (rParallax && visible(rParallax, vh)) parallax.style.setProperty('--lo-y', `${((span(rParallax, vh) - 0.5) * -90).toFixed(1)}px`);
        if (rWord && visible(rWord, vh)) wordmark.style.setProperty('--lo-wmy', `${(20 + span(rWord, vh) * 60).toFixed(1)}%`);
        if (rStatement && visible(rStatement, vh)) {
          const sp = Math.round(clamp((vh * 0.82 - rStatement.top) / (rStatement.height + vh * 0.42)) * 400) / 400;
          if (sp !== lastStatement) {
            lastStatement = sp;
            statement.style.setProperty('--lo-p', String(sp));
          }
        }
        if (rDetails && visible(rDetails, vh)) {
          const gp = clamp(-rDetails.top / Math.max(1, rDetails.height - vh));
          const gx = -gp * detailsTravel;
          details.style.setProperty('--lo-gx', `${gx.toFixed(1)}px`);
          details.style.setProperty('--lo-gp', gp.toFixed(4));
          panels.forEach((panel, i) => {
            panel.style.setProperty('--lo-pp', clamp((panelCenters[i] + gx - vw / 2) / vw, -1, 1).toFixed(3));
          });
          const active = Math.round(gp * (panels.length - 1));
          if (active !== lastPanel) {
            lastPanel = active;
            panels.forEach((panel, i) => panel.classList.toggle('is-active', i === active));
            if (detailsN) detailsN.textContent = String(active + 1).padStart(2, '0');
          }
        }
        if (progress) progress.style.setProperty('--lo-p', clamp(scrollY / Math.max(1, docHeight - vh)).toFixed(4));
        if (rActions) {
          const show = rActions.bottom < 0 && !(rFinal && rFinal.top < vh * 0.8);
          if (show !== shown) {
            shown = show;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', String(!show));
            sticky.querySelectorAll('a, button').forEach((node) => node.setAttribute('tabindex', show ? '0' : '-1'));
          }
        }
      };
      const queue = () => {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(onFrame);
      };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', () => {
        sizeCanvas(false);
        remeasure();
        queue();
      }, { passive: true });
      window.addEventListener('load', () => {
        remeasure();
        queue();
      }, { once: true });
      /* Opening the spec list or an FAQ answer changes the page height. */
      root.addEventListener('toggle', () => {
        remeasure();
        queue();
      }, true);
      onFrame();

      /* ---------- Cursor spotlight on cards (mouse / trackpad only) ---------- */
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        let spotEvent = null;
        let spotQueued = false;
        root.addEventListener('pointermove', (event) => {
          spotEvent = event;
          if (spotQueued) return;
          spotQueued = true;
          window.requestAnimationFrame(() => {
            spotQueued = false;
            const card = spotEvent.target.closest && spotEvent.target.closest('[data-lo-spot]');
            if (!card) return;
            const r = card.getBoundingClientRect();
            card.style.setProperty('--mx', `${Math.round(spotEvent.clientX - r.left)}px`);
            card.style.setProperty('--my', `${Math.round(spotEvent.clientY - r.top)}px`);
          });
        }, { passive: true });
      }

      /* ---------- Link planner ---------- */
      const linkHost = $('[data-lo26-link]');
      if (linkHost) {
        const options = {
          dac: {
            acc: 'dac',
            name: 'SFP28 DAC cable',
            use: 'Direct copper cable to an SFP28 switch or NAS, 0.5 to 5 m',
            speed: 'LINK 25GbE',
            end: 'SFP28 · DAC',
          },
          fiber: {
            acc: 'fiber',
            name: 'SFP28 optical module',
            use: '1310 nm, up to 10 km on single-mode fiber. Use a matching module at the far end',
            speed: 'LINK 25GbE',
            end: 'SFP28 · FIBER',
          },
          sfpplus: {
            acc: null,
            name: '10G SFP+ module or DAC',
            use: 'The SFP28 ports also run SFP+. Use the module or cable your switch supports',
            speed: 'LINK 10GbE',
            end: 'SFP+ · 10G',
          },
          rj45: {
            acc: 'rj45',
            name: 'SFP+ to RJ45 transceiver',
            use: 'Joins 10GBASE-T, 5G, 2.5G or 1G copper at your switch\'s speed',
            speed: 'LINK UP TO 10GbE',
            end: 'RJ45 · COPPER',
          },
          none: {
            acc: null,
            name: 'Nothing yet',
            use: 'Leave the port free and add a module later',
            speed: '',
            end: 'FREE',
          },
        };
        const linkValue = (n) => {
          const input = root.querySelector(`input[name="lo26_port${n}"]:checked`);
          return input ? input.value : 'none';
        };
        const setLink = (n, value) => {
          root.querySelectorAll(`input[name="lo26_port${n}"]`).forEach((input) => { input.checked = input.value === value; });
        };
        const el = (tag, cls, text) => {
          const node = document.createElement(tag);
          if (cls) node.className = cls;
          if (text) node.textContent = text;
          return node;
        };
        const note = $('[data-lo26-link-note]');
        const caption = $('[data-lo26-link-caption]');
        const renderLinks = () => {
          const picks = [linkValue(1), linkValue(2)];
          picks.forEach((value, i) => {
            const n = i + 1;
            const option = options[value] || options.none;
            const li = $(`[data-lo26-pick="${n}"]`);
            if (li) {
              li.textContent = '';
              li.dataset.kind = value;
              li.appendChild(el('span', 'lo26-pick__n', `PORT ${n}`));
              const name = el('span', 'lo26-pick__name', option.name);
              name.appendChild(el('small', '', option.use));
              li.appendChild(name);
              const buy = el('span', 'lo26-pick__buy');
              const product = option.acc && accessories ? accessories[option.acc] : null;
              if (product && product.url) {
                const a = el('a', '', product.price ? `${value === 'dac' ? 'From ' : ''}${product.price}` : 'View');
                a.href = product.url;
                buy.appendChild(a);
              }
              li.appendChild(buy);
              if (option.speed) li.appendChild(el('span', 'lo26-pick__speed', option.speed));
            }
            ['cage', 'wire', 'end'].forEach((part) => {
              const node = $(`[data-lo26-${part}="${n}"]`);
              if (node) node.setAttribute('data-kind', value);
            });
            setText(`[data-lo26-end-v="${n}"]`, option.end);
          });
          const used = picks.filter((v) => v !== 'none').length;
          if (note) {
            note.textContent = used === 2
              ? 'Both ports run at the same time and share one Thunderbolt link. ServeTheHome measured 21–22 Gb/s on a single 25GbE port.'
              : 'The free port is ready for a second network whenever you need one.';
          }
          if (caption) caption.textContent = used === 2 ? 'Two networks, one Thunderbolt cable' : 'One port in use, one ready for later';
          $$('[data-lo26-preset]').forEach((button) => {
            button.classList.toggle('is-active', button.dataset.lo26Preset === picks.join(','));
          });
        };
        linkHost.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"]')) renderLinks();
        });
        $$('[data-lo26-preset]').forEach((button) => {
          button.addEventListener('click', () => {
            const [p1, p2] = button.dataset.lo26Preset.split(',');
            setLink(1, p1);
            setLink(2, p2);
            renderLinks();
          });
        });
        renderLinks();
      }

      /* ---------- Compatibility ---------- */
      const compat = $('[data-lo26-compat]');
      if (compat) {
        const hosts = {
          'mac-as': ['ok', 'Tested', 'Tested on Mac mini M4 and MacBook Pro.', 'ServeTheHome used LightOne with a Mac mini M4 and MacBook Pro M1 and M4, and measured 21–22 Gb/s on 25GbE.', 'Thunderbolt, 40 Gb/s', 'Both SFP28 ports', 'Up to 85 W for laptops'],
          'pc-tb': ['ok', 'Tested', 'Tested on an ASUS ROG NUC.', 'Windows PCs with Thunderbolt 3 or 4 connect at 40 Gb/s. ServeTheHome ran LightOne on an ASUS ROG NUC.', 'Thunderbolt 3 / 4, 40 Gb/s', 'Both SFP28 ports', 'Up to 85 W for laptops that charge over Thunderbolt'],
          'mac-intel': ['ok', 'Supported', 'A Thunderbolt 3 host.', 'LightOne is a Thunderbolt 3 device, so Intel Macs with Thunderbolt 3 ports connect at 40 Gb/s. Email us your model if you\'d like a check first.', 'Thunderbolt 3, 40 Gb/s', 'Both SFP28 ports', 'Up to 85 W for laptops'],
          'pc-usb4': ['slow', 'Check with us', 'Usually works. Let us confirm.', 'Many USB4 ports carry Thunderbolt 3 devices, but support varies by computer maker. Send us your model and we\'ll check before you order.', 'USB4, depends on the computer', 'Both SFP28 ports when connected', 'Depends on the computer'],
          usb: ['no', 'Not supported', 'LightOne needs Thunderbolt or USB4.', 'Its network ports use the PCIe connection that only Thunderbolt and USB4 ports provide. Standard USB-C and USB-A ports are not the right match.', 'Not available', 'Not available', 'Not available'],
        };
        const pill = $('[data-lo26-verdict-pill]');
        compat.addEventListener('change', (event) => {
          if (event.target.name !== 'lo26_host') return;
          const host = hosts[event.target.value];
          if (!host) return;
          if (pill) {
            pill.className = `lo26-pill lo26-pill--${host[0]}`;
            pill.textContent = host[1];
          }
          setText('[data-lo26-verdict-title]', host[2]);
          setText('[data-lo26-verdict-body]', host[3]);
          setText('[data-lo26-verdict-link]', host[4]);
          setText('[data-lo26-verdict-net]', host[5]);
          setText('[data-lo26-verdict-power]', host[6]);
        });
      }

      /* Long spec list starts collapsed on phones */
      const specs = $('.lo26-specs');
      if (specs && isPhone()) specs.open = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qd-pdp-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qd26]');
    roots.forEach((root) => {
      /* Effects are switched on here, by the script itself, so a slow or failed script load
         never leaves content hidden. Content already on screen is marked revealed first. */
      const motion = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (motion) {
        /* Split headlines into masked words, and the statement into words that light up. */
        const splitWords = (el, cls) => {
          let i = 0;
          const walk = (parent) => {
            Array.from(parent.childNodes).forEach((node) => {
              if (node.nodeType === 1) {
                if (!node.classList.contains('qd26-visually-hidden')) walk(node);
                return;
              }
              if (node.nodeType !== 3 || !node.textContent.trim()) return;
              const frag = document.createDocumentFragment();
              node.textContent.split(/([ \n\t]+)/).forEach((part) => {
                if (!part) return;
                if (/^[ \n\t]+$/.test(part)) {
                  frag.appendChild(document.createTextNode(' '));
                  return;
                }
                const word = document.createElement('span');
                if (cls === 'qd26-w') {
                  const inner = document.createElement('span');
                  inner.textContent = part;
                  inner.style.setProperty('--qd-i', String(i));
                  word.appendChild(inner);
                } else {
                  word.textContent = part;
                  word.style.setProperty('--qd-i', String(i));
                }
                word.className = cls;
                i += 1;
                frag.appendChild(word);
              });
              parent.replaceChild(frag, node);
            });
          };
          walk(el);
          return i;
        };
        root.querySelectorAll('h2.qd26-title:not(.qd26-visually-hidden)').forEach((h2) => {
          splitWords(h2, 'qd26-w');
          h2.classList.add('qd26-words');
          const host = h2.closest('[data-qd-reveal]');
          if (!host) return;
          host.classList.add('qd26-reveal-words');
          Array.from(h2.parentElement.children).forEach((child) => {
            if (child !== h2 && !child.classList.contains('qd26-eyebrow')) child.classList.add('qd26-follow');
          });
          if (h2.parentElement !== host) {
            Array.from(host.children).forEach((child) => {
              if (!child.contains(h2)) child.classList.add('qd26-follow');
            });
          }
        });
        const statementText = root.querySelector('[data-qd26-statement-text]');
        if (statementText) {
          statementText.style.setProperty('--qd-n', String(splitWords(statementText, 'qd26-sw')));
          /* Each marked phrase draws its rule while its own words light up. */
          statementText.querySelectorAll('mark').forEach((mark) => {
            const words = mark.querySelectorAll('.qd26-sw');
            if (!words.length) return;
            mark.style.setProperty('--qd-is', words[0].style.getPropertyValue('--qd-i'));
            mark.style.setProperty('--qd-ml', String(words.length));
          });
        }
        root.querySelectorAll('.qd26-ticks > .qd26-frame').forEach((frame) => frame.classList.add('qd26-media'));
        root.querySelectorAll('[data-qd-reveal]').forEach((node) => {
          if (node.getBoundingClientRect().top < window.innerHeight) {
            node.classList.add('is-in');
            node.dataset.qdSeen = '1';
          }
        });
        const poster = root.querySelector('[data-qd26-seq-poster]');
        if (poster && poster.dataset.qd26SeqStart) poster.src = poster.dataset.qd26SeqStart;
        root.classList.add('qd26-motion');
      }
      root.setAttribute('data-qd26-ready', '');
      const read = (selector) => {
        const node = root.querySelector(selector);
        try {
          return node ? JSON.parse(node.textContent) : [];
        } catch (error) {
          return [];
        }
      };
      const variants = read('[data-qd26-variants]');
      const frames = read('[data-qd26-build-frames]');
      const seqFramesDesktop = read('[data-qd26-seq-frames]');
      const seqFramesPhone = read('[data-qd26-seq-frames-phone]');
      const $ = (selector) => root.querySelector(selector);
      const $$ = (selector) => Array.from(root.querySelectorAll(selector));
      const setText = (selector, text) => $$(selector).forEach((node) => { node.textContent = text; });
      const clamp = (v, min = 0, max = 1) => Math.min(max, Math.max(min, v));
      const isPhone = () => window.matchMedia('(max-width: 900px)').matches;
      const seqFrames = isPhone() && seqFramesPhone.length ? seqFramesPhone : seqFramesDesktop;

      /* ---------- Variant selection ---------- */
      const idInput = $('[data-qd26-variant-id]');
      const submit = root.querySelector('.product-form__submit');
      const updateVariant = (id) => {
        const variant = variants.find((item) => String(item.id) === String(id));
        if (!variant) return;
        if (idInput) {
          idInput.value = variant.id;
          idInput.disabled = !variant.available;
        }
        setText('[data-qd26-price]', variant.price);
        setText('[data-qd26-sticky-price]', variant.price);
        setText('[data-qd26-final-price]', variant.price);
        setText('[data-qd26-finish-name]', variant.name);
        setText('[data-qd26-sticky-finish]', variant.name);
        setText('[data-qd26-final-finish]', variant.name);
        const compare = $('[data-qd26-compare]');
        const save = $('[data-qd26-save]');
        if (compare) {
          compare.textContent = variant.compare || '';
          compare.classList.toggle('is-hidden', !variant.compare);
        }
        if (save) {
          save.textContent = variant.save ? `Save ${variant.save}` : '';
          save.classList.toggle('is-hidden', !variant.save);
        }
        const swatch = $('[data-qd26-sticky-swatch]');
        if (swatch) swatch.className = `qd26-swatch qd26-swatch--${variant.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
        const atcText = $('[data-qd26-atc-text]');
        if (atcText) atcText.textContent = variant.available ? 'Buy now' : 'Sold out';
        if (submit) submit.toggleAttribute('disabled', !variant.available);
        $$('[data-qd26-alt-atc]').forEach((button) => button.toggleAttribute('disabled', !variant.available));
        const stock = $('[data-qd26-stock]');
        if (stock) {
          stock.innerHTML = variant.available
            ? '<span class="qd26-stock__dot" aria-hidden="true"></span> In stock, ships now. Delivery estimate at checkout.'
            : '<span class="qd26-stock__dot is-out" aria-hidden="true"></span> This finish is sold out.';
        }
        const payLater = root.querySelector('[data-paypal-pay-later-message]');
        if (payLater) payLater.setAttribute('data-pp-amount', variant.price_amount);
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (error) {
          /* URL updates are a convenience only */
        }
      };
      $$('[data-qd26-variant-option]').forEach((input) => {
        input.addEventListener('change', () => updateVariant(input.value));
      });

      /* ---------- Quantity ---------- */
      const qty = root.querySelector('input[name="quantity"]');
      $$('[data-qd26-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!qty) return;
          qty.value = Math.min(20, Math.max(1, (parseInt(qty.value, 10) || 1) + Number(button.dataset.qd26Qty)));
        });
      });

      /* ---------- Buy now: add, then straight to checkout ---------- */
      // Same flow as the Explorer: the cart page lost visitors between add and checkout. If the
      // finish is already in the cart its quantity is set to the chosen amount instead of adding
      // more, so checkout shows exactly what the shopper picked here.
      const buyForm = root.querySelector('product-form');
      const buyError = root.querySelector('.qd26-form__error');
      const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cartUrl = (window.routes && window.routes.cart_url) || `${shopRoot}cart`;
      const addUrl = (window.routes && window.routes.cart_add_url) || `${shopRoot}cart/add`;
      const changeUrl = (window.routes && window.routes.cart_change_url) || `${shopRoot}cart/change`;
      let buying = false;
      const showBuyError = (message) => {
        if (!buyError) return;
        buyError.hidden = !message;
        const text = buyError.querySelector('.product-form__error-message');
        if (text) text.textContent = message || '';
      };
      const setBuying = (busy) => {
        buying = busy;
        if (!submit) return;
        submit.classList.toggle('loading', busy);
        submit.toggleAttribute('aria-disabled', busy);
        const spinner = submit.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !busy);
      };
      const cartRequest = async (url, body) => {
        const response = await fetch(url, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest', ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json' }) },
          body: body instanceof FormData ? body : JSON.stringify(body),
          credentials: 'same-origin',
        });
        const json = await response.json().catch(() => ({}));
        if (!response.ok || json.status) throw new Error(json.description || json.message || 'QuadDrive could not be added. Please try again.');
      };
      if (buyForm) {
        // Capture phase on <product-form> runs before the theme's product-form.js listener on the form
        // and keeps it from sending the shopper to the cart page.
        buyForm.addEventListener('submit', async (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (buying || !idInput || idInput.disabled) return;
          setBuying(true);
          showBuyError('');
          const data = new FormData(event.target);
          data.delete('return_to');
          const variantId = String(data.get('id'));
          const quantity = Math.min(20, Math.max(1, parseInt(data.get('quantity'), 10) || 1));
          try {
            const cart = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
              .then((response) => response.json())
              .catch(() => null);
            const line = cart && Array.isArray(cart.items) ? cart.items.find((item) => String(item.variant_id) === variantId) : null;
            if (!line) await cartRequest(addUrl, data);
            else if (line.quantity !== quantity) await cartRequest(`${changeUrl}.js`, { id: line.key, quantity });
            window.location.href = `${shopRoot}checkout`;
          } catch (error) {
            showBuyError(error.message || 'Something went wrong. Please try again.');
            setBuying(false);
          }
        }, true);
        // Coming back from checkout restores the page from cache with the button still busy.
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) setBuying(false);
        });
      }

      /* ---------- Gallery ---------- */
      const track = $('[data-qd26-track]');
      const thumbs = $$('[data-qd26-thumb]');
      if (track) {
        const slides = Array.from(track.children);
        const goTo = (index) => {
          const clamped = (index + slides.length) % slides.length;
          track.scrollTo({ left: slides[clamped].offsetLeft, behavior: 'smooth' });
        };
        const current = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        const markActive = () => {
          const index = current();
          thumbs.forEach((thumb, i) => {
            thumb.classList.toggle('is-active', i === index);
            if (i === index) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
        };
        let ticking = false;
        track.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => {
            markActive();
            ticking = false;
          });
        }, { passive: true });
        thumbs.forEach((thumb) => thumb.addEventListener('click', () => goTo(Number(thumb.dataset.qd26Thumb))));
        const prev = $('[data-qd26-prev]');
        const next = $('[data-qd26-next]');
        if (prev) prev.addEventListener('click', () => goTo(current() - 1));
        if (next) next.addEventListener('click', () => goTo(current() + 1));
        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            goTo(current() + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goTo(current() - 1);
          }
        });
      }

      /* ---------- Count-up numbers ---------- */
      const countUp = (node) => {
        if (node.dataset.qdCounted) return;
        node.dataset.qdCounted = '1';
        const target = Number(node.dataset.qdCount);
        if (!motion || !Number.isFinite(target)) return;
        const fmt = (v) => Math.round(v).toLocaleString('en-US');
        const start = performance.now();
        const duration = target > 999 ? 1400 : 900;
        const step = (now) => {
          const t = clamp((now - start) / duration);
          node.textContent = fmt(target * (1 - Math.pow(1 - t, 3)));
          if (t < 1) window.requestAnimationFrame(step);
        };
        node.textContent = '0';
        window.requestAnimationFrame(step);
      };

      /* ---------- Reveal on scroll ---------- */
      $$('[data-qd-stagger]').forEach((group) => {
        Array.from(group.children).forEach((child, i) => child.style.setProperty('--qd-d', `${i * 90}ms`));
      });
      const reveal = (node) => {
        node.classList.add('is-in');
        node.querySelectorAll('[data-qd-count]').forEach(countUp);
        /* Drop stagger delays once the entrance is over so hover effects respond at once. */
        if (node.hasAttribute('data-qd-stagger')) {
          window.setTimeout(() => {
            Array.from(node.children).forEach((child) => child.style.setProperty('--qd-d', '0ms'));
          }, 1600);
        }
      };
      if (motion && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal(entry.target);
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
        $$('[data-qd-reveal]').forEach((node) => {
          if (!node.dataset.qdSeen) io.observe(node);
        });
        $$('.qd26-media').forEach((node) => {
          if (node.getBoundingClientRect().top < window.innerHeight) node.classList.add('is-in');
          else io.observe(node);
        });
      } else {
        $$('[data-qd-reveal]').forEach(reveal);
        $$('.qd26-media').forEach((node) => node.classList.add('is-in'));
      }

      /* ---------- Feature list highlight ---------- */
      const features = $$('[data-qd26-features] li');
      if (motion && features.length && 'IntersectionObserver' in window) {
        const fio = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.target.classList.toggle('is-active', entry.isIntersecting));
        }, { rootMargin: '-38% 0px -38% 0px' });
        features.forEach((li) => fio.observe(li));
      }

      /* ---------- Pinned assembly sequence ---------- */
      const seq = $('[data-qd26-seq]');
      const canvas = $('[data-qd26-seq-canvas]');
      const ctx = canvas ? canvas.getContext('2d') : null;
      /* Frames come from the 120 fps master render. Every frame is fetched once as a compressed
         blob; only frames near the current position are decoded to ImageBitmaps (rolling cache),
         so drawing never decodes and memory stays bounded. shown eases toward target. */
      const seqState = { blobs: [], frames: [], pending: new Set(), started: false, drawn: -1, target: 0, shown: 0, dir: 1, cssWidth: 0 };
      if (seq) seq.__qd26 = seqState;
      const keys = (() => {
        try {
          return JSON.parse(seq ? seq.getAttribute('data-qd26-seq-keys') : '{}') || {};
        } catch (error) {
          return {};
        }
      })();
      const last = seqFrames.length - 1;
      const K = {
        empty: keys.empty || 0,
        d1: keys.d1 || 0,
        d2: keys.d2 || 0,
        d3: keys.d3 || 0,
        d4: keys.d4 || 0,
        lidStart: keys.lidStart || 0,
        lid: keys.lid || last,
        sealed: keys.sealed || last,
      };
      const beats = $$('[data-qd-beat]');
      const hudBays = $('[data-qd26-hud-bays]');
      const hudMode = $('[data-qd26-hud-mode]');
      const rail = $('[data-qd26-rail]');
      const baysAt = (i) => (i >= K.d4 ? 4 : i >= K.d3 ? 3 : i >= K.d2 ? 2 : i >= K.d1 ? 1 : 0);
      /* Scroll progress -> frame. Each SSD gets an unhurried slide and a short rest; the lid
         closes over a short stretch so it lands crisply; the screws follow quickly. */
      const curve = [
        [0, K.empty], [0.05, K.empty],
        [0.17, K.d1], [0.2, K.d1],
        [0.28, K.d2], [0.31, K.d2],
        [0.4, K.d3], [0.43, K.d3],
        [0.51, K.d4], [0.61, K.d4],
        [0.62, K.lidStart], [0.66, K.lid], [0.68, K.lid],
        [0.8, K.sealed], [1, K.sealed],
      ];
      const frameAt = (p) => {
        for (let k = 1; k < curve.length; k += 1) {
          const [p0, f0] = curve[k - 1];
          const [p1, f1] = curve[k];
          if (p <= p1) return Math.round(f0 + (f1 - f0) * (p1 === p0 ? 1 : (p - p0) / (p1 - p0)));
        }
        return curve[curve.length - 1][1];
      };
      const beatAt = (p) => (p >= 0.62 ? 4 : p >= 0.43 ? 3 : p >= 0.28 ? 2 : p >= 0.05 ? 1 : 0);

      const nearestReady = (index) => {
        for (let d = 0; d <= last; d += 1) {
          if (seqState.frames[index - d]) return index - d;
          if (seqState.frames[index + d]) return index + d;
        }
        return -1;
      };

      const paint = (index) => {
        if (!ctx || !seqState.started) return;
        const pick = nearestReady(index);
        if (pick < 0 || pick === seqState.drawn) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(seqState.frames[pick], 0, 0, canvas.width, canvas.height);
        seqState.drawn = pick;
        if (!seq.classList.contains('is-live')) seq.classList.add('is-live');
      };

      /* Rolling decode cache */
      const cacheMax = isPhone() ? 22 : 34;
      const decodeQueue = [];
      let decoding = 0;
      const decodeBlob = (blob) => {
        if ('createImageBitmap' in window) {
          const opts = canvas.width ? { resizeWidth: Math.min(canvas.width, 1000), resizeQuality: 'high' } : undefined;
          return createImageBitmap(blob, opts).catch(() => createImageBitmap(blob));
        }
        const img = new Image();
        img.src = URL.createObjectURL(blob);
        return img.decode().then(() => img);
      };
      const evict = () => {
        const held = [];
        seqState.frames.forEach((frame, i) => {
          if (frame) held.push(i);
        });
        if (held.length <= cacheMax) return;
        const center = seqState.shown;
        held.sort((a, b) => Math.abs(b - center) - Math.abs(a - center));
        held.slice(0, held.length - cacheMax).forEach((i) => {
          if (Math.abs(i - center) <= 4) return;
          const frame = seqState.frames[i];
          if (frame && frame.close) frame.close();
          seqState.frames[i] = null;
        });
      };
      const pump = () => {
        while (decoding < 2 && decodeQueue.length) {
          const i = decodeQueue.shift();
          if (seqState.frames[i] || seqState.pending.has(i) || !seqState.blobs[i]) continue;
          decoding += 1;
          seqState.pending.add(i);
          decodeBlob(seqState.blobs[i])
            .then((frame) => {
              seqState.frames[i] = frame;
              if (Math.abs(i - seqState.shown) <= 2 || seqState.drawn < 0) {
                seqState.drawn = -1;
                paint(Math.round(seqState.shown));
              }
              evict();
            })
            .catch(() => {})
            .then(() => {
              decoding -= 1;
              seqState.pending.delete(i);
              pump();
            });
        }
      };
      /* Decode around the current frame, mostly ahead in the scroll direction. */
      const schedule = () => {
        if (!seqState.started) return;
        const center = Math.round(seqState.shown);
        const ahead = isPhone() ? 12 : 18;
        const behind = 5;
        decodeQueue.length = 0;
        for (let k = 0; k <= ahead; k += 1) {
          const forward = center + seqState.dir * k;
          if (forward >= 0 && forward <= last && !seqState.frames[forward]) decodeQueue.push(forward);
          if (k > 0 && k <= behind) {
            const back = center - seqState.dir * k;
            if (back >= 0 && back <= last && !seqState.frames[back]) decodeQueue.push(back);
          }
        }
        pump();
      };

      let easing = false;
      const ease = () => {
        const diff = seqState.target - seqState.shown;
        seqState.shown = Math.abs(diff) < 0.04 ? seqState.target : seqState.shown + diff * 0.25;
        paint(Math.round(seqState.shown));
        schedule();
        if (seqState.shown !== seqState.target) window.requestAnimationFrame(ease);
        else easing = false;
      };
      const kick = () => {
        if (easing) return;
        easing = true;
        window.requestAnimationFrame(ease);
      };

      /* Size the canvas only when its width changes, so the phone address bar showing or
         hiding (a height-only resize) never clears and rebuilds it mid-scroll. */
      const sizeCanvas = (force) => {
        if (!canvas) return;
        const width = canvas.clientWidth;
        if (!width || (!force && Math.abs(width - seqState.cssWidth) < 2)) return;
        seqState.cssWidth = width;
        const dpr = Math.min(window.devicePixelRatio || 1, isPhone() ? 1.75 : 2);
        canvas.width = Math.round(width * dpr);
        canvas.height = Math.round(canvas.clientHeight * dpr);
        seqState.drawn = -1;
        paint(Math.round(seqState.shown));
      };

      /* Download order: resting states first, then fill gaps by halving, so coverage is even
         early. Phones and Save-Data skip every other in-between frame. */
      /* Resting states first, nearest to where the visitor is now (someone who lands mid-sequence
         sees the right frame first), then the in-between frames by halving. */
      const loadOrder = () => {
        const here = seqState.target;
        const order = [K.empty, K.d1, K.d2, K.d3, K.d4, K.lidStart, K.lid, K.sealed]
          .filter((k, i, all) => all.indexOf(k) === i)
          .sort((a, b) => Math.abs(a - here) - Math.abs(b - here));
        const seen = new Set(order);
        const lean = isPhone() || (navigator.connection && navigator.connection.saveData);
        let step = 32;
        while (step >= (lean ? 2 : 1)) {
          for (let i = 0; i <= last; i += step) {
            if (!seen.has(i)) {
              seen.add(i);
              order.push(i);
            }
          }
          step = Math.floor(step / 2);
        }
        return order;
      };

      const startSeq = () => {
        if (seqState.started || !canvas || !seqFrames.length) return;
        seqState.started = true;
        sizeCanvas(true);
        let order = [];
        let cursor = 0;
        // fetch() sends a wildcard Accept header by default, and the Shopify CDN then answers
        // with PNG (about 8x larger). Ask for WebP explicitly, as an <img> request would.
        const accept = { headers: { Accept: 'image/webp,image/*;q=0.8' } };
        const fetchNext = () => {
          if (cursor >= order.length) return;
          const i = order[cursor];
          cursor += 1;
          fetch(seqFrames[i], accept)
            .then((response) => (response.ok ? response.blob() : null))
            .then((blob) => {
              if (!blob) return;
              seqState.blobs[i] = blob;
              if (seqState.drawn < 0 || Math.abs(i - seqState.shown) <= 20) schedule();
            })
            .catch(() => {})
            .then(fetchNext);
        };
        /* Wait one frame so the scroll handler has set the current target before ordering. */
        window.requestAnimationFrame(() => {
          order = loadOrder();
          for (let k = 0; k < 4; k += 1) fetchNext();
        });
      };

      let lastBeat = -1;
      let lastBays = -1;
      let lastRail = -1;
      /* Called with layout values already read in onFrame; only writes here. */
      const updateSeq = (rectTop, rectHeight, vh) => {
        const p = clamp(-rectTop / Math.max(1, rectHeight - vh));
        const target = Math.min(last, frameAt(p));
        if (target !== seqState.target) seqState.dir = target > seqState.target ? 1 : -1;
        seqState.target = target;
        kick();
        const beat = beatAt(p);
        if (beat !== lastBeat) {
          lastBeat = beat;
          beats.forEach((node, i) => node.classList.toggle('is-active', i === beat));
        }
        const bays = baysAt(seqState.target);
        if (bays !== lastBays) {
          lastBays = bays;
          if (hudBays) hudBays.textContent = `${bays}/4`;
          if (hudMode) hudMode.textContent = bays ? `${bays * 8} TB` : '—';
        }
        const railP = Math.round(p * 500) / 500;
        if (rail && railP !== lastRail) {
          lastRail = railP;
          rail.style.transform = `scaleX(${railP})`;
        }
      };

      /* Frames load only after the page itself has loaded and the visitor starts scrolling
         (or the sequence is close), so visitors who never scroll never download them. */
      if (seq && motion) {
        let pageLoaded = document.readyState === 'complete';
        let wanted = false;
        const tryStart = () => {
          if (pageLoaded && wanted) startSeq();
        };
        const want = () => {
          wanted = true;
          tryStart();
        };
        if (!pageLoaded) {
          window.addEventListener('load', () => {
            pageLoaded = true;
            tryStart();
          }, { once: true });
          /* Some third-party scripts hold up the load event for a long time. */
          window.setTimeout(() => {
            pageLoaded = true;
            tryStart();
          }, 6000);
        }
        const onFirstScroll = () => {
          if (window.scrollY > 120) {
            window.removeEventListener('scroll', onFirstScroll);
            want();
          }
        };
        window.addEventListener('scroll', onFirstScroll, { passive: true });
        if ('IntersectionObserver' in window) {
          /* Reaching the sequence itself starts loading at once, even if the page load event is late. */
          const sio = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              startSeq();
              sio.disconnect();
            }
          }, { rootMargin: '0px 0px 25% 0px' });
          sio.observe(seq);
        } else {
          want();
        }
      }

      /* ---------- Film ---------- */
      const film = $('[data-qd26-film]');
      const filmVideo = $('[data-qd26-film-video]');
      const filmPlay = $('[data-qd26-film-play]');
      if (film && filmVideo && filmPlay) {
        /* Pause once the film has been watched on screen and is then scrolled away. */
        let filmSeen = false;
        /* The poster stays up, with a spinner in the button, until the first frame plays. */
        const startFilm = () => {
          filmSeen = false;
          film.classList.add('is-loading');
          const run = filmVideo.play();
          if (run && run.catch) run.catch(() => film.classList.remove('is-loading'));
        };
        filmPlay.addEventListener('click', startFilm);
        filmVideo.addEventListener('playing', () => {
          film.classList.remove('is-loading');
          film.classList.add('is-playing');
          filmVideo.controls = true;
        });
        filmVideo.addEventListener('error', () => film.classList.remove('is-loading'), true);
        filmVideo.addEventListener('ended', () => {
          film.classList.remove('is-playing');
          filmVideo.controls = false;
        });
        $$('[data-qd26-film-open]').forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            startFilm();
            film.scrollIntoView({ behavior: motion ? 'smooth' : 'auto', block: 'center' });
          });
        });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) filmSeen = true;
              else if (filmSeen && !filmVideo.paused) filmVideo.pause();
            });
          }, { threshold: 0.2 }).observe(filmVideo);
        }
      }

      /* ---------- Scroll-linked effects ---------- */
      const zoom = $('[data-qd26-zoom]');
      const marquee = $('[data-qd26-marquee]');
      const marqueeHost = $('[data-qd26-marquee-host]');
      const parallax = $('[data-qd26-parallax]');
      const wordmark = $('[data-qd26-wordmark]');
      const statement = $('[data-qd26-statement-text]');
      const path = $('[data-qd26-path]');
      const pathSteps = path ? Array.from(path.querySelectorAll('.qd26-step')) : [];
      let lastSteps = '';
      /* Phones stack the path in two rows, so each step lights when it reaches the screen;
         wider screens light the single row in sequence with the line. */
      let pathRows = isPhone();
      const details = $('[data-qd26-details]');
      const detailsTrack = $('[data-qd26-details-track]');
      const panels = detailsTrack ? Array.from(detailsTrack.children) : [];
      const detailsN = $('[data-qd26-details-n]');
      let detailsTravel = 0;
      let panelCenters = [];
      let lastPanel = -1;
      let lastStatement = -1;
      /* Horizontal travel of the Details track; the section is made that much taller than the
         viewport so vertical scrolling drives it. */
      const measureDetails = () => {
        if (!motion || !details || !detailsTrack) return;
        detailsTravel = Math.max(0, detailsTrack.offsetWidth - document.documentElement.clientWidth);
        panelCenters = panels.map((panel) => panel.offsetLeft + panel.offsetWidth / 2);
        details.style.setProperty('--qd-gt', `${Math.round(detailsTravel)}px`);
      };
      measureDetails();
      const progress = $('[data-qd26-progress]');
      const sticky = $('[data-qd26-sticky]');
      const buybox = $('[data-qd26-buybox]');
      const final = $('[data-qd26-final]');
      const actions = buybox ? buybox.querySelector('.qd26-actions') || buybox : null;
      let shown = null;
      let queued = false;
      let docHeight = document.documentElement.scrollHeight;
      let marqueeTravel = marquee ? Math.max(0, marquee.scrollWidth - window.innerWidth * 0.6) : 0;
      const remeasure = () => {
        measureDetails();
        pathRows = isPhone();
        docHeight = document.documentElement.scrollHeight;
        marqueeTravel = marquee ? Math.max(0, marquee.scrollWidth - window.innerWidth * 0.6) : 0;
      };
      const visible = (r, vh) => r.bottom > -vh * 0.25 && r.top < vh * 1.25;
      const span = (r, vh) => clamp((vh - r.top) / (vh + r.height));

      /* Read every rectangle first, then write, so no write forces a second layout. */
      const onFrame = () => {
        queued = false;
        const vh = window.innerHeight;
        const scrollY = window.scrollY;
        const rSeq = motion && seq ? seq.getBoundingClientRect() : null;
        const rZoom = motion && zoom ? zoom.getBoundingClientRect() : null;
        const rMarquee = motion && marquee && marqueeHost ? marqueeHost.getBoundingClientRect() : null;
        const rParallax = motion && parallax ? parallax.parentElement.getBoundingClientRect() : null;
        const rWord = motion && wordmark ? wordmark.getBoundingClientRect() : null;
        const rStatement = motion && statement ? statement.getBoundingClientRect() : null;
        const rPath = motion && path ? path.getBoundingClientRect() : null;
        const stepTops = rPath && pathRows ? pathSteps.map((step) => step.getBoundingClientRect().top) : null;
        const rDetails = motion && details && detailsTrack ? details.getBoundingClientRect() : null;
        const vw = window.innerWidth;
        const rActions = sticky && actions ? actions.getBoundingClientRect() : null;
        const rFinal = sticky && final ? final.getBoundingClientRect() : null;

        if (rSeq && visible(rSeq, vh)) updateSeq(rSeq.top, rSeq.height, vh);
        if (rZoom && visible(rZoom, vh)) zoom.style.setProperty('--qd-zoom', (1.18 - 0.18 * clamp(span(rZoom, vh) * 1.6)).toFixed(4));
        if (rMarquee && visible(rMarquee, vh)) marquee.style.setProperty('--qd-x', `${(-span(rMarquee, vh) * marqueeTravel).toFixed(1)}px`);
        if (rParallax && visible(rParallax, vh)) parallax.style.setProperty('--qd-y', `${((span(rParallax, vh) - 0.5) * -90).toFixed(1)}px`);
        if (rWord && visible(rWord, vh)) wordmark.style.setProperty('--qd-wmy', `${(20 + span(rWord, vh) * 60).toFixed(1)}%`);
        if (rStatement && visible(rStatement, vh)) {
          const sp = Math.round(clamp((vh * 0.82 - rStatement.top) / (rStatement.height + vh * 0.42)) * 400) / 400;
          if (sp !== lastStatement) {
            lastStatement = sp;
            statement.style.setProperty('--qd-p', String(sp));
          }
        }
        if (rPath && visible(rPath, vh)) {
          const pp = clamp((vh * 0.8 - rPath.top) / (rPath.height + vh * 0.15));
          path.style.setProperty('--qd-pathp', pp.toFixed(3));
          const lit = rPath.top < vh * 0.8 ? Math.min(pathSteps.length - 1, Math.floor(pp * pathSteps.length)) : -1;
          const states = pathSteps.map((step, i) => (stepTops ? stepTops[i] < vh * 0.82 : i <= lit));
          const key = states.join();
          if (key !== lastSteps) {
            lastSteps = key;
            pathSteps.forEach((step, i) => {
              if (states[i] && !step.classList.contains('is-on')) step.querySelectorAll('[data-qd-count]').forEach(countUp);
              step.classList.toggle('is-on', states[i]);
            });
          }
        }
        if (rDetails && visible(rDetails, vh)) {
          const gp = clamp(-rDetails.top / Math.max(1, rDetails.height - vh));
          const gx = -gp * detailsTravel;
          details.style.setProperty('--qd-gx', `${gx.toFixed(1)}px`);
          details.style.setProperty('--qd-gp', gp.toFixed(4));
          panels.forEach((panel, i) => {
            panel.style.setProperty('--qd-pp', clamp((panelCenters[i] + gx - vw / 2) / vw, -1, 1).toFixed(3));
          });
          const active = Math.round(gp * (panels.length - 1));
          if (active !== lastPanel) {
            lastPanel = active;
            panels.forEach((panel, i) => panel.classList.toggle('is-active', i === active));
            if (detailsN) detailsN.textContent = String(active + 1).padStart(2, '0');
          }
        }
        if (progress) progress.style.setProperty('--qd-p', clamp(scrollY / Math.max(1, docHeight - vh)).toFixed(4));
        if (rActions) {
          const show = rActions.bottom < 0 && !(rFinal && rFinal.top < vh * 0.8);
          if (show !== shown) {
            shown = show;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', String(!show));
            sticky.querySelectorAll('a, button').forEach((node) => node.setAttribute('tabindex', show ? '0' : '-1'));
          }
        }
      };
      const queue = () => {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(onFrame);
      };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', () => {
        sizeCanvas(false);
        remeasure();
        queue();
      }, { passive: true });
      window.addEventListener('load', () => {
        remeasure();
        queue();
      }, { once: true });
      /* Opening the spec list or an FAQ answer changes the page height. */
      root.addEventListener('toggle', () => {
        remeasure();
        queue();
      }, true);
      onFrame();

      /* ---------- Cursor spotlight on cards (mouse / trackpad only) ---------- */
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        let spotEvent = null;
        let spotQueued = false;
        root.addEventListener('pointermove', (event) => {
          spotEvent = event;
          if (spotQueued) return;
          spotQueued = true;
          window.requestAnimationFrame(() => {
            spotQueued = false;
            const card = spotEvent.target.closest && spotEvent.target.closest('[data-qd-spot]');
            if (!card) return;
            const r = card.getBoundingClientRect();
            card.style.setProperty('--mx', `${Math.round(spotEvent.clientX - r.left)}px`);
            card.style.setProperty('--my', `${Math.round(spotEvent.clientY - r.top)}px`);
          });
        }, { passive: true });
      }

      /* ---------- Build planner ---------- */
      const build = $('[data-qd26-build]');
      if (build) {
        const img = $('[data-qd26-build-img]');
        const caption = $('[data-qd26-build-caption]');
        const hint = $('[data-qd26-mode-hint]');
        const radios = (name) => $$(`input[name="${name}"]`);
        const value = (name) => (radios(name).find((input) => input.checked) || {}).value;
        const check = (name, val) => radios(name).forEach((input) => { input.checked = input.value === String(val); });
        const modeInput = (val) => radios('qd26_mode').find((input) => input.value === val);
        let preloaded = false;
        const preload = () => {
          if (preloaded) return;
          preloaded = true;
          frames.forEach((src) => { const image = new Image(); image.src = src; });
        };
        const fmt = (tb) => `${tb % 1 ? tb.toFixed(1) : tb} TB`;
        const allowed = (mode, n) => (mode === 'raid0' ? n >= 2 : mode === 'mirror' ? n === 2 || n === 4 : mode === 'parity' ? n >= 3 : true);

        const render = () => {
          const drives = Number(value('qd26_drives') || 4);
          const size = Number(value('qd26_size') || 4);
          ['raid0', 'mirror', 'parity'].forEach((mode) => {
            const input = modeInput(mode);
            if (input) input.disabled = !allowed(mode, drives);
          });
          let mode = value('qd26_mode') || 'jbod';
          let note = '';
          if (!allowed(mode, drives)) {
            note = mode === 'raid0' ? 'RAID 0 needs at least two SSDs.' : mode === 'mirror' ? 'Mirroring needs two SSDs (RAID 1) or four (RAID 10 / 01).' : 'RAID 5 needs at least three SSDs; RAID 6 needs four.';
            mode = 'jbod';
            check('qd26_mode', 'jbod');
          } else if (drives === 1) {
            note = 'Add a second SSD to unlock RAID.';
          } else if (drives === 3 && mode !== 'parity') {
            note = 'With three SSDs: RAID 0 or RAID 5. Mirroring needs two or four.';
          }
          if (hint) {
            hint.textContent = note;
            hint.hidden = !note;
          }

          const raw = drives * size;
          let usable = raw;
          let volumes = String(drives);
          let speed = 'Each SSD is its own drive. Add, remove or swap one without touching the others.';
          let protect = 'No redundancy. Keep a backup of anything important.';
          let tools = 'No setup needed on macOS, Windows or Linux. Works on USB 3.x too.';
          if (mode === 'raid0') {
            volumes = '1';
            speed = `One volume across ${drives} SSDs, read and written in parallel. It needs every SSD present to work.`;
            protect = 'No redundancy: if one SSD fails, the volume is lost. Pair it with a backup.';
            tools = 'macOS Disk Utility, Windows Storage Spaces, Linux mdadm or RAID software.';
          } else if (mode === 'mirror') {
            volumes = '1';
            usable = raw / 2;
            speed = drives === 4 ? 'RAID 10 / 01: mirrored pairs striped together, so reads and writes still use several SSDs at once.' : 'RAID 1: every file is written to both SSDs.';
            protect = drives === 4 ? 'Keeps working if one SSD in each pair fails.' : 'Keeps working if either SSD fails.';
            tools = drives === 4 ? 'Windows Storage Spaces, Linux mdadm or RAID software.' : 'macOS Disk Utility, Windows, Linux or RAID software.';
          } else if (mode === 'parity') {
            volumes = '1';
            usable = (drives - 1) * size;
            speed = 'RAID 5: data and parity striped across all SSDs. Write speed depends on your RAID software.';
            protect = drives === 4
              ? `Survives one SSD failure. RAID 6 survives two, with ${fmt((drives - 2) * size)} usable.`
              : 'Survives one SSD failure.';
            tools = 'Windows Storage Spaces, Linux mdadm or RAID software on macOS.';
          }

          setText('[data-qd26-usable]', fmt(usable));
          setText('[data-qd26-raw]', fmt(raw));
          setText('[data-qd26-volumes]', volumes);
          setText('[data-qd26-speed]', speed);
          setText('[data-qd26-protect]', protect);
          setText('[data-qd26-tools]', `Set up with: ${tools}`);
          if (img && frames[drives]) {
            img.src = frames[drives];
            img.alt = `QuadDrive with ${drives} SSD${drives > 1 ? 's' : ''} installed`;
          }
          if (caption) caption.textContent = `${drives} of 4 bays filled`;
          $$('[data-qd26-preset]').forEach((button) => {
            button.classList.toggle('is-active', button.dataset.qd26Preset === `${drives},${size},${mode}`);
          });
        };

        build.addEventListener('change', (event) => {
          if (event.target.matches('input[type="radio"]')) {
            preload();
            render();
          }
        });
        $$('[data-qd26-preset]').forEach((button) => {
          button.addEventListener('click', () => {
            const [drives, size, mode] = button.dataset.qd26Preset.split(',');
            check('qd26_drives', drives);
            check('qd26_size', size);
            preload();
            render();
            check('qd26_mode', mode);
            render();
          });
        });
        render();
      }

      /* ---------- Compatibility ---------- */
      const compat = $('[data-qd26-compat]');
      if (compat) {
        const hosts = {
          'mac-as': ['ok', 'Full speed', '40 Gbps, tested.', 'Apple silicon Macs run QuadDrive at 40 Gbps on their Thunderbolt / USB4 ports, with RAID set up in Disk Utility or RAID software.', 'USB4 / Thunderbolt, 40 Gbps', 'All four', 'Available'],
          'mac-intel': ['ok', 'Full speed', '40 Gbps on Thunderbolt 3.', 'Intel Macs with 8th or 9th gen processors and Thunderbolt 3 were tested at 40 Gbps.', 'Thunderbolt 3, 40 Gbps', 'All four', 'Available'],
          'pc-intel': ['ok', 'Full speed', '40 Gbps on Thunderbolt or USB4.', 'Intel 12th to 15th gen platforms with a Thunderbolt or USB4 port were tested at 40 Gbps.', 'Thunderbolt 4 / USB4, 40 Gbps', 'All four', 'Available'],
          'pc-amd': ['ok', 'Full speed', '40 Gbps on USB4.', 'AMD Ryzen 8000 and 9000 series desktops and laptops with a USB4 port were tested at 40 Gbps.', 'USB4, 40 Gbps', 'All four', 'Available'],
          'pc-intel-1011': ['no', 'Not supported at high speed', 'Choose a newer computer for full speed.', 'The high-speed USB-C connection is not supported on Intel 10th and 11th gen platforms. QuadDrive is not the right match for these computers.', 'High-speed link not supported', 'Not supported', 'Not available'],
          usb: ['slow', 'Works, slower', 'Runs at your port\'s USB speed.', 'Without Thunderbolt or USB4, QuadDrive falls back to USB 3.2 Gen 2x2 (20 Gbps), Gen 2 (10 Gbps), Gen 1 (5 Gbps) or USB 2.0. All four SSDs still show up as separate drives.', 'USB 3.2 / 2.0, up to 20 Gbps', 'All four, as separate drives', 'Not available on USB'],
        };
        const pill = $('[data-qd26-verdict-pill]');
        compat.addEventListener('change', (event) => {
          if (event.target.name !== 'qd26_host') return;
          const host = hosts[event.target.value];
          if (!host) return;
          if (pill) {
            pill.className = `qd26-pill qd26-pill--${host[0]}`;
            pill.textContent = host[1];
          }
          setText('[data-qd26-verdict-title]', host[2]);
          setText('[data-qd26-verdict-body]', host[3]);
          setText('[data-qd26-verdict-link]', host[4]);
          setText('[data-qd26-verdict-drives]', host[5]);
          setText('[data-qd26-verdict-raid]', host[6]);
        });
      }

      /* Long spec list starts collapsed on phones */
      const specs = $('.qd26-specs');
      if (specs && isPhone()) specs.open = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-cro-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = () => {
      document.querySelectorAll('[data-qd-cro]').forEach((root) => {
        if (root.dataset.qdCroReady === 'true') return;
        root.dataset.qdCroReady = 'true';

        root.querySelectorAll('[data-qd-buy-link]').forEach((link) => {
          link.addEventListener('click', (event) => {
            const target = document.querySelector('product-info[id^="MainProduct"], .product__info-container, form[action*="/cart/add"]');
            if (!target) return;

            event.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-explorer-page-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const smooth = (value) => value * value * (3 - 2 * value);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobilePlayback = window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(max-width: 989px)').matches;

    const scenes = [
      {
        id: 'hero-start',
        from: 0,
        to: 0.16,
        startSource: 1,
        endSource: 125,
        duration: 1.65,
        eyebrow: 'QuadDrive Explorer',
        title: 'Build the drive your work actually needs.',
        body: 'A 4-bay USB4 NVMe enclosure for creators, engineers, and mobile workstations that outgrow sealed external SSDs.',
        metric: '4-Bay USB4',
        metricNote: 'QuadDrive enclosure plus 65W USB-C PD adapter. SSDs sold separately.',
        backword: 'QUADDRIVE',
        ghostword: 'USB4'
      },
      {
          id: 'install-nvme-1',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.16,
          to: 0.30,
          startSource: 125,
          endSource: 293,
          sourceCurve: [
            { at: 0, source: 125 },
            { at: 0.72, source: 285 },
            { at: 0.87, source: 293 },
            { at: 1, source: 293 }
          ],
          duration: 1.85,
          eyebrow: 'Install 1 of 4',
          title: 'Start with one NVMe.',
          body: 'Install the first 2230, 2242, or 2280 M.2 NVMe SSD. Three bays stay open for future capacity.',
          metric: 'NVMe 1 / 4',
          metricNote: 'First drive installed. Scroll once to add the next NVMe.',
          backword: 'NVME 1',
          ghostword: '1 / 4'
      },
      {
          id: 'install-nvme-2',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.30,
          to: 0.42,
          startSource: 293,
          endSource: 313,
          sourceCurve: [
            { at: 0, source: 293 },
            { at: 0.18, source: 293 },
            { at: 0.82, source: 313 },
            { at: 1, source: 313 }
          ],
          duration: 1.05,
          eyebrow: 'Install 2 of 4',
          title: 'Add the second NVMe.',
          body: 'Populate the second bay when the workflow needs more capacity, another volume, or a multi-drive array.',
          metric: 'NVMe 2 / 4',
          metricNote: 'Two drives installed. Two bays remain open.',
          backword: 'NVME 2',
          ghostword: '2 / 4'
      },
      {
          id: 'install-nvme-3',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.42,
          to: 0.54,
          startSource: 313,
          endSource: 337,
          sourceCurve: [
            { at: 0, source: 313 },
            { at: 0.16, source: 313 },
            { at: 0.84, source: 337 },
            { at: 1, source: 337 }
          ],
          duration: 1.2,
          eyebrow: 'Install 3 of 4',
          title: 'Add the third NVMe.',
          body: 'Use the third bay for additional project media, scratch space, or the next stage of your storage plan.',
          metric: 'NVMe 3 / 4',
          metricNote: 'Three drives installed. One bay remains open.',
          backword: 'NVME 3',
          ghostword: '3 / 4'
      },
      {
          id: 'install-nvme-4',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.54,
          to: 0.68,
          startSource: 337,
          endSource: 357,
          sourceCurve: [
            { at: 0, source: 337 },
            { at: 0.20, source: 337 },
            { at: 0.80, source: 357 },
            { at: 1, source: 357 }
          ],
          duration: 1.1,
          eyebrow: 'Install 4 of 4',
          title: 'Fill the fourth bay.',
          body: 'Populate all four NVMe bays when the job calls for maximum flexibility, capacity, or a four-drive workflow.',
          metric: 'NVMe 4 / 4',
          metricNote: 'All four bays populated. Scroll to continue to USB4 performance.',
          backword: '4 NVME',
          ghostword: '4 / 4'
      },
      {
        id: 'io-transition',
        marker: 'thunderbolt',
        from: 0.68,
        to: 0.80,
        startSource: 357,
        endSource: 461,
        sourceCurve: [
          { at: 0, source: 357 },
          { at: 0.14, source: 357 },
          { at: 0.20, source: 413 },
          { at: 1, source: 461 }
        ],
        duration: 1.35,
        eyebrow: 'Thunderbolt-class USB4',
        title: 'Thunderbolt speed. Separate PD power.',
        body: 'The camera moves from the four-bay build to the I/O edge before the speed story lands.',
        metric: 'Up to 3200MB/s',
        metricNote: 'Single NVMe up to 1600MB/s. Multi-drive workflows up to 3200MB/s.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'thunderbolt',
        from: 0.80,
        to: 0.88,
        startSource: 461,
        endSource: 505,
        duration: 1.05,
        eyebrow: 'Thunderbolt-class USB4',
        title: 'Thunderbolt speed. Separate PD power.',
        body: 'One USB-C link carries USB4 and Thunderbolt-class data. A separate USB-C PD input feeds stable power to the four-drive system while data moves fast.',
        metric: 'Up to 3200MB/s',
        metricNote: 'Single NVMe up to 1600MB/s. Multi-drive workflows up to 3200MB/s.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'hero-return',
        from: 0.88,
        to: 1,
        startSource: 505,
        endSource: 601,
        duration: 1.3,
        eyebrow: 'Ready for work',
        title: 'One compact box. A storage plan that keeps growing.',
        body: 'For project media, scratch disks, backup staging, and lab work that needs fast removable NVMe storage without cable clutter.',
        metric: 'Build yours',
        metricNote: 'Order the enclosure, then choose the SSD capacity that fits your workflow.',
        backword: 'READY',
        ghostword: 'SSD'
      }
    ];

    const motionVersion = '3.15.0';
    const motionUrls = {
      gsap: `https://cdn.jsdelivr.net/npm/gsap@${motionVersion}/dist/gsap.min.js`,
      scrollTrigger: `https://cdn.jsdelivr.net/npm/gsap@${motionVersion}/dist/ScrollTrigger.min.js`,
    };

    const loadScriptOnce = (src, id, ready) => {
      if (ready()) return Promise.resolve();

      return new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[data-qdx-motion="${id}"]`);
        const handleLoad = () => ready() ? resolve() : reject(new Error(`${id} did not initialize`));
        const handleError = () => reject(new Error(`${id} failed to load`));

        if (existing) {
          existing.addEventListener('load', handleLoad, { once: true });
          existing.addEventListener('error', handleError, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.dataset.qdxMotion = id;
        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
        document.head.appendChild(script);
      });
    };

    const ensureMotionEngine = () => {
      if (window.gsap && window.ScrollTrigger) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        return Promise.resolve({ gsap: window.gsap, ScrollTrigger: window.ScrollTrigger });
      }

      if (!window.__qdxMotionPromise) {
        window.__qdxMotionPromise = loadScriptOnce(motionUrls.gsap, 'gsap', () => Boolean(window.gsap))
          .then(() => loadScriptOnce(
            motionUrls.scrollTrigger,
            'scroll-trigger',
            () => Boolean(window.ScrollTrigger)
          ))
          .then(() => {
            window.gsap.registerPlugin(window.ScrollTrigger);
            return { gsap: window.gsap, ScrollTrigger: window.ScrollTrigger };
          })
          .catch(() => null);
      }

      return window.__qdxMotionPromise;
    };

    const createFrameLoader = (frames, onReady, onStats) => {
      const reportedMemory = Number(navigator.deviceMemory);
      const lowMemory = Number.isFinite(reportedMemory) && reportedMemory <= 4;
      const constrained = mobilePlayback || lowMemory;
      const maxConcurrent = constrained ? 2 : 4;
      const maxReady = mobilePlayback ? 6 : (lowMemory ? 8 : 14);
      const ahead = constrained ? 4 : 10;
      const behind = constrained ? 1 : 3;
      const maxQueued = constrained ? 18 : 36;
      const requestTimeout = constrained ? 12000 : 10000;
      const maxAttempts = 2;
      const coreIndices = Array.from(new Set([
        1,
        ...frames.filter((frame) => frame.core).map((frame) => frame.index),
        frames.length,
      ])).sort((a, b) => a - b);
      const eligibleIndices = constrained && coreIndices.length ? coreIndices : frames.map((frame) => frame.index);
      const entries = new Map();
      let queue = [];
      let activeLoads = 0;
      let touch = 0;
      let totalRetries = 0;
      let centerIndex = 1;
      let directionIntent = 1;
      let destroyed = false;

      const normalizeIndex = (index, direction = 0) => {
        const requested = clamp(Math.round(index), 1, frames.length);
        if (!constrained || eligibleIndices.length === frames.length) return requested;

        let low = 0;
        let high = eligibleIndices.length - 1;
        while (low <= high) {
          const middle = Math.floor((low + high) / 2);
          if (eligibleIndices[middle] === requested) return requested;
          if (eligibleIndices[middle] < requested) low = middle + 1;
          else high = middle - 1;
        }

        const before = eligibleIndices[Math.max(high, 0)];
        const after = eligibleIndices[Math.min(low, eligibleIndices.length - 1)];
        const beforeDistance = Math.abs(requested - before);
        const afterDistance = Math.abs(after - requested);
        if (beforeDistance === afterDistance && direction !== 0) return direction > 0 ? after : before;
        return beforeDistance <= afterDistance ? before : after;
      };

      const eligibleOffset = (index, offset) => {
        const normalized = normalizeIndex(index, Math.sign(offset));
        const position = eligibleIndices.indexOf(normalized);
        return eligibleIndices[clamp(position + offset, 0, eligibleIndices.length - 1)];
      };

      const reportStats = () => {
        if (!onStats) return;
        onStats({
          ready: Array.from(entries.values()).filter((entry) => entry.state === 'ready').length,
          inFlight: activeLoads,
          retries: totalRetries,
        });
      };

      const releaseEntry = (entry) => {
        if (!entry?.image) return;
        window.clearTimeout(entry.timeoutId);
        entry.image.onload = null;
        entry.image.onerror = null;
        entry.image.removeAttribute('src');
        entry.image = null;
      };

      const trim = () => {
        let readyCount = Array.from(entries.values()).filter((entry) => entry.state === 'ready').length;
        while (readyCount > maxReady) {
          const now = performance.now();
          const entry = Array.from(entries.values())
            .filter((candidate) => candidate.state === 'ready' && candidate.index !== centerIndex)
            .sort((a, b) => {
              const pinned = Number(a.pinUntil > now) - Number(b.pinUntil > now);
              if (pinned) return pinned;
              const core = Number(a.frame.core) - Number(b.frame.core);
              if (core) return core;
              const distance = Math.abs(b.index - centerIndex) - Math.abs(a.index - centerIndex);
              return distance || a.touched - b.touched;
            })[0];
          if (!entry) break;
          entries.delete(entry.index);
          releaseEntry(entry);
          readyCount -= 1;
        }
      };

      const queueScore = (entry) => {
        if (entry.index === centerIndex) return -1000;
        const directionalDistance = (entry.index - centerIndex) * directionIntent;
        const behindPenalty = directionalDistance < 0 ? 20 : 0;
        const activeBoost = entry.pinUntil > performance.now() ? entry.priority : 0;
        const coreBoost = entry.frame.core ? -8 : 0;
        return activeBoost + coreBoost + behindPenalty + Math.abs(entry.index - centerIndex);
      };

      const sortAndLimitQueue = () => {
        queue = queue.filter((entry) => entry.state === 'queued');
        queue.sort((a, b) => queueScore(a) - queueScore(b) || a.queuedAt - b.queuedAt);
        if (queue.length <= maxQueued) return;
        queue.splice(maxQueued).forEach((entry) => {
          if (entry.state !== 'queued') return;
          entries.delete(entry.index);
          releaseEntry(entry);
        });
      };

      const ensure = (index, priority = 0, pinMs = 0) => {
        const safeIndex = normalizeIndex(index);
        const existing = entries.get(safeIndex);
        if (existing) {
          existing.priority = Math.min(existing.priority, priority);
          existing.pinUntil = Math.max(existing.pinUntil, performance.now() + pinMs);
          existing.touched = ++touch;
          return existing;
        }

        const entry = {
          index: safeIndex,
          frame: frames[safeIndex - 1],
          state: 'queued',
          image: null,
          touched: ++touch,
          queuedAt: touch,
          priority,
          pinUntil: performance.now() + pinMs,
          attempts: 0,
          loadToken: 0,
          timeoutId: 0,
        };
        entries.set(safeIndex, entry);
        queue.push(entry);
        return entry;
      };

      const pump = () => {
        if (destroyed) return;
        sortAndLimitQueue();
        while (activeLoads < maxConcurrent && queue.length) {
          const entry = queue.shift();
          if (!entry || entry.state !== 'queued') continue;

          entry.state = 'loading';
          entry.attempts += 1;
          entry.loadToken += 1;
          const loadToken = entry.loadToken;
          activeLoads += 1;

          const image = new Image();
          image.decoding = 'async';
          image.fetchPriority = entry.index === centerIndex || entry.priority <= -200 ? 'high' : 'low';
          entry.image = image;

          const finish = (state) => {
            if (entry.state !== 'loading' || entry.loadToken !== loadToken) return;
            window.clearTimeout(entry.timeoutId);
            image.onload = null;
            image.onerror = null;
            entry.touched = ++touch;
            activeLoads -= 1;

            if (state === 'ready') {
              entry.state = 'ready';
              trim();
              onReady(entry);
            } else if (entry.attempts < maxAttempts) {
              image.removeAttribute('src');
              entry.image = null;
              entry.state = 'queued';
              entry.priority -= 8;
              entry.queuedAt = ++touch;
              totalRetries += 1;
              queue.push(entry);
            } else {
              image.removeAttribute('src');
              entry.image = null;
              entry.state = 'error';
            }

            reportStats();
            pump();
          };

          image.onload = () => {
            if (typeof image.decode === 'function') {
              image.decode().catch(() => {}).then(() => finish('ready'));
            } else {
              finish('ready');
            }
          };
          image.onerror = () => finish('error');
          entry.timeoutId = window.setTimeout(() => finish('error'), requestTimeout);
          image.src = entry.frame.url;
          reportStats();
        }
      };

      const schedule = (index, direction) => {
        centerIndex = normalizeIndex(index, direction);
        directionIntent = direction >= 0 ? 1 : -1;
        ensure(centerIndex, -240, 140);

        for (let offset = 1; offset <= ahead; offset += 1) {
          ensure(eligibleOffset(centerIndex, offset * directionIntent), -120 + offset, 80);
        }
        for (let offset = 1; offset <= behind; offset += 1) {
          ensure(eligibleOffset(centerIndex, -offset * directionIntent), -40 + offset, 60);
        }

        sortAndLimitQueue();
        trim();
        pump();
        return entries.get(centerIndex);
      };

      const nearestReady = (index, fromIndex) => {
        const lower = Math.min(index, fromIndex);
        const upper = Math.max(index, fromIndex);
        return Array.from(entries.values())
          .filter((entry) => entry.state === 'ready' && entry.index >= lower && entry.index <= upper)
          .sort((a, b) => Math.abs(a.index - index) - Math.abs(b.index - index))[0] || null;
      };

      const prewarmCorridor = (fromIndex, toIndex, compact = false) => {
        const from = normalizeIndex(fromIndex, Math.sign(toIndex - fromIndex));
        const to = normalizeIndex(toIndex, Math.sign(toIndex - fromIndex));
        const direction = to >= from ? 1 : -1;
        const span = Math.abs(to - from);
        const budget = compact ? (constrained ? 3 : 5) : (constrained ? 6 : 10);
        const candidates = [{ index: to, priority: -320 }];

        for (let offset = 1; offset <= Math.min(3, span); offset += 1) {
          candidates.push({ index: eligibleOffset(from, offset * direction), priority: -280 + offset });
        }

        frames.forEach((frame, frameOffset) => {
          const index = frameOffset + 1;
          if (!frame.core || index === from || index === to) return;
          if (index < Math.min(from, to) || index > Math.max(from, to)) return;
          candidates.push({ index, priority: -220 + Math.abs(index - from) * 0.01 });
        });

        [0.25, 0.5, 0.75].forEach((ratio, ratioIndex) => {
          candidates.push({
            index: Math.round(from + (to - from) * ratio),
            priority: -180 + ratioIndex,
          });
        });

        const seen = new Set();
        candidates
          .sort((a, b) => a.priority - b.priority)
          .filter((candidate) => {
            const index = normalizeIndex(candidate.index);
            if (seen.has(index)) return false;
            seen.add(index);
            candidate.index = index;
            return true;
          })
          .slice(0, budget)
          .forEach((candidate) => ensure(candidate.index, candidate.priority, compact ? 3200 : 5000));

        sortAndLimitQueue();
        pump();
      };

      const destroy = () => {
        destroyed = true;
        queue = [];
        entries.forEach(releaseEntry);
        entries.clear();
      };

      reportStats();
      return { schedule, nearestReady, prewarmCorridor, destroy };
    };

    const initScroll = (section) => {
      if (section.dataset.qdxReady === 'true') return;
      section.dataset.qdxReady = 'true';

      const frameData = section.querySelector('[data-qdx-frames]');
      const canvas = section.querySelector('[data-qdx-frame-canvas]');
      const poster = section.querySelector('[data-qdx-frame-poster]');
      const titleEl = section.querySelector('[data-qdx-title]');
      const bodyEl = section.querySelector('[data-qdx-body]');
      const eyebrowEl = section.querySelector('[data-qdx-eyebrow]');
      const metricEl = section.querySelector('[data-qdx-metric]');
      const metricNoteEl = section.querySelector('[data-qdx-metric-note]');
      const backwordEl = section.querySelector('[data-qdx-backword]');
      const ghostwordEl = section.querySelector('[data-qdx-ghostword]');
      const markers = Array.from(section.querySelectorAll('[data-qdx-marker]'));

      if (!frameData || !canvas || !poster) return;

      const context = canvas.getContext('2d', { alpha: true, desynchronized: true });
      if (!context) return;

      let manifest = null;
      try {
        manifest = JSON.parse(frameData.textContent);
      } catch (error) {
        manifest = null;
      }

      if (!manifest || !Array.isArray(manifest.urls) || !Array.isArray(manifest.sources)) return;

      const coreSources = new Set((manifest.coreSources || []).map(Number));
      const frames = manifest.urls.map((url, index) => ({
        index: index + 1,
        url,
        sourceFrame: Number(manifest.sources[index]),
        core: coreSources.has(Number(manifest.sources[index])),
      })).filter((frame) => frame.url && Number.isFinite(frame.sourceFrame));

      if (!frames.length || frames.length !== manifest.urls.length || frames.length !== manifest.sources.length) return;
      if (frames.some((frame, index) => index > 0 && frame.sourceFrame <= frames[index - 1].sourceFrame)) return;

      const reportedMemory = Number(navigator.deviceMemory);
      const lowMemoryPlayback = Number.isFinite(reportedMemory) && reportedMemory <= 4;
      const corePlayback = mobilePlayback || lowMemoryPlayback;
      const coreFrames = frames.filter((frame, index) => frame.core || index === 0 || index === frames.length - 1);
      const playbackFrames = corePlayback && coreFrames.length ? coreFrames : frames;

      const canvasWidth = Number(manifest.width) || 1920;
      const canvasHeight = Number(manifest.height) || 1080;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      canvas.setAttribute('width', String(canvasWidth));
      canvas.setAttribute('height', String(canvasHeight));
      section.dataset.qdxSequenceVersion = String(manifest.version || 'unknown');
      section.dataset.qdxSequenceFrames = String(frames.length);
      section.dataset.qdxPlaybackFrames = String(playbackFrames.length);

      if (reduceMotion) {
        const staticScene = scenes[0];
        if (eyebrowEl) eyebrowEl.textContent = staticScene.eyebrow;
        if (titleEl) titleEl.textContent = staticScene.title;
        if (bodyEl) bodyEl.textContent = staticScene.body;
        if (metricEl) metricEl.textContent = staticScene.metric;
        if (metricNoteEl) metricNoteEl.textContent = staticScene.metricNote;
        if (backwordEl) backwordEl.textContent = staticScene.backword;
        if (ghostwordEl) ghostwordEl.textContent = staticScene.ghostword;
        markers.forEach((marker) => marker.classList.toggle(
          'is-active',
          marker.dataset.qdxMarker === 'hero-start'
        ));
        section.dataset.qdxChapterMode = 'reduced-motion';
        section.dataset.qdxDesiredFrame = '1';
        section.dataset.qdxDisplayedFrame = '0';
        section.dataset.qdxDesiredSource = String(frames[0].sourceFrame);
        section.dataset.qdxDisplayedSource = '0';
        section.dataset.qdxCacheReady = '0';
        section.dataset.qdxInFlight = '0';
        section.dataset.qdxRetries = '0';
        section.dataset.qdxMaxDrawJump = '0';
        section.dataset.qdxLongestHoldMs = '0';
        section.style.setProperty('--qdx-progress', '0');
        section.dataset.scene = 'hero-start';
        poster.hidden = false;
        return;
      }

      let raf = 0;
      let activeSceneId = '';
      let displayedFrame = 0;
      let desiredFrame = 1;
      let visualPosition = 0;
      let desiredSource = frames[0].sourceFrame;
      let displayedSource = 0;
      let copyTimer = 0;
      let lastRenderTime = performance.now();
      let lastDrawTime = 0;
      let maxDrawJump = 0;
      let longestHoldMs = 0;
      let stableViewportWidth = window.innerWidth;
      let stableViewportHeight = Math.max(window.innerHeight, document.documentElement.clientHeight, 1);
      let chapterObserver = null;
      let chapterTrigger = null;
      let chapterTween = null;
      let chapterObserverEnabled = false;
      let chapterInputArmed = true;
      let wheelActive = false;
      let frameLoader;

      const playbackTargetForSource = (source, direction = 0) => {
        if (source <= playbackFrames[0].sourceFrame) {
          return { index: playbackFrames[0].index, position: 0 };
        }
        if (source >= playbackFrames[playbackFrames.length - 1].sourceFrame) {
          return {
            index: playbackFrames[playbackFrames.length - 1].index,
            position: playbackFrames.length - 1,
          };
        }

        let low = 0;
        let high = playbackFrames.length - 1;
        while (low <= high) {
          const middle = Math.floor((low + high) / 2);
          const middleSource = playbackFrames[middle].sourceFrame;
          if (middleSource === source) return { index: playbackFrames[middle].index, position: middle };
          if (middleSource < source) low = middle + 1;
          else high = middle - 1;
        }

        const beforePosition = Math.max(high, 0);
        const afterPosition = Math.min(low, playbackFrames.length - 1);
        const before = playbackFrames[beforePosition];
        const after = playbackFrames[afterPosition];
        const beforeDistance = Math.abs(source - before.sourceFrame);
        const afterDistance = Math.abs(after.sourceFrame - source);
        if (beforeDistance === afterDistance && direction !== 0) {
          return direction > 0
            ? { index: after.index, position: afterPosition }
            : { index: before.index, position: beforePosition };
        }
        return beforeDistance <= afterDistance
          ? { index: before.index, position: beforePosition }
          : { index: after.index, position: afterPosition };
      };

      const displayIndexForSource = (source, direction = 0) => playbackTargetForSource(source, direction).index;

      const updateLoaderStats = (stats) => {
        section.dataset.qdxCacheReady = String(stats.ready);
        section.dataset.qdxInFlight = String(stats.inFlight);
        section.dataset.qdxRetries = String(stats.retries);
      };

      const updateMotionStats = (timestamp = performance.now()) => {
        if (lastDrawTime && displayedFrame !== desiredFrame) {
          longestHoldMs = Math.max(longestHoldMs, timestamp - lastDrawTime);
        }
        section.dataset.qdxDesiredFrame = String(desiredFrame);
        section.dataset.qdxDisplayedFrame = String(displayedFrame);
        section.dataset.qdxDesiredSource = String(Math.round(desiredSource));
        section.dataset.qdxDisplayedSource = String(displayedSource);
        section.dataset.qdxMaxDrawJump = String(maxDrawJump);
        section.dataset.qdxLongestHoldMs = String(Math.round(longestHoldMs));
      };

      const drawFrame = (entry) => {
        if (!entry || entry.state !== 'ready') return;
        if (!entry.image || !entry.image.complete || entry.image.naturalWidth < 1) return;
        if (entry.index === displayedFrame) return;
        if (displayedFrame === 0 && entry.index !== desiredFrame) return;

        if (displayedFrame > 0) {
          const lower = Math.min(displayedFrame, desiredFrame);
          const upper = Math.max(displayedFrame, desiredFrame);
          const advancesTowardTarget = entry.index >= lower &&
            entry.index <= upper &&
            Math.abs(desiredFrame - entry.index) < Math.abs(desiredFrame - displayedFrame);
          if (!advancesTowardTarget) return;
        }

        const now = performance.now();
        if (displayedFrame > 0) {
          maxDrawJump = Math.max(maxDrawJump, Math.abs(entry.index - displayedFrame));
          if (lastDrawTime && displayedFrame !== desiredFrame) {
            longestHoldMs = Math.max(longestHoldMs, now - lastDrawTime);
          }
        }
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(entry.image, 0, 0, canvas.width, canvas.height);
        canvas.dataset.qdxFrame = String(entry.index);
        canvas.dataset.qdxSource = String(entry.frame.sourceFrame);
        canvas.dataset.qdxSourceFrame = String(entry.frame.sourceFrame);
        canvas.classList.add('is-ready');
        poster.hidden = true;
        displayedFrame = entry.index;
        displayedSource = entry.frame.sourceFrame;
        lastDrawTime = now;
        updateMotionStats(now);
      };

      frameLoader = createFrameLoader(frames, (entry) => {
        drawFrame(entry);
      }, updateLoaderStats);

      const sceneForProgress = (progress) => {
        return scenes.find((scene, index) => {
          const isLast = index === scenes.length - 1;
          return progress >= scene.from && (isLast ? progress <= scene.to : progress <= scene.to);
        }) || scenes[scenes.length - 1];
      };

      const applySceneCopy = (scene) => {
        if (eyebrowEl && eyebrowEl.textContent !== scene.eyebrow) eyebrowEl.textContent = scene.eyebrow;
        if (titleEl && titleEl.textContent !== scene.title) titleEl.textContent = scene.title;
        if (bodyEl && bodyEl.textContent !== scene.body) bodyEl.textContent = scene.body;
        if (metricEl && metricEl.textContent !== scene.metric) metricEl.textContent = scene.metric;
        if (metricNoteEl && metricNoteEl.textContent !== scene.metricNote) metricNoteEl.textContent = scene.metricNote;
        if (backwordEl && backwordEl.textContent !== scene.backword) backwordEl.textContent = scene.backword;
        if (ghostwordEl && ghostwordEl.textContent !== scene.ghostword) ghostwordEl.textContent = scene.ghostword;

        const markerId = scene.marker || scene.id;
        markers.forEach((marker) => {
          marker.classList.toggle('is-active', marker.dataset.qdxMarker === markerId);
        });
      };

      const markStableCopy = (scene) => {
        section.classList.toggle('qdx-stable-eyebrow', Boolean(eyebrowEl && eyebrowEl.textContent === scene.eyebrow));
        section.classList.toggle('qdx-stable-title', Boolean(titleEl && titleEl.textContent === scene.title));
        section.classList.toggle('qdx-stable-body', Boolean(bodyEl && bodyEl.textContent === scene.body));
        section.classList.toggle('qdx-stable-metric', Boolean(
          metricEl &&
          metricNoteEl &&
          metricEl.textContent === scene.metric &&
          metricNoteEl.textContent === scene.metricNote
        ));
      };

      const clearStableCopy = () => {
        section.classList.remove('qdx-stable-eyebrow', 'qdx-stable-title', 'qdx-stable-body', 'qdx-stable-metric');
      };

      const setScene = (scene) => {
        if (activeSceneId === scene.id) return;
        const hadScene = Boolean(activeSceneId);
        activeSceneId = scene.id;
        section.dataset.scene = scene.styleScene || scene.id;
        window.clearTimeout(copyTimer);

        if (!hadScene || reduceMotion) {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
          clearStableCopy();
          return;
        }

        markStableCopy(scene);
        section.classList.add('is-changing');
        copyTimer = window.setTimeout(() => {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
          clearStableCopy();
        }, 140);
      };

      const sourceForProgress = (progress, scene) => {
        if (reduceMotion) return scene.endSource;
        const local = clamp((progress - scene.from) / Math.max(scene.to - scene.from, 0.0001), 0, 1);
        const curve = scene.sourceCurve;
        if (!Array.isArray(curve) || curve.length < 2) {
          return scene.startSource + (scene.endSource - scene.startSource) * local;
        }

        const upperIndex = curve.findIndex((point) => local <= point.at);
        if (upperIndex <= 0) return curve[0].source;
        if (upperIndex < 0) return curve[curve.length - 1].source;
        const lowerPoint = curve[upperIndex - 1];
        const upperPoint = curve[upperIndex];
        const segmentProgress = clamp(
          (local - lowerPoint.at) / Math.max(upperPoint.at - lowerPoint.at, 0.0001),
          0,
          1
        );
        return lowerPoint.source + (upperPoint.source - lowerPoint.source) * segmentProgress;
      };

      const frameForProgress = (progress, scene, direction = 0) => {
        const source = sourceForProgress(progress, scene);
        return { ...playbackTargetForSource(source, direction), source };
      };

      const sectionProgress = () => {
        if (reduceMotion) return 1;
        const rect = section.getBoundingClientRect();
        const viewportHeight = mobilePlayback ? stableViewportHeight : window.innerHeight;
        const travel = Math.max(rect.height - viewportHeight, 1);
        return clamp(-rect.top / travel, 0, 1);
      };

      const render = (timestamp = performance.now()) => {
        raf = 0;
        const progress = sectionProgress();
        const scene = sceneForProgress(progress);
        const sourceDirection = Math.sign(sourceForProgress(progress, scene) - desiredSource);
        const target = frameForProgress(progress, scene, sourceDirection);
        const targetFrame = target.index;
        const elapsed = clamp(timestamp - lastRenderTime, 8, 48);
        let frame = targetFrame;

        if (mobilePlayback && !reduceMotion) {
          const delta = target.position - visualPosition;
          if (Math.abs(delta) < 0.45) {
            visualPosition = target.position;
          } else {
            const maxStep = clamp((elapsed / 16.67) * 2.4, 1.2, 4.2);
            visualPosition += clamp(delta * 0.24, -maxStep, maxStep);
          }
          frame = playbackFrames[clamp(Math.round(visualPosition), 0, playbackFrames.length - 1)].index;
        } else {
          visualPosition = target.position;
        }

        const direction = frame >= Math.max(displayedFrame, 1) ? 1 : -1;

        section.style.setProperty('--qdx-progress', progress.toFixed(4));
        setScene(scene);
        desiredFrame = frame;
        desiredSource = target.source;
        const entry = frameLoader.schedule(frame, direction);
        const readyEntry = entry?.state === 'ready'
          ? entry
          : frameLoader.nearestReady(frame, Math.max(displayedFrame, 1));
        if (readyEntry) drawFrame(readyEntry);
        updateMotionStats(timestamp);
        lastRenderTime = timestamp;

        if (mobilePlayback && Math.abs(target.position - visualPosition) >= 0.45) {
          raf = window.requestAnimationFrame(render);
        }
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      const handleViewportResize = () => {
        const nextWidth = window.innerWidth;
        if (!mobilePlayback || Math.abs(nextWidth - stableViewportWidth) > 40) {
          stableViewportWidth = nextWidth;
          stableViewportHeight = Math.max(window.innerHeight, document.documentElement.clientHeight, 1);
        }
        requestRender();
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', handleViewportResize);
      requestRender();

      const chapterStops = [
        { progress: 0, source: scenes[0].startSource },
        ...scenes.map((scene) => ({ progress: scene.to, source: scene.endSource })),
      ].filter((stop, index, values) => index === 0 || stop.progress !== values[index - 1].progress);

      const nearestStopIndex = (progress) => {
        return chapterStops.reduce((bestIndex, stop, index) => {
          const bestDistance = Math.abs(chapterStops[bestIndex].progress - progress);
          return Math.abs(stop.progress - progress) < bestDistance ? index : bestIndex;
        }, 0);
      };

      const warmAdjacentChapters = (progress) => {
        const stopIndex = nearestStopIndex(progress);
        const current = chapterStops[stopIndex];
        const currentFrame = displayIndexForSource(current.source);
        const previous = chapterStops[stopIndex - 1];
        const next = chapterStops[stopIndex + 1];
        if (next) frameLoader.prewarmCorridor(currentFrame, displayIndexForSource(next.source, 1), false);
        if (previous) frameLoader.prewarmCorridor(currentFrame, displayIndexForSource(previous.source, -1), true);
      };

      const scheduleIdleWarm = (progress) => {
        const warm = () => {
          if (!section.isConnected || chapterTween?.isActive()) return;
          warmAdjacentChapters(progress);
        };
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(warm, { timeout: 900 });
        } else {
          window.setTimeout(warm, 160);
        }
      };

      const setChapterObserver = (enabled) => {
        if (!chapterObserver) return;
        chapterObserverEnabled = enabled;
        if (enabled) {
          chapterInputArmed = true;
          wheelActive = false;
          chapterObserver.enable();
        } else {
          chapterObserver.disable();
        }
      };

      const releaseChapterEdge = (direction) => {
        chapterInputArmed = true;
        wheelActive = false;
        setChapterObserver(false);
        window.requestAnimationFrame(() => window.scrollBy(0, direction * 4));
      };

      const handleChapterKey = (event) => {
        if (!chapterObserverEnabled) return;
        const nextKeys = ['ArrowDown', 'PageDown', ' '];
        const previousKeys = ['ArrowUp', 'PageUp'];
        if (!nextKeys.includes(event.key) && !previousKeys.includes(event.key)) return;
        event.preventDefault();
        playChapter(nextKeys.includes(event.key) ? 1 : -1);
      };

      const playChapter = (direction) => {
        if (!chapterObserver || chapterTween?.isActive()) return;

        const current = sectionProgress();
        const epsilon = 0.012;
        const target = direction > 0
          ? chapterStops.find((stop) => stop.progress > current + epsilon)
          : [...chapterStops].reverse().find((stop) => stop.progress < current - epsilon);

        if (!target) {
          releaseChapterEdge(direction);
          return;
        }

        const landingProgress = target.progress;
        const targetFrame = displayIndexForSource(target.source, direction);
        const transitionProgress = clamp(current + direction * 0.0001, 0, 1);
        const transitionScene = sceneForProgress(transitionProgress);
        frameLoader.prewarmCorridor(Math.max(displayedFrame, 1), targetFrame, false);

        const rect = section.getBoundingClientRect();
        const sectionTop = window.scrollY + rect.top;
        const travel = Math.max(section.offsetHeight - window.innerHeight, 1);
        const targetY = sectionTop + travel * landingProgress;
        const proxy = { y: window.scrollY };
        const duration = transitionScene.duration || 1.2;

        section.dataset.qdxChapterPlaying = 'true';
        section.dataset.qdxChapterTargetSource = String(target.source);
        chapterTween = window.gsap.to(proxy, {
          y: targetY,
          duration,
          ease: 'none',
          overwrite: true,
          onUpdate: () => {
            window.scrollTo(0, proxy.y);
            requestRender();
          },
          onComplete: () => {
            chapterTween = null;
            delete section.dataset.qdxChapterPlaying;
            requestRender();
            scheduleIdleWarm(landingProgress);
            if (!wheelActive) chapterInputArmed = true;
          },
          onInterrupt: () => {
            chapterTween = null;
            delete section.dataset.qdxChapterPlaying;
            if (!wheelActive) chapterInputArmed = true;
          },
        });
      };

      if (!mobilePlayback && !reduceMotion) {
        ensureMotionEngine().then((motion) => {
          if (!motion || !section.isConnected) {
            section.dataset.qdxChapterMode = 'fallback';
            return;
          }

          const { ScrollTrigger } = motion;
          section.dataset.qdxChapterMode = 'gsap';
          chapterObserver = ScrollTrigger.observe({
            target: window,
            type: 'wheel',
            preventDefault: true,
            tolerance: 18,
            onChangeY: (observer) => {
              wheelActive = true;
              if (!chapterInputArmed) return;
              chapterInputArmed = false;
              playChapter(observer.deltaY > 0 ? 1 : -1);
            },
            onStopDelay: 0.16,
            onStop: () => {
              wheelActive = false;
              if (!chapterTween?.isActive()) chapterInputArmed = true;
            },
          });
          chapterObserver.disable();

          chapterTrigger = ScrollTrigger.create({
            trigger: section,
            start: 'top top',
            end: 'bottom bottom',
            onEnter: () => setChapterObserver(true),
            onEnterBack: () => setChapterObserver(true),
            onLeave: () => setChapterObserver(false),
            onLeaveBack: () => {
              const rect = section.getBoundingClientRect();
              setChapterObserver(rect.top <= 1 && rect.bottom >= window.innerHeight);
            },
          });

          document.addEventListener('keydown', handleChapterKey);
          ScrollTrigger.refresh();
          const currentRect = section.getBoundingClientRect();
          if (currentRect.top <= 1 && currentRect.bottom >= window.innerHeight) {
            setChapterObserver(true);
          }
          scheduleIdleWarm(sectionProgress());
        });
      } else {
        section.dataset.qdxChapterMode = reduceMotion ? 'reduced-motion' : 'mobile-scrub';
        scheduleIdleWarm(sectionProgress());
      }

      section.qdxCleanup = () => {
        window.removeEventListener('scroll', requestRender);
        window.removeEventListener('resize', handleViewportResize);
        document.removeEventListener('keydown', handleChapterKey);
        if (raf) window.cancelAnimationFrame(raf);
        if (chapterTween) chapterTween.kill();
        if (chapterObserver) chapterObserver.kill();
        if (chapterTrigger) chapterTrigger.kill();
        if (frameLoader) frameLoader.destroy();
      };
    };

    const initBridge = (bridge) => {
      if (bridge.dataset.qdxBridgeReady === 'true') return;
      bridge.dataset.qdxBridgeReady = 'true';

      const setProgress = (progress) => {
        const eased = smooth(clamp(progress, 0, 1));

        bridge.style.setProperty('--qdx-bridge-photo-opacity', (0.34 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-photo-scale', (1.08 - eased * 0.035).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-copy-y', `${(28 - eased * 42).toFixed(2)}px`);
        bridge.style.setProperty('--qdx-bridge-copy-opacity', (0.72 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-line', Math.min(1, eased * 1.06).toFixed(3));
      };

      if (reduceMotion) {
        setProgress(1);
        return;
      }

      let raf = 0;

      const render = () => {
        raf = 0;
        const rect = bridge.getBoundingClientRect();
        const distance = Math.max(rect.height - window.innerHeight, 1);
        const progress = clamp(-rect.top / distance, 0, 1);
        setProgress(progress);
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initReveal = (root) => {
      const items = Array.from(root.querySelectorAll('[data-qdx-reveal]'));
      if (!items.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    };

    const initHeaderChrome = (root) => {
      if (!root || document.body.dataset.qdxHeaderReady === 'true') return;
      document.body.dataset.qdxHeaderReady = 'true';
      document.body.classList.add('qdx-cinema-active');

      let lastY = window.scrollY;
      let raf = 0;

      const render = () => {
        raf = 0;
        const y = window.scrollY;
        const rect = root.getBoundingClientRect();
        const inExplorer = rect.bottom > 80 && rect.top < window.innerHeight;
        const scrollingDown = y > lastY + 3;
        const scrollingUp = y < lastY - 10;
        const pastTop = y > 60 && rect.top < 0;

        document.body.classList.toggle('qdx-header-soft', inExplorer && pastTop);

        if (!inExplorer || !pastTop || scrollingUp) {
          document.body.classList.remove('qdx-header-hidden');
        } else if (scrollingDown) {
          document.body.classList.add('qdx-header-hidden');
        }

        lastY = y;
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initAll = (root) => {
      root.querySelectorAll('[data-qdx-scroll]').forEach(initScroll);
      root.querySelectorAll('[data-qdx-bridge]').forEach(initBridge);
      root.querySelectorAll('[data-qdx-root]').forEach(initReveal);
      root.querySelectorAll('[data-qdx-root]').forEach(initHeaderChrome);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-qdx-scroll]').forEach((section) => section.qdxCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-explorer-page-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const smooth = (value) => value * value * (3 - 2 * value);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobilePlayback = window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(max-width: 989px)').matches;

    const scenes = [
      {
        id: 'hero-start',
        from: 0,
        to: 0.16,
        startSource: 1,
        endSource: 125,
        duration: 1.65,
        eyebrow: 'QuadDrive Explorer',
        title: 'Build the drive your work actually needs.',
        body: 'A 4-bay USB4 NVMe enclosure for creators, engineers, and mobile workstations that outgrow sealed external SSDs.',
        metric: '4-Bay USB4',
        metricNote: 'QuadDrive enclosure plus 65W USB-C PD adapter. SSDs sold separately.',
        backword: 'QUADDRIVE',
        ghostword: 'USB4'
      },
      {
          id: 'install-nvme-1',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.16,
          to: 0.30,
          startSource: 125,
          endSource: 293,
          sourceCurve: [
            { at: 0, source: 125 },
            { at: 0.72, source: 285 },
            { at: 0.87, source: 293 },
            { at: 1, source: 293 }
          ],
          duration: 1.85,
          eyebrow: 'Install 1 of 4',
          title: 'Start with one NVMe.',
          body: 'Install the first 2230, 2242, or 2280 M.2 NVMe SSD. Three bays stay open for future capacity.',
          metric: 'NVMe 1 / 4',
          metricNote: 'First drive installed. Scroll once to add the next NVMe.',
          backword: 'NVME 1',
          ghostword: '1 / 4'
      },
      {
          id: 'install-nvme-2',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.30,
          to: 0.42,
          startSource: 293,
          endSource: 313,
          sourceCurve: [
            { at: 0, source: 293 },
            { at: 0.18, source: 293 },
            { at: 0.82, source: 313 },
            { at: 1, source: 313 }
          ],
          duration: 1.05,
          eyebrow: 'Install 2 of 4',
          title: 'Add the second NVMe.',
          body: 'Populate the second bay when the workflow needs more capacity, another volume, or a multi-drive array.',
          metric: 'NVMe 2 / 4',
          metricNote: 'Two drives installed. Two bays remain open.',
          backword: 'NVME 2',
          ghostword: '2 / 4'
      },
      {
          id: 'install-nvme-3',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.42,
          to: 0.54,
          startSource: 313,
          endSource: 337,
          sourceCurve: [
            { at: 0, source: 313 },
            { at: 0.16, source: 313 },
            { at: 0.84, source: 337 },
            { at: 1, source: 337 }
          ],
          duration: 1.2,
          eyebrow: 'Install 3 of 4',
          title: 'Add the third NVMe.',
          body: 'Use the third bay for additional project media, scratch space, or the next stage of your storage plan.',
          metric: 'NVMe 3 / 4',
          metricNote: 'Three drives installed. One bay remains open.',
          backword: 'NVME 3',
          ghostword: '3 / 4'
      },
      {
          id: 'install-nvme-4',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.54,
          to: 0.68,
          startSource: 337,
          endSource: 357,
          sourceCurve: [
            { at: 0, source: 337 },
            { at: 0.20, source: 337 },
            { at: 0.80, source: 357 },
            { at: 1, source: 357 }
          ],
          duration: 1.1,
          eyebrow: 'Install 4 of 4',
          title: 'Fill the fourth bay.',
          body: 'Populate all four NVMe bays when the job calls for maximum flexibility, capacity, or a four-drive workflow.',
          metric: 'NVMe 4 / 4',
          metricNote: 'All four bays populated. Scroll to continue to USB4 performance.',
          backword: '4 NVME',
          ghostword: '4 / 4'
      },
      {
        id: 'io-transition',
        marker: 'thunderbolt',
        from: 0.68,
        to: 0.80,
        startSource: 357,
        endSource: 461,
        sourceCurve: [
          { at: 0, source: 357 },
          { at: 0.14, source: 357 },
          { at: 0.20, source: 413 },
          { at: 1, source: 461 }
        ],
        duration: 1.35,
        eyebrow: 'Thunderbolt-class USB4',
        title: 'Thunderbolt speed. Separate PD power.',
        body: 'The camera moves from the four-bay build to the I/O edge before the speed story lands.',
        metric: 'Up to 3200MB/s',
        metricNote: 'Single NVMe up to 1600MB/s. Multi-drive workflows up to 3200MB/s.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'thunderbolt',
        from: 0.80,
        to: 0.88,
        startSource: 461,
        endSource: 505,
        duration: 1.05,
        eyebrow: 'Thunderbolt-class USB4',
        title: 'Thunderbolt speed. Separate PD power.',
        body: 'One USB-C link carries USB4 and Thunderbolt-class data. A separate USB-C PD input feeds stable power to the four-drive system while data moves fast.',
        metric: 'Up to 3200MB/s',
        metricNote: 'Single NVMe up to 1600MB/s. Multi-drive workflows up to 3200MB/s.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'hero-return',
        from: 0.88,
        to: 1,
        startSource: 505,
        endSource: 601,
        duration: 1.3,
        eyebrow: 'Ready for work',
        title: 'One compact box. A storage plan that keeps growing.',
        body: 'For project media, scratch disks, backup staging, and lab work that needs fast removable NVMe storage without cable clutter.',
        metric: 'Build yours',
        metricNote: 'Order the enclosure, then choose the SSD capacity that fits your workflow.',
        backword: 'READY',
        ghostword: 'SSD'
      }
    ];

    const motionVersion = '3.15.0';
    const motionUrls = {
      gsap: `https://cdn.jsdelivr.net/npm/gsap@${motionVersion}/dist/gsap.min.js`,
      scrollTrigger: `https://cdn.jsdelivr.net/npm/gsap@${motionVersion}/dist/ScrollTrigger.min.js`,
    };

    const loadScriptOnce = (src, id, ready) => {
      if (ready()) return Promise.resolve();

      return new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[data-qdx-motion="${id}"]`);
        const handleLoad = () => ready() ? resolve() : reject(new Error(`${id} did not initialize`));
        const handleError = () => reject(new Error(`${id} failed to load`));

        if (existing) {
          existing.addEventListener('load', handleLoad, { once: true });
          existing.addEventListener('error', handleError, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.dataset.qdxMotion = id;
        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
        document.head.appendChild(script);
      });
    };

    const ensureMotionEngine = () => {
      if (window.gsap && window.ScrollTrigger) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        return Promise.resolve({ gsap: window.gsap, ScrollTrigger: window.ScrollTrigger });
      }

      if (!window.__qdxMotionPromise) {
        window.__qdxMotionPromise = loadScriptOnce(motionUrls.gsap, 'gsap', () => Boolean(window.gsap))
          .then(() => loadScriptOnce(
            motionUrls.scrollTrigger,
            'scroll-trigger',
            () => Boolean(window.ScrollTrigger)
          ))
          .then(() => {
            window.gsap.registerPlugin(window.ScrollTrigger);
            return { gsap: window.gsap, ScrollTrigger: window.ScrollTrigger };
          })
          .catch(() => null);
      }

      return window.__qdxMotionPromise;
    };

    const createFrameLoader = (frames, onReady, onStats) => {
      const reportedMemory = Number(navigator.deviceMemory);
      const lowMemory = Number.isFinite(reportedMemory) && reportedMemory <= 4;
      const constrained = mobilePlayback || lowMemory;
      const maxConcurrent = constrained ? 2 : 4;
      const maxReady = mobilePlayback ? 6 : (lowMemory ? 8 : 14);
      const ahead = constrained ? 4 : 10;
      const behind = constrained ? 1 : 3;
      const maxQueued = constrained ? 18 : 36;
      const requestTimeout = constrained ? 12000 : 10000;
      const maxAttempts = 2;
      const coreIndices = Array.from(new Set([
        1,
        ...frames.filter((frame) => frame.core).map((frame) => frame.index),
        frames.length,
      ])).sort((a, b) => a - b);
      const eligibleIndices = constrained && coreIndices.length ? coreIndices : frames.map((frame) => frame.index);
      const entries = new Map();
      let queue = [];
      let activeLoads = 0;
      let touch = 0;
      let totalRetries = 0;
      let centerIndex = 1;
      let directionIntent = 1;
      let destroyed = false;

      const normalizeIndex = (index, direction = 0) => {
        const requested = clamp(Math.round(index), 1, frames.length);
        if (!constrained || eligibleIndices.length === frames.length) return requested;

        let low = 0;
        let high = eligibleIndices.length - 1;
        while (low <= high) {
          const middle = Math.floor((low + high) / 2);
          if (eligibleIndices[middle] === requested) return requested;
          if (eligibleIndices[middle] < requested) low = middle + 1;
          else high = middle - 1;
        }

        const before = eligibleIndices[Math.max(high, 0)];
        const after = eligibleIndices[Math.min(low, eligibleIndices.length - 1)];
        const beforeDistance = Math.abs(requested - before);
        const afterDistance = Math.abs(after - requested);
        if (beforeDistance === afterDistance && direction !== 0) return direction > 0 ? after : before;
        return beforeDistance <= afterDistance ? before : after;
      };

      const eligibleOffset = (index, offset) => {
        const normalized = normalizeIndex(index, Math.sign(offset));
        const position = eligibleIndices.indexOf(normalized);
        return eligibleIndices[clamp(position + offset, 0, eligibleIndices.length - 1)];
      };

      const reportStats = () => {
        if (!onStats) return;
        onStats({
          ready: Array.from(entries.values()).filter((entry) => entry.state === 'ready').length,
          inFlight: activeLoads,
          retries: totalRetries,
        });
      };

      const releaseEntry = (entry) => {
        if (!entry?.image) return;
        window.clearTimeout(entry.timeoutId);
        entry.image.onload = null;
        entry.image.onerror = null;
        entry.image.removeAttribute('src');
        entry.image = null;
      };

      const trim = () => {
        let readyCount = Array.from(entries.values()).filter((entry) => entry.state === 'ready').length;
        while (readyCount > maxReady) {
          const now = performance.now();
          const entry = Array.from(entries.values())
            .filter((candidate) => candidate.state === 'ready' && candidate.index !== centerIndex)
            .sort((a, b) => {
              const pinned = Number(a.pinUntil > now) - Number(b.pinUntil > now);
              if (pinned) return pinned;
              const core = Number(a.frame.core) - Number(b.frame.core);
              if (core) return core;
              const distance = Math.abs(b.index - centerIndex) - Math.abs(a.index - centerIndex);
              return distance || a.touched - b.touched;
            })[0];
          if (!entry) break;
          entries.delete(entry.index);
          releaseEntry(entry);
          readyCount -= 1;
        }
      };

      const queueScore = (entry) => {
        if (entry.index === centerIndex) return -1000;
        const directionalDistance = (entry.index - centerIndex) * directionIntent;
        const behindPenalty = directionalDistance < 0 ? 20 : 0;
        const activeBoost = entry.pinUntil > performance.now() ? entry.priority : 0;
        const coreBoost = entry.frame.core ? -8 : 0;
        return activeBoost + coreBoost + behindPenalty + Math.abs(entry.index - centerIndex);
      };

      const sortAndLimitQueue = () => {
        queue = queue.filter((entry) => entry.state === 'queued');
        queue.sort((a, b) => queueScore(a) - queueScore(b) || a.queuedAt - b.queuedAt);
        if (queue.length <= maxQueued) return;
        queue.splice(maxQueued).forEach((entry) => {
          if (entry.state !== 'queued') return;
          entries.delete(entry.index);
          releaseEntry(entry);
        });
      };

      const ensure = (index, priority = 0, pinMs = 0) => {
        const safeIndex = normalizeIndex(index);
        const existing = entries.get(safeIndex);
        if (existing) {
          existing.priority = Math.min(existing.priority, priority);
          existing.pinUntil = Math.max(existing.pinUntil, performance.now() + pinMs);
          existing.touched = ++touch;
          return existing;
        }

        const entry = {
          index: safeIndex,
          frame: frames[safeIndex - 1],
          state: 'queued',
          image: null,
          touched: ++touch,
          queuedAt: touch,
          priority,
          pinUntil: performance.now() + pinMs,
          attempts: 0,
          loadToken: 0,
          timeoutId: 0,
        };
        entries.set(safeIndex, entry);
        queue.push(entry);
        return entry;
      };

      const pump = () => {
        if (destroyed) return;
        sortAndLimitQueue();
        while (activeLoads < maxConcurrent && queue.length) {
          const entry = queue.shift();
          if (!entry || entry.state !== 'queued') continue;

          entry.state = 'loading';
          entry.attempts += 1;
          entry.loadToken += 1;
          const loadToken = entry.loadToken;
          activeLoads += 1;

          const image = new Image();
          image.decoding = 'async';
          image.fetchPriority = entry.index === centerIndex || entry.priority <= -200 ? 'high' : 'low';
          entry.image = image;

          const finish = (state) => {
            if (entry.state !== 'loading' || entry.loadToken !== loadToken) return;
            window.clearTimeout(entry.timeoutId);
            image.onload = null;
            image.onerror = null;
            entry.touched = ++touch;
            activeLoads -= 1;

            if (state === 'ready') {
              entry.state = 'ready';
              trim();
              onReady(entry);
            } else if (entry.attempts < maxAttempts) {
              image.removeAttribute('src');
              entry.image = null;
              entry.state = 'queued';
              entry.priority -= 8;
              entry.queuedAt = ++touch;
              totalRetries += 1;
              queue.push(entry);
            } else {
              image.removeAttribute('src');
              entry.image = null;
              entry.state = 'error';
            }

            reportStats();
            pump();
          };

          image.onload = () => {
            if (typeof image.decode === 'function') {
              image.decode().catch(() => {}).then(() => finish('ready'));
            } else {
              finish('ready');
            }
          };
          image.onerror = () => finish('error');
          entry.timeoutId = window.setTimeout(() => finish('error'), requestTimeout);
          image.src = entry.frame.url;
          reportStats();
        }
      };

      const schedule = (index, direction) => {
        centerIndex = normalizeIndex(index, direction);
        directionIntent = direction >= 0 ? 1 : -1;
        ensure(centerIndex, -240, 140);

        for (let offset = 1; offset <= ahead; offset += 1) {
          ensure(eligibleOffset(centerIndex, offset * directionIntent), -120 + offset, 80);
        }
        for (let offset = 1; offset <= behind; offset += 1) {
          ensure(eligibleOffset(centerIndex, -offset * directionIntent), -40 + offset, 60);
        }

        sortAndLimitQueue();
        trim();
        pump();
        return entries.get(centerIndex);
      };

      const nearestReady = (index, fromIndex) => {
        const lower = Math.min(index, fromIndex);
        const upper = Math.max(index, fromIndex);
        return Array.from(entries.values())
          .filter((entry) => entry.state === 'ready' && entry.index >= lower && entry.index <= upper)
          .sort((a, b) => Math.abs(a.index - index) - Math.abs(b.index - index))[0] || null;
      };

      const prewarmCorridor = (fromIndex, toIndex, compact = false) => {
        const from = normalizeIndex(fromIndex, Math.sign(toIndex - fromIndex));
        const to = normalizeIndex(toIndex, Math.sign(toIndex - fromIndex));
        const direction = to >= from ? 1 : -1;
        const span = Math.abs(to - from);
        const budget = compact ? (constrained ? 3 : 5) : (constrained ? 6 : 10);
        const candidates = [{ index: to, priority: -320 }];

        for (let offset = 1; offset <= Math.min(3, span); offset += 1) {
          candidates.push({ index: eligibleOffset(from, offset * direction), priority: -280 + offset });
        }

        frames.forEach((frame, frameOffset) => {
          const index = frameOffset + 1;
          if (!frame.core || index === from || index === to) return;
          if (index < Math.min(from, to) || index > Math.max(from, to)) return;
          candidates.push({ index, priority: -220 + Math.abs(index - from) * 0.01 });
        });

        [0.25, 0.5, 0.75].forEach((ratio, ratioIndex) => {
          candidates.push({
            index: Math.round(from + (to - from) * ratio),
            priority: -180 + ratioIndex,
          });
        });

        const seen = new Set();
        candidates
          .sort((a, b) => a.priority - b.priority)
          .filter((candidate) => {
            const index = normalizeIndex(candidate.index);
            if (seen.has(index)) return false;
            seen.add(index);
            candidate.index = index;
            return true;
          })
          .slice(0, budget)
          .forEach((candidate) => ensure(candidate.index, candidate.priority, compact ? 3200 : 5000));

        sortAndLimitQueue();
        pump();
      };

      const destroy = () => {
        destroyed = true;
        queue = [];
        entries.forEach(releaseEntry);
        entries.clear();
      };

      reportStats();
      return { schedule, nearestReady, prewarmCorridor, destroy };
    };

    const initScroll = (section) => {
      if (section.dataset.qdxReady === 'true') return;
      section.dataset.qdxReady = 'true';

      const frameData = section.querySelector('[data-qdx-frames]');
      const canvas = section.querySelector('[data-qdx-frame-canvas]');
      const poster = section.querySelector('[data-qdx-frame-poster]');
      const titleEl = section.querySelector('[data-qdx-title]');
      const bodyEl = section.querySelector('[data-qdx-body]');
      const eyebrowEl = section.querySelector('[data-qdx-eyebrow]');
      const metricEl = section.querySelector('[data-qdx-metric]');
      const metricNoteEl = section.querySelector('[data-qdx-metric-note]');
      const backwordEl = section.querySelector('[data-qdx-backword]');
      const ghostwordEl = section.querySelector('[data-qdx-ghostword]');
      const markers = Array.from(section.querySelectorAll('[data-qdx-marker]'));

      if (!frameData || !canvas || !poster) return;

      const context = canvas.getContext('2d', { alpha: true, desynchronized: true });
      if (!context) return;

      let manifest = null;
      try {
        manifest = JSON.parse(frameData.textContent);
      } catch (error) {
        manifest = null;
      }

      if (!manifest || !Array.isArray(manifest.urls) || !Array.isArray(manifest.sources)) return;

      const coreSources = new Set((manifest.coreSources || []).map(Number));
      const frames = manifest.urls.map((url, index) => ({
        index: index + 1,
        url,
        sourceFrame: Number(manifest.sources[index]),
        core: coreSources.has(Number(manifest.sources[index])),
      })).filter((frame) => frame.url && Number.isFinite(frame.sourceFrame));

      if (!frames.length || frames.length !== manifest.urls.length || frames.length !== manifest.sources.length) return;
      if (frames.some((frame, index) => index > 0 && frame.sourceFrame <= frames[index - 1].sourceFrame)) return;

      const reportedMemory = Number(navigator.deviceMemory);
      const lowMemoryPlayback = Number.isFinite(reportedMemory) && reportedMemory <= 4;
      const corePlayback = mobilePlayback || lowMemoryPlayback;
      const coreFrames = frames.filter((frame, index) => frame.core || index === 0 || index === frames.length - 1);
      const playbackFrames = corePlayback && coreFrames.length ? coreFrames : frames;

      const canvasWidth = Number(manifest.width) || 1920;
      const canvasHeight = Number(manifest.height) || 1080;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      canvas.setAttribute('width', String(canvasWidth));
      canvas.setAttribute('height', String(canvasHeight));
      section.dataset.qdxSequenceVersion = String(manifest.version || 'unknown');
      section.dataset.qdxSequenceFrames = String(frames.length);
      section.dataset.qdxPlaybackFrames = String(playbackFrames.length);

      if (reduceMotion) {
        const staticScene = scenes[0];
        if (eyebrowEl) eyebrowEl.textContent = staticScene.eyebrow;
        if (titleEl) titleEl.textContent = staticScene.title;
        if (bodyEl) bodyEl.textContent = staticScene.body;
        if (metricEl) metricEl.textContent = staticScene.metric;
        if (metricNoteEl) metricNoteEl.textContent = staticScene.metricNote;
        if (backwordEl) backwordEl.textContent = staticScene.backword;
        if (ghostwordEl) ghostwordEl.textContent = staticScene.ghostword;
        markers.forEach((marker) => marker.classList.toggle(
          'is-active',
          marker.dataset.qdxMarker === 'hero-start'
        ));
        section.dataset.qdxChapterMode = 'reduced-motion';
        section.dataset.qdxDesiredFrame = '1';
        section.dataset.qdxDisplayedFrame = '0';
        section.dataset.qdxDesiredSource = String(frames[0].sourceFrame);
        section.dataset.qdxDisplayedSource = '0';
        section.dataset.qdxCacheReady = '0';
        section.dataset.qdxInFlight = '0';
        section.dataset.qdxRetries = '0';
        section.dataset.qdxMaxDrawJump = '0';
        section.dataset.qdxLongestHoldMs = '0';
        section.style.setProperty('--qdx-progress', '0');
        section.dataset.scene = 'hero-start';
        poster.hidden = false;
        return;
      }

      let raf = 0;
      let activeSceneId = '';
      let displayedFrame = 0;
      let desiredFrame = 1;
      let visualPosition = 0;
      let desiredSource = frames[0].sourceFrame;
      let displayedSource = 0;
      let copyTimer = 0;
      let lastRenderTime = performance.now();
      let lastDrawTime = 0;
      let maxDrawJump = 0;
      let longestHoldMs = 0;
      let stableViewportWidth = window.innerWidth;
      let stableViewportHeight = Math.max(window.innerHeight, document.documentElement.clientHeight, 1);
      let chapterObserver = null;
      let chapterTrigger = null;
      let chapterTween = null;
      let chapterObserverEnabled = false;
      let chapterInputArmed = true;
      let wheelActive = false;
      let frameLoader;

      const playbackTargetForSource = (source, direction = 0) => {
        if (source <= playbackFrames[0].sourceFrame) {
          return { index: playbackFrames[0].index, position: 0 };
        }
        if (source >= playbackFrames[playbackFrames.length - 1].sourceFrame) {
          return {
            index: playbackFrames[playbackFrames.length - 1].index,
            position: playbackFrames.length - 1,
          };
        }

        let low = 0;
        let high = playbackFrames.length - 1;
        while (low <= high) {
          const middle = Math.floor((low + high) / 2);
          const middleSource = playbackFrames[middle].sourceFrame;
          if (middleSource === source) return { index: playbackFrames[middle].index, position: middle };
          if (middleSource < source) low = middle + 1;
          else high = middle - 1;
        }

        const beforePosition = Math.max(high, 0);
        const afterPosition = Math.min(low, playbackFrames.length - 1);
        const before = playbackFrames[beforePosition];
        const after = playbackFrames[afterPosition];
        const beforeDistance = Math.abs(source - before.sourceFrame);
        const afterDistance = Math.abs(after.sourceFrame - source);
        if (beforeDistance === afterDistance && direction !== 0) {
          return direction > 0
            ? { index: after.index, position: afterPosition }
            : { index: before.index, position: beforePosition };
        }
        return beforeDistance <= afterDistance
          ? { index: before.index, position: beforePosition }
          : { index: after.index, position: afterPosition };
      };

      const displayIndexForSource = (source, direction = 0) => playbackTargetForSource(source, direction).index;

      const updateLoaderStats = (stats) => {
        section.dataset.qdxCacheReady = String(stats.ready);
        section.dataset.qdxInFlight = String(stats.inFlight);
        section.dataset.qdxRetries = String(stats.retries);
      };

      const updateMotionStats = (timestamp = performance.now()) => {
        if (lastDrawTime && displayedFrame !== desiredFrame) {
          longestHoldMs = Math.max(longestHoldMs, timestamp - lastDrawTime);
        }
        section.dataset.qdxDesiredFrame = String(desiredFrame);
        section.dataset.qdxDisplayedFrame = String(displayedFrame);
        section.dataset.qdxDesiredSource = String(Math.round(desiredSource));
        section.dataset.qdxDisplayedSource = String(displayedSource);
        section.dataset.qdxMaxDrawJump = String(maxDrawJump);
        section.dataset.qdxLongestHoldMs = String(Math.round(longestHoldMs));
      };

      const drawFrame = (entry) => {
        if (!entry || entry.state !== 'ready') return;
        if (!entry.image || !entry.image.complete || entry.image.naturalWidth < 1) return;
        if (entry.index === displayedFrame) return;
        if (displayedFrame === 0 && entry.index !== desiredFrame) return;

        if (displayedFrame > 0) {
          const lower = Math.min(displayedFrame, desiredFrame);
          const upper = Math.max(displayedFrame, desiredFrame);
          const advancesTowardTarget = entry.index >= lower &&
            entry.index <= upper &&
            Math.abs(desiredFrame - entry.index) < Math.abs(desiredFrame - displayedFrame);
          if (!advancesTowardTarget) return;
        }

        const now = performance.now();
        if (displayedFrame > 0) {
          maxDrawJump = Math.max(maxDrawJump, Math.abs(entry.index - displayedFrame));
          if (lastDrawTime && displayedFrame !== desiredFrame) {
            longestHoldMs = Math.max(longestHoldMs, now - lastDrawTime);
          }
        }
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(entry.image, 0, 0, canvas.width, canvas.height);
        canvas.dataset.qdxFrame = String(entry.index);
        canvas.dataset.qdxSource = String(entry.frame.sourceFrame);
        canvas.dataset.qdxSourceFrame = String(entry.frame.sourceFrame);
        canvas.classList.add('is-ready');
        poster.hidden = true;
        displayedFrame = entry.index;
        displayedSource = entry.frame.sourceFrame;
        lastDrawTime = now;
        updateMotionStats(now);
      };

      frameLoader = createFrameLoader(frames, (entry) => {
        drawFrame(entry);
      }, updateLoaderStats);

      const sceneForProgress = (progress) => {
        return scenes.find((scene, index) => {
          const isLast = index === scenes.length - 1;
          return progress >= scene.from && (isLast ? progress <= scene.to : progress <= scene.to);
        }) || scenes[scenes.length - 1];
      };

      const applySceneCopy = (scene) => {
        if (eyebrowEl && eyebrowEl.textContent !== scene.eyebrow) eyebrowEl.textContent = scene.eyebrow;
        if (titleEl && titleEl.textContent !== scene.title) titleEl.textContent = scene.title;
        if (bodyEl && bodyEl.textContent !== scene.body) bodyEl.textContent = scene.body;
        if (metricEl && metricEl.textContent !== scene.metric) metricEl.textContent = scene.metric;
        if (metricNoteEl && metricNoteEl.textContent !== scene.metricNote) metricNoteEl.textContent = scene.metricNote;
        if (backwordEl && backwordEl.textContent !== scene.backword) backwordEl.textContent = scene.backword;
        if (ghostwordEl && ghostwordEl.textContent !== scene.ghostword) ghostwordEl.textContent = scene.ghostword;

        const markerId = scene.marker || scene.id;
        markers.forEach((marker) => {
          marker.classList.toggle('is-active', marker.dataset.qdxMarker === markerId);
        });
      };

      const markStableCopy = (scene) => {
        section.classList.toggle('qdx-stable-eyebrow', Boolean(eyebrowEl && eyebrowEl.textContent === scene.eyebrow));
        section.classList.toggle('qdx-stable-title', Boolean(titleEl && titleEl.textContent === scene.title));
        section.classList.toggle('qdx-stable-body', Boolean(bodyEl && bodyEl.textContent === scene.body));
        section.classList.toggle('qdx-stable-metric', Boolean(
          metricEl &&
          metricNoteEl &&
          metricEl.textContent === scene.metric &&
          metricNoteEl.textContent === scene.metricNote
        ));
      };

      const clearStableCopy = () => {
        section.classList.remove('qdx-stable-eyebrow', 'qdx-stable-title', 'qdx-stable-body', 'qdx-stable-metric');
      };

      const setScene = (scene) => {
        if (activeSceneId === scene.id) return;
        const hadScene = Boolean(activeSceneId);
        activeSceneId = scene.id;
        section.dataset.scene = scene.styleScene || scene.id;
        window.clearTimeout(copyTimer);

        if (!hadScene || reduceMotion) {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
          clearStableCopy();
          return;
        }

        markStableCopy(scene);
        section.classList.add('is-changing');
        copyTimer = window.setTimeout(() => {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
          clearStableCopy();
        }, 140);
      };

      const sourceForProgress = (progress, scene) => {
        if (reduceMotion) return scene.endSource;
        const local = clamp((progress - scene.from) / Math.max(scene.to - scene.from, 0.0001), 0, 1);
        const curve = scene.sourceCurve;
        if (!Array.isArray(curve) || curve.length < 2) {
          return scene.startSource + (scene.endSource - scene.startSource) * local;
        }

        const upperIndex = curve.findIndex((point) => local <= point.at);
        if (upperIndex <= 0) return curve[0].source;
        if (upperIndex < 0) return curve[curve.length - 1].source;
        const lowerPoint = curve[upperIndex - 1];
        const upperPoint = curve[upperIndex];
        const segmentProgress = clamp(
          (local - lowerPoint.at) / Math.max(upperPoint.at - lowerPoint.at, 0.0001),
          0,
          1
        );
        return lowerPoint.source + (upperPoint.source - lowerPoint.source) * segmentProgress;
      };

      const frameForProgress = (progress, scene, direction = 0) => {
        const source = sourceForProgress(progress, scene);
        return { ...playbackTargetForSource(source, direction), source };
      };

      const sectionProgress = () => {
        if (reduceMotion) return 1;
        const rect = section.getBoundingClientRect();
        const viewportHeight = mobilePlayback ? stableViewportHeight : window.innerHeight;
        const travel = Math.max(rect.height - viewportHeight, 1);
        return clamp(-rect.top / travel, 0, 1);
      };

      const render = (timestamp = performance.now()) => {
        raf = 0;
        const progress = sectionProgress();
        const scene = sceneForProgress(progress);
        const sourceDirection = Math.sign(sourceForProgress(progress, scene) - desiredSource);
        const target = frameForProgress(progress, scene, sourceDirection);
        const targetFrame = target.index;
        const elapsed = clamp(timestamp - lastRenderTime, 8, 48);
        let frame = targetFrame;

        if (mobilePlayback && !reduceMotion) {
          const delta = target.position - visualPosition;
          if (Math.abs(delta) < 0.45) {
            visualPosition = target.position;
          } else {
            const maxStep = clamp((elapsed / 16.67) * 2.4, 1.2, 4.2);
            visualPosition += clamp(delta * 0.24, -maxStep, maxStep);
          }
          frame = playbackFrames[clamp(Math.round(visualPosition), 0, playbackFrames.length - 1)].index;
        } else {
          visualPosition = target.position;
        }

        const direction = frame >= Math.max(displayedFrame, 1) ? 1 : -1;

        section.style.setProperty('--qdx-progress', progress.toFixed(4));
        setScene(scene);
        desiredFrame = frame;
        desiredSource = target.source;
        const entry = frameLoader.schedule(frame, direction);
        const readyEntry = entry?.state === 'ready'
          ? entry
          : frameLoader.nearestReady(frame, Math.max(displayedFrame, 1));
        if (readyEntry) drawFrame(readyEntry);
        updateMotionStats(timestamp);
        lastRenderTime = timestamp;

        if (mobilePlayback && Math.abs(target.position - visualPosition) >= 0.45) {
          raf = window.requestAnimationFrame(render);
        }
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      const handleViewportResize = () => {
        const nextWidth = window.innerWidth;
        if (!mobilePlayback || Math.abs(nextWidth - stableViewportWidth) > 40) {
          stableViewportWidth = nextWidth;
          stableViewportHeight = Math.max(window.innerHeight, document.documentElement.clientHeight, 1);
        }
        requestRender();
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', handleViewportResize);
      requestRender();

      const chapterStops = [
        { progress: 0, source: scenes[0].startSource },
        ...scenes.map((scene) => ({ progress: scene.to, source: scene.endSource })),
      ].filter((stop, index, values) => index === 0 || stop.progress !== values[index - 1].progress);

      const nearestStopIndex = (progress) => {
        return chapterStops.reduce((bestIndex, stop, index) => {
          const bestDistance = Math.abs(chapterStops[bestIndex].progress - progress);
          return Math.abs(stop.progress - progress) < bestDistance ? index : bestIndex;
        }, 0);
      };

      const warmAdjacentChapters = (progress) => {
        const stopIndex = nearestStopIndex(progress);
        const current = chapterStops[stopIndex];
        const currentFrame = displayIndexForSource(current.source);
        const previous = chapterStops[stopIndex - 1];
        const next = chapterStops[stopIndex + 1];
        if (next) frameLoader.prewarmCorridor(currentFrame, displayIndexForSource(next.source, 1), false);
        if (previous) frameLoader.prewarmCorridor(currentFrame, displayIndexForSource(previous.source, -1), true);
      };

      const scheduleIdleWarm = (progress) => {
        const warm = () => {
          if (!section.isConnected || chapterTween?.isActive()) return;
          warmAdjacentChapters(progress);
        };
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(warm, { timeout: 900 });
        } else {
          window.setTimeout(warm, 160);
        }
      };

      const setChapterObserver = (enabled) => {
        if (!chapterObserver) return;
        chapterObserverEnabled = enabled;
        if (enabled) {
          chapterInputArmed = true;
          wheelActive = false;
          chapterObserver.enable();
        } else {
          chapterObserver.disable();
        }
      };

      const releaseChapterEdge = (direction) => {
        chapterInputArmed = true;
        wheelActive = false;
        setChapterObserver(false);
        window.requestAnimationFrame(() => window.scrollBy(0, direction * 4));
      };

      const handleChapterKey = (event) => {
        if (!chapterObserverEnabled) return;
        const nextKeys = ['ArrowDown', 'PageDown', ' '];
        const previousKeys = ['ArrowUp', 'PageUp'];
        if (!nextKeys.includes(event.key) && !previousKeys.includes(event.key)) return;
        event.preventDefault();
        playChapter(nextKeys.includes(event.key) ? 1 : -1);
      };

      const playChapter = (direction) => {
        if (!chapterObserver || chapterTween?.isActive()) return;

        const current = sectionProgress();
        const epsilon = 0.012;
        const target = direction > 0
          ? chapterStops.find((stop) => stop.progress > current + epsilon)
          : [...chapterStops].reverse().find((stop) => stop.progress < current - epsilon);

        if (!target) {
          releaseChapterEdge(direction);
          return;
        }

        const landingProgress = target.progress;
        const targetFrame = displayIndexForSource(target.source, direction);
        const transitionProgress = clamp(current + direction * 0.0001, 0, 1);
        const transitionScene = sceneForProgress(transitionProgress);
        frameLoader.prewarmCorridor(Math.max(displayedFrame, 1), targetFrame, false);

        const rect = section.getBoundingClientRect();
        const sectionTop = window.scrollY + rect.top;
        const travel = Math.max(section.offsetHeight - window.innerHeight, 1);
        const targetY = sectionTop + travel * landingProgress;
        const proxy = { y: window.scrollY };
        const duration = transitionScene.duration || 1.2;

        section.dataset.qdxChapterPlaying = 'true';
        section.dataset.qdxChapterTargetSource = String(target.source);
        chapterTween = window.gsap.to(proxy, {
          y: targetY,
          duration,
          ease: 'none',
          overwrite: true,
          onUpdate: () => {
            window.scrollTo(0, proxy.y);
            requestRender();
          },
          onComplete: () => {
            chapterTween = null;
            delete section.dataset.qdxChapterPlaying;
            requestRender();
            scheduleIdleWarm(landingProgress);
            if (!wheelActive) chapterInputArmed = true;
          },
          onInterrupt: () => {
            chapterTween = null;
            delete section.dataset.qdxChapterPlaying;
            if (!wheelActive) chapterInputArmed = true;
          },
        });
      };

      if (!mobilePlayback && !reduceMotion) {
        ensureMotionEngine().then((motion) => {
          if (!motion || !section.isConnected) {
            section.dataset.qdxChapterMode = 'fallback';
            return;
          }

          const { ScrollTrigger } = motion;
          section.dataset.qdxChapterMode = 'gsap';
          chapterObserver = ScrollTrigger.observe({
            target: window,
            type: 'wheel',
            preventDefault: true,
            tolerance: 18,
            onChangeY: (observer) => {
              wheelActive = true;
              if (!chapterInputArmed) return;
              chapterInputArmed = false;
              playChapter(observer.deltaY > 0 ? 1 : -1);
            },
            onStopDelay: 0.16,
            onStop: () => {
              wheelActive = false;
              if (!chapterTween?.isActive()) chapterInputArmed = true;
            },
          });
          chapterObserver.disable();

          chapterTrigger = ScrollTrigger.create({
            trigger: section,
            start: 'top top',
            end: 'bottom bottom',
            onEnter: () => setChapterObserver(true),
            onEnterBack: () => setChapterObserver(true),
            onLeave: () => setChapterObserver(false),
            onLeaveBack: () => {
              const rect = section.getBoundingClientRect();
              setChapterObserver(rect.top <= 1 && rect.bottom >= window.innerHeight);
            },
          });

          document.addEventListener('keydown', handleChapterKey);
          ScrollTrigger.refresh();
          const currentRect = section.getBoundingClientRect();
          if (currentRect.top <= 1 && currentRect.bottom >= window.innerHeight) {
            setChapterObserver(true);
          }
          scheduleIdleWarm(sectionProgress());
        });
      } else {
        section.dataset.qdxChapterMode = reduceMotion ? 'reduced-motion' : 'mobile-scrub';
        scheduleIdleWarm(sectionProgress());
      }

      section.qdxCleanup = () => {
        window.removeEventListener('scroll', requestRender);
        window.removeEventListener('resize', handleViewportResize);
        document.removeEventListener('keydown', handleChapterKey);
        if (raf) window.cancelAnimationFrame(raf);
        if (chapterTween) chapterTween.kill();
        if (chapterObserver) chapterObserver.kill();
        if (chapterTrigger) chapterTrigger.kill();
        if (frameLoader) frameLoader.destroy();
      };
    };

    const initBridge = (bridge) => {
      if (bridge.dataset.qdxBridgeReady === 'true') return;
      bridge.dataset.qdxBridgeReady = 'true';

      const setProgress = (progress) => {
        const eased = smooth(clamp(progress, 0, 1));

        bridge.style.setProperty('--qdx-bridge-photo-opacity', (0.34 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-photo-scale', (1.08 - eased * 0.035).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-copy-y', `${(28 - eased * 42).toFixed(2)}px`);
        bridge.style.setProperty('--qdx-bridge-copy-opacity', (0.72 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-line', Math.min(1, eased * 1.06).toFixed(3));
      };

      if (reduceMotion) {
        setProgress(1);
        return;
      }

      let raf = 0;

      const render = () => {
        raf = 0;
        const rect = bridge.getBoundingClientRect();
        const distance = Math.max(rect.height - window.innerHeight, 1);
        const progress = clamp(-rect.top / distance, 0, 1);
        setProgress(progress);
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initReveal = (root) => {
      const items = Array.from(root.querySelectorAll('[data-qdx-reveal]'));
      if (!items.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    };

    const initHeaderChrome = (root) => {
      if (!root || document.body.dataset.qdxHeaderReady === 'true') return;
      document.body.dataset.qdxHeaderReady = 'true';
      document.body.classList.add('qdx-cinema-active');

      let lastY = window.scrollY;
      let raf = 0;

      const render = () => {
        raf = 0;
        const y = window.scrollY;
        const rect = root.getBoundingClientRect();
        const inExplorer = rect.bottom > 80 && rect.top < window.innerHeight;
        const scrollingDown = y > lastY + 3;
        const scrollingUp = y < lastY - 10;
        const pastTop = y > 60 && rect.top < 0;

        document.body.classList.toggle('qdx-header-soft', inExplorer && pastTop);

        if (!inExplorer || !pastTop || scrollingUp) {
          document.body.classList.remove('qdx-header-hidden');
        } else if (scrollingDown) {
          document.body.classList.add('qdx-header-hidden');
        }

        lastY = y;
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initAll = (root) => {
      root.querySelectorAll('[data-qdx-scroll]').forEach(initScroll);
      root.querySelectorAll('[data-qdx-bridge]').forEach(initBridge);
      root.querySelectorAll('[data-qdx-root]').forEach(initReveal);
      root.querySelectorAll('[data-qdx-root]').forEach(initHeaderChrome);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-qdx-scroll]').forEach((section) => section.qdxCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-explorer-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const smooth = (value) => value * value * (3 - 2 * value);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobilePlayback = window.matchMedia('(pointer: coarse)').matches || window.matchMedia('(max-width: 989px)').matches;

    const scenes = [
      {
        id: 'hero-start',
        from: 0,
        to: 0.16,
        startSource: 1,
        endSource: 125,
        duration: 1.65,
        eyebrow: 'QuadDrive Explorer',
        title: 'Build the drive your work actually needs.',
        body: 'A 4-bay USB4 NVMe enclosure for creators, engineers, and mobile workstations that outgrow sealed external SSDs.',
        metric: '4-Bay USB4',
        metricNote: 'QuadDrive enclosure plus 65W USB-C PD adapter. SSDs sold separately.',
        backword: 'QUADDRIVE',
        ghostword: 'USB4'
      },
      {
          id: 'install-nvme-1',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.16,
          to: 0.30,
          startSource: 125,
          endSource: 293,
          sourceCurve: [
            { at: 0, source: 125 },
            { at: 0.72, source: 285 },
            { at: 0.87, source: 293 },
            { at: 1, source: 293 }
          ],
          duration: 1.85,
          eyebrow: 'Install 1 of 4',
          title: 'Start with one NVMe.',
          body: 'Install the first 2230, 2242, or 2280 M.2 NVMe SSD. Three bays stay open for future capacity.',
          metric: 'NVMe 1 / 4',
          metricNote: 'First drive installed. Scroll once to add the next NVMe.',
          backword: 'NVME 1',
          ghostword: '1 / 4'
      },
      {
          id: 'install-nvme-2',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.30,
          to: 0.42,
          startSource: 293,
          endSource: 313,
          sourceCurve: [
            { at: 0, source: 293 },
            { at: 0.18, source: 293 },
            { at: 0.82, source: 313 },
            { at: 1, source: 313 }
          ],
          duration: 1.05,
          eyebrow: 'Install 2 of 4',
          title: 'Add the second NVMe.',
          body: 'Populate the second bay when the workflow needs more capacity, another volume, or a multi-drive array.',
          metric: 'NVMe 2 / 4',
          metricNote: 'Two drives installed. Two bays remain open.',
          backword: 'NVME 2',
          ghostword: '2 / 4'
      },
      {
          id: 'install-nvme-3',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.42,
          to: 0.54,
          startSource: 313,
          endSource: 337,
          sourceCurve: [
            { at: 0, source: 313 },
            { at: 0.16, source: 313 },
            { at: 0.84, source: 337 },
            { at: 1, source: 337 }
          ],
          duration: 1.2,
          eyebrow: 'Install 3 of 4',
          title: 'Add the third NVMe.',
          body: 'Use the third bay for additional project media, scratch space, or the next stage of your storage plan.',
          metric: 'NVMe 3 / 4',
          metricNote: 'Three drives installed. One bay remains open.',
          backword: 'NVME 3',
          ghostword: '3 / 4'
      },
      {
          id: 'install-nvme-4',
          styleScene: 'four-nvme',
          marker: 'four-nvme',
          from: 0.54,
          to: 0.68,
          startSource: 337,
          endSource: 357,
          sourceCurve: [
            { at: 0, source: 337 },
            { at: 0.20, source: 337 },
            { at: 0.80, source: 357 },
            { at: 1, source: 357 }
          ],
          duration: 1.1,
          eyebrow: 'Install 4 of 4',
          title: 'Fill the fourth bay.',
          body: 'Populate all four NVMe bays when the job calls for maximum flexibility, capacity, or a four-drive workflow.',
          metric: 'NVMe 4 / 4',
          metricNote: 'All four bays populated. Scroll to continue to USB4 performance.',
          backword: '4 NVME',
          ghostword: '4 / 4'
      },
      {
        id: 'io-transition',
        marker: 'thunderbolt',
        from: 0.68,
        to: 0.80,
        startSource: 357,
        endSource: 461,
        sourceCurve: [
          { at: 0, source: 357 },
          { at: 0.14, source: 357 },
          { at: 0.20, source: 413 },
          { at: 1, source: 461 }
        ],
        duration: 1.35,
        eyebrow: 'Thunderbolt-class USB4',
        title: 'Thunderbolt speed. Separate PD power.',
        body: 'The camera moves from the four-bay build to the I/O edge before the speed story lands.',
        metric: 'Up to 3200MB/s',
        metricNote: 'Single NVMe up to 1600MB/s. Multi-drive workflows up to 3200MB/s.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'thunderbolt',
        from: 0.80,
        to: 0.88,
        startSource: 461,
        endSource: 505,
        duration: 1.05,
        eyebrow: 'Thunderbolt-class USB4',
        title: 'Thunderbolt speed. Separate PD power.',
        body: 'One USB-C link carries USB4 and Thunderbolt-class data. A separate USB-C PD input feeds stable power to the four-drive system while data moves fast.',
        metric: 'Up to 3200MB/s',
        metricNote: 'Single NVMe up to 1600MB/s. Multi-drive workflows up to 3200MB/s.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'hero-return',
        from: 0.88,
        to: 1,
        startSource: 505,
        endSource: 601,
        duration: 1.3,
        eyebrow: 'Ready for work',
        title: 'One compact box. A storage plan that keeps growing.',
        body: 'For project media, scratch disks, backup staging, and lab work that needs fast removable NVMe storage without cable clutter.',
        metric: 'Build yours',
        metricNote: 'Order the enclosure, then choose the SSD capacity that fits your workflow.',
        backword: 'READY',
        ghostword: 'SSD'
      }
    ];

    const motionVersion = '3.15.0';
    const motionUrls = {
      gsap: `https://cdn.jsdelivr.net/npm/gsap@${motionVersion}/dist/gsap.min.js`,
      scrollTrigger: `https://cdn.jsdelivr.net/npm/gsap@${motionVersion}/dist/ScrollTrigger.min.js`,
    };

    const loadScriptOnce = (src, id, ready) => {
      if (ready()) return Promise.resolve();

      return new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[data-qdx-motion="${id}"]`);
        const handleLoad = () => ready() ? resolve() : reject(new Error(`${id} did not initialize`));
        const handleError = () => reject(new Error(`${id} failed to load`));

        if (existing) {
          existing.addEventListener('load', handleLoad, { once: true });
          existing.addEventListener('error', handleError, { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.dataset.qdxMotion = id;
        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
        document.head.appendChild(script);
      });
    };

    const ensureMotionEngine = () => {
      if (window.gsap && window.ScrollTrigger) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        return Promise.resolve({ gsap: window.gsap, ScrollTrigger: window.ScrollTrigger });
      }

      if (!window.__qdxMotionPromise) {
        window.__qdxMotionPromise = loadScriptOnce(motionUrls.gsap, 'gsap', () => Boolean(window.gsap))
          .then(() => loadScriptOnce(
            motionUrls.scrollTrigger,
            'scroll-trigger',
            () => Boolean(window.ScrollTrigger)
          ))
          .then(() => {
            window.gsap.registerPlugin(window.ScrollTrigger);
            return { gsap: window.gsap, ScrollTrigger: window.ScrollTrigger };
          })
          .catch(() => null);
      }

      return window.__qdxMotionPromise;
    };

    const createFrameLoader = (frames, onReady, onStats) => {
      const reportedMemory = Number(navigator.deviceMemory);
      const lowMemory = Number.isFinite(reportedMemory) && reportedMemory <= 4;
      const constrained = mobilePlayback || lowMemory;
      const maxConcurrent = constrained ? 2 : 4;
      const maxReady = mobilePlayback ? 6 : (lowMemory ? 8 : 14);
      const ahead = constrained ? 4 : 10;
      const behind = constrained ? 1 : 3;
      const maxQueued = constrained ? 18 : 36;
      const requestTimeout = constrained ? 12000 : 10000;
      const maxAttempts = 2;
      const coreIndices = Array.from(new Set([
        1,
        ...frames.filter((frame) => frame.core).map((frame) => frame.index),
        frames.length,
      ])).sort((a, b) => a - b);
      const eligibleIndices = constrained && coreIndices.length ? coreIndices : frames.map((frame) => frame.index);
      const entries = new Map();
      let queue = [];
      let activeLoads = 0;
      let touch = 0;
      let totalRetries = 0;
      let centerIndex = 1;
      let directionIntent = 1;
      let destroyed = false;

      const normalizeIndex = (index, direction = 0) => {
        const requested = clamp(Math.round(index), 1, frames.length);
        if (!constrained || eligibleIndices.length === frames.length) return requested;

        let low = 0;
        let high = eligibleIndices.length - 1;
        while (low <= high) {
          const middle = Math.floor((low + high) / 2);
          if (eligibleIndices[middle] === requested) return requested;
          if (eligibleIndices[middle] < requested) low = middle + 1;
          else high = middle - 1;
        }

        const before = eligibleIndices[Math.max(high, 0)];
        const after = eligibleIndices[Math.min(low, eligibleIndices.length - 1)];
        const beforeDistance = Math.abs(requested - before);
        const afterDistance = Math.abs(after - requested);
        if (beforeDistance === afterDistance && direction !== 0) return direction > 0 ? after : before;
        return beforeDistance <= afterDistance ? before : after;
      };

      const eligibleOffset = (index, offset) => {
        const normalized = normalizeIndex(index, Math.sign(offset));
        const position = eligibleIndices.indexOf(normalized);
        return eligibleIndices[clamp(position + offset, 0, eligibleIndices.length - 1)];
      };

      const reportStats = () => {
        if (!onStats) return;
        onStats({
          ready: Array.from(entries.values()).filter((entry) => entry.state === 'ready').length,
          inFlight: activeLoads,
          retries: totalRetries,
        });
      };

      const releaseEntry = (entry) => {
        if (!entry?.image) return;
        window.clearTimeout(entry.timeoutId);
        entry.image.onload = null;
        entry.image.onerror = null;
        entry.image.removeAttribute('src');
        entry.image = null;
      };

      const trim = () => {
        let readyCount = Array.from(entries.values()).filter((entry) => entry.state === 'ready').length;
        while (readyCount > maxReady) {
          const now = performance.now();
          const entry = Array.from(entries.values())
            .filter((candidate) => candidate.state === 'ready' && candidate.index !== centerIndex)
            .sort((a, b) => {
              const pinned = Number(a.pinUntil > now) - Number(b.pinUntil > now);
              if (pinned) return pinned;
              const core = Number(a.frame.core) - Number(b.frame.core);
              if (core) return core;
              const distance = Math.abs(b.index - centerIndex) - Math.abs(a.index - centerIndex);
              return distance || a.touched - b.touched;
            })[0];
          if (!entry) break;
          entries.delete(entry.index);
          releaseEntry(entry);
          readyCount -= 1;
        }
      };

      const queueScore = (entry) => {
        if (entry.index === centerIndex) return -1000;
        const directionalDistance = (entry.index - centerIndex) * directionIntent;
        const behindPenalty = directionalDistance < 0 ? 20 : 0;
        const activeBoost = entry.pinUntil > performance.now() ? entry.priority : 0;
        const coreBoost = entry.frame.core ? -8 : 0;
        return activeBoost + coreBoost + behindPenalty + Math.abs(entry.index - centerIndex);
      };

      const sortAndLimitQueue = () => {
        queue = queue.filter((entry) => entry.state === 'queued');
        queue.sort((a, b) => queueScore(a) - queueScore(b) || a.queuedAt - b.queuedAt);
        if (queue.length <= maxQueued) return;
        queue.splice(maxQueued).forEach((entry) => {
          if (entry.state !== 'queued') return;
          entries.delete(entry.index);
          releaseEntry(entry);
        });
      };

      const ensure = (index, priority = 0, pinMs = 0) => {
        const safeIndex = normalizeIndex(index);
        const existing = entries.get(safeIndex);
        if (existing) {
          existing.priority = Math.min(existing.priority, priority);
          existing.pinUntil = Math.max(existing.pinUntil, performance.now() + pinMs);
          existing.touched = ++touch;
          return existing;
        }

        const entry = {
          index: safeIndex,
          frame: frames[safeIndex - 1],
          state: 'queued',
          image: null,
          touched: ++touch,
          queuedAt: touch,
          priority,
          pinUntil: performance.now() + pinMs,
          attempts: 0,
          loadToken: 0,
          timeoutId: 0,
        };
        entries.set(safeIndex, entry);
        queue.push(entry);
        return entry;
      };

      const pump = () => {
        if (destroyed) return;
        sortAndLimitQueue();
        while (activeLoads < maxConcurrent && queue.length) {
          const entry = queue.shift();
          if (!entry || entry.state !== 'queued') continue;

          entry.state = 'loading';
          entry.attempts += 1;
          entry.loadToken += 1;
          const loadToken = entry.loadToken;
          activeLoads += 1;

          const image = new Image();
          image.decoding = 'async';
          image.fetchPriority = entry.index === centerIndex || entry.priority <= -200 ? 'high' : 'low';
          entry.image = image;

          const finish = (state) => {
            if (entry.state !== 'loading' || entry.loadToken !== loadToken) return;
            window.clearTimeout(entry.timeoutId);
            image.onload = null;
            image.onerror = null;
            entry.touched = ++touch;
            activeLoads -= 1;

            if (state === 'ready') {
              entry.state = 'ready';
              trim();
              onReady(entry);
            } else if (entry.attempts < maxAttempts) {
              image.removeAttribute('src');
              entry.image = null;
              entry.state = 'queued';
              entry.priority -= 8;
              entry.queuedAt = ++touch;
              totalRetries += 1;
              queue.push(entry);
            } else {
              image.removeAttribute('src');
              entry.image = null;
              entry.state = 'error';
            }

            reportStats();
            pump();
          };

          image.onload = () => {
            if (typeof image.decode === 'function') {
              image.decode().catch(() => {}).then(() => finish('ready'));
            } else {
              finish('ready');
            }
          };
          image.onerror = () => finish('error');
          entry.timeoutId = window.setTimeout(() => finish('error'), requestTimeout);
          image.src = entry.frame.url;
          reportStats();
        }
      };

      const schedule = (index, direction) => {
        centerIndex = normalizeIndex(index, direction);
        directionIntent = direction >= 0 ? 1 : -1;
        ensure(centerIndex, -240, 140);

        for (let offset = 1; offset <= ahead; offset += 1) {
          ensure(eligibleOffset(centerIndex, offset * directionIntent), -120 + offset, 80);
        }
        for (let offset = 1; offset <= behind; offset += 1) {
          ensure(eligibleOffset(centerIndex, -offset * directionIntent), -40 + offset, 60);
        }

        sortAndLimitQueue();
        trim();
        pump();
        return entries.get(centerIndex);
      };

      const nearestReady = (index, fromIndex) => {
        const lower = Math.min(index, fromIndex);
        const upper = Math.max(index, fromIndex);
        return Array.from(entries.values())
          .filter((entry) => entry.state === 'ready' && entry.index >= lower && entry.index <= upper)
          .sort((a, b) => Math.abs(a.index - index) - Math.abs(b.index - index))[0] || null;
      };

      const prewarmCorridor = (fromIndex, toIndex, compact = false) => {
        const from = normalizeIndex(fromIndex, Math.sign(toIndex - fromIndex));
        const to = normalizeIndex(toIndex, Math.sign(toIndex - fromIndex));
        const direction = to >= from ? 1 : -1;
        const span = Math.abs(to - from);
        const budget = compact ? (constrained ? 3 : 5) : (constrained ? 6 : 10);
        const candidates = [{ index: to, priority: -320 }];

        for (let offset = 1; offset <= Math.min(3, span); offset += 1) {
          candidates.push({ index: eligibleOffset(from, offset * direction), priority: -280 + offset });
        }

        frames.forEach((frame, frameOffset) => {
          const index = frameOffset + 1;
          if (!frame.core || index === from || index === to) return;
          if (index < Math.min(from, to) || index > Math.max(from, to)) return;
          candidates.push({ index, priority: -220 + Math.abs(index - from) * 0.01 });
        });

        [0.25, 0.5, 0.75].forEach((ratio, ratioIndex) => {
          candidates.push({
            index: Math.round(from + (to - from) * ratio),
            priority: -180 + ratioIndex,
          });
        });

        const seen = new Set();
        candidates
          .sort((a, b) => a.priority - b.priority)
          .filter((candidate) => {
            const index = normalizeIndex(candidate.index);
            if (seen.has(index)) return false;
            seen.add(index);
            candidate.index = index;
            return true;
          })
          .slice(0, budget)
          .forEach((candidate) => ensure(candidate.index, candidate.priority, compact ? 3200 : 5000));

        sortAndLimitQueue();
        pump();
      };

      const destroy = () => {
        destroyed = true;
        queue = [];
        entries.forEach(releaseEntry);
        entries.clear();
      };

      reportStats();
      return { schedule, nearestReady, prewarmCorridor, destroy };
    };

    const initScroll = (section) => {
      if (section.dataset.qdxReady === 'true') return;
      section.dataset.qdxReady = 'true';

      const frameData = section.querySelector('[data-qdx-frames]');
      const canvas = section.querySelector('[data-qdx-frame-canvas]');
      const poster = section.querySelector('[data-qdx-frame-poster]');
      const titleEl = section.querySelector('[data-qdx-title]');
      const bodyEl = section.querySelector('[data-qdx-body]');
      const eyebrowEl = section.querySelector('[data-qdx-eyebrow]');
      const metricEl = section.querySelector('[data-qdx-metric]');
      const metricNoteEl = section.querySelector('[data-qdx-metric-note]');
      const backwordEl = section.querySelector('[data-qdx-backword]');
      const ghostwordEl = section.querySelector('[data-qdx-ghostword]');
      const markers = Array.from(section.querySelectorAll('[data-qdx-marker]'));

      if (!frameData || !canvas || !poster) return;

      const context = canvas.getContext('2d', { alpha: true, desynchronized: true });
      if (!context) return;

      let manifest = null;
      try {
        manifest = JSON.parse(frameData.textContent);
      } catch (error) {
        manifest = null;
      }

      if (!manifest || !Array.isArray(manifest.urls) || !Array.isArray(manifest.sources)) return;

      const coreSources = new Set((manifest.coreSources || []).map(Number));
      const frames = manifest.urls.map((url, index) => ({
        index: index + 1,
        url,
        sourceFrame: Number(manifest.sources[index]),
        core: coreSources.has(Number(manifest.sources[index])),
      })).filter((frame) => frame.url && Number.isFinite(frame.sourceFrame));

      if (!frames.length || frames.length !== manifest.urls.length || frames.length !== manifest.sources.length) return;
      if (frames.some((frame, index) => index > 0 && frame.sourceFrame <= frames[index - 1].sourceFrame)) return;

      const reportedMemory = Number(navigator.deviceMemory);
      const lowMemoryPlayback = Number.isFinite(reportedMemory) && reportedMemory <= 4;
      const corePlayback = mobilePlayback || lowMemoryPlayback;
      const coreFrames = frames.filter((frame, index) => frame.core || index === 0 || index === frames.length - 1);
      const playbackFrames = corePlayback && coreFrames.length ? coreFrames : frames;

      const canvasWidth = Number(manifest.width) || 1920;
      const canvasHeight = Number(manifest.height) || 1080;
      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      canvas.setAttribute('width', String(canvasWidth));
      canvas.setAttribute('height', String(canvasHeight));
      section.dataset.qdxSequenceVersion = String(manifest.version || 'unknown');
      section.dataset.qdxSequenceFrames = String(frames.length);
      section.dataset.qdxPlaybackFrames = String(playbackFrames.length);

      if (reduceMotion) {
        const staticScene = scenes[0];
        if (eyebrowEl) eyebrowEl.textContent = staticScene.eyebrow;
        if (titleEl) titleEl.textContent = staticScene.title;
        if (bodyEl) bodyEl.textContent = staticScene.body;
        if (metricEl) metricEl.textContent = staticScene.metric;
        if (metricNoteEl) metricNoteEl.textContent = staticScene.metricNote;
        if (backwordEl) backwordEl.textContent = staticScene.backword;
        if (ghostwordEl) ghostwordEl.textContent = staticScene.ghostword;
        markers.forEach((marker) => marker.classList.toggle(
          'is-active',
          marker.dataset.qdxMarker === 'hero-start'
        ));
        section.dataset.qdxChapterMode = 'reduced-motion';
        section.dataset.qdxDesiredFrame = '1';
        section.dataset.qdxDisplayedFrame = '0';
        section.dataset.qdxDesiredSource = String(frames[0].sourceFrame);
        section.dataset.qdxDisplayedSource = '0';
        section.dataset.qdxCacheReady = '0';
        section.dataset.qdxInFlight = '0';
        section.dataset.qdxRetries = '0';
        section.dataset.qdxMaxDrawJump = '0';
        section.dataset.qdxLongestHoldMs = '0';
        section.style.setProperty('--qdx-progress', '0');
        section.dataset.scene = 'hero-start';
        poster.hidden = false;
        return;
      }

      let raf = 0;
      let activeSceneId = '';
      let displayedFrame = 0;
      let desiredFrame = 1;
      let visualPosition = 0;
      let desiredSource = frames[0].sourceFrame;
      let displayedSource = 0;
      let copyTimer = 0;
      let lastRenderTime = performance.now();
      let lastDrawTime = 0;
      let maxDrawJump = 0;
      let longestHoldMs = 0;
      let stableViewportWidth = window.innerWidth;
      let stableViewportHeight = Math.max(window.innerHeight, document.documentElement.clientHeight, 1);
      let chapterObserver = null;
      let chapterTrigger = null;
      let chapterTween = null;
      let chapterObserverEnabled = false;
      let chapterInputArmed = true;
      let wheelActive = false;
      let frameLoader;

      const playbackTargetForSource = (source, direction = 0) => {
        if (source <= playbackFrames[0].sourceFrame) {
          return { index: playbackFrames[0].index, position: 0 };
        }
        if (source >= playbackFrames[playbackFrames.length - 1].sourceFrame) {
          return {
            index: playbackFrames[playbackFrames.length - 1].index,
            position: playbackFrames.length - 1,
          };
        }

        let low = 0;
        let high = playbackFrames.length - 1;
        while (low <= high) {
          const middle = Math.floor((low + high) / 2);
          const middleSource = playbackFrames[middle].sourceFrame;
          if (middleSource === source) return { index: playbackFrames[middle].index, position: middle };
          if (middleSource < source) low = middle + 1;
          else high = middle - 1;
        }

        const beforePosition = Math.max(high, 0);
        const afterPosition = Math.min(low, playbackFrames.length - 1);
        const before = playbackFrames[beforePosition];
        const after = playbackFrames[afterPosition];
        const beforeDistance = Math.abs(source - before.sourceFrame);
        const afterDistance = Math.abs(after.sourceFrame - source);
        if (beforeDistance === afterDistance && direction !== 0) {
          return direction > 0
            ? { index: after.index, position: afterPosition }
            : { index: before.index, position: beforePosition };
        }
        return beforeDistance <= afterDistance
          ? { index: before.index, position: beforePosition }
          : { index: after.index, position: afterPosition };
      };

      const displayIndexForSource = (source, direction = 0) => playbackTargetForSource(source, direction).index;

      const updateLoaderStats = (stats) => {
        section.dataset.qdxCacheReady = String(stats.ready);
        section.dataset.qdxInFlight = String(stats.inFlight);
        section.dataset.qdxRetries = String(stats.retries);
      };

      const updateMotionStats = (timestamp = performance.now()) => {
        if (lastDrawTime && displayedFrame !== desiredFrame) {
          longestHoldMs = Math.max(longestHoldMs, timestamp - lastDrawTime);
        }
        section.dataset.qdxDesiredFrame = String(desiredFrame);
        section.dataset.qdxDisplayedFrame = String(displayedFrame);
        section.dataset.qdxDesiredSource = String(Math.round(desiredSource));
        section.dataset.qdxDisplayedSource = String(displayedSource);
        section.dataset.qdxMaxDrawJump = String(maxDrawJump);
        section.dataset.qdxLongestHoldMs = String(Math.round(longestHoldMs));
      };

      const drawFrame = (entry) => {
        if (!entry || entry.state !== 'ready') return;
        if (!entry.image || !entry.image.complete || entry.image.naturalWidth < 1) return;
        if (entry.index === displayedFrame) return;
        if (displayedFrame === 0 && entry.index !== desiredFrame) return;

        if (displayedFrame > 0) {
          const lower = Math.min(displayedFrame, desiredFrame);
          const upper = Math.max(displayedFrame, desiredFrame);
          const advancesTowardTarget = entry.index >= lower &&
            entry.index <= upper &&
            Math.abs(desiredFrame - entry.index) < Math.abs(desiredFrame - displayedFrame);
          if (!advancesTowardTarget) return;
        }

        const now = performance.now();
        if (displayedFrame > 0) {
          maxDrawJump = Math.max(maxDrawJump, Math.abs(entry.index - displayedFrame));
          if (lastDrawTime && displayedFrame !== desiredFrame) {
            longestHoldMs = Math.max(longestHoldMs, now - lastDrawTime);
          }
        }
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(entry.image, 0, 0, canvas.width, canvas.height);
        canvas.dataset.qdxFrame = String(entry.index);
        canvas.dataset.qdxSource = String(entry.frame.sourceFrame);
        canvas.dataset.qdxSourceFrame = String(entry.frame.sourceFrame);
        canvas.classList.add('is-ready');
        poster.hidden = true;
        displayedFrame = entry.index;
        displayedSource = entry.frame.sourceFrame;
        lastDrawTime = now;
        updateMotionStats(now);
      };

      frameLoader = createFrameLoader(frames, (entry) => {
        drawFrame(entry);
      }, updateLoaderStats);

      const sceneForProgress = (progress) => {
        return scenes.find((scene, index) => {
          const isLast = index === scenes.length - 1;
          return progress >= scene.from && (isLast ? progress <= scene.to : progress <= scene.to);
        }) || scenes[scenes.length - 1];
      };

      const applySceneCopy = (scene) => {
        if (eyebrowEl && eyebrowEl.textContent !== scene.eyebrow) eyebrowEl.textContent = scene.eyebrow;
        if (titleEl && titleEl.textContent !== scene.title) titleEl.textContent = scene.title;
        if (bodyEl && bodyEl.textContent !== scene.body) bodyEl.textContent = scene.body;
        if (metricEl && metricEl.textContent !== scene.metric) metricEl.textContent = scene.metric;
        if (metricNoteEl && metricNoteEl.textContent !== scene.metricNote) metricNoteEl.textContent = scene.metricNote;
        if (backwordEl && backwordEl.textContent !== scene.backword) backwordEl.textContent = scene.backword;
        if (ghostwordEl && ghostwordEl.textContent !== scene.ghostword) ghostwordEl.textContent = scene.ghostword;

        const markerId = scene.marker || scene.id;
        markers.forEach((marker) => {
          marker.classList.toggle('is-active', marker.dataset.qdxMarker === markerId);
        });
      };

      const markStableCopy = (scene) => {
        section.classList.toggle('qdx-stable-eyebrow', Boolean(eyebrowEl && eyebrowEl.textContent === scene.eyebrow));
        section.classList.toggle('qdx-stable-title', Boolean(titleEl && titleEl.textContent === scene.title));
        section.classList.toggle('qdx-stable-body', Boolean(bodyEl && bodyEl.textContent === scene.body));
        section.classList.toggle('qdx-stable-metric', Boolean(
          metricEl &&
          metricNoteEl &&
          metricEl.textContent === scene.metric &&
          metricNoteEl.textContent === scene.metricNote
        ));
      };

      const clearStableCopy = () => {
        section.classList.remove('qdx-stable-eyebrow', 'qdx-stable-title', 'qdx-stable-body', 'qdx-stable-metric');
      };

      const setScene = (scene) => {
        if (activeSceneId === scene.id) return;
        const hadScene = Boolean(activeSceneId);
        activeSceneId = scene.id;
        section.dataset.scene = scene.styleScene || scene.id;
        window.clearTimeout(copyTimer);

        if (!hadScene || reduceMotion) {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
          clearStableCopy();
          return;
        }

        markStableCopy(scene);
        section.classList.add('is-changing');
        copyTimer = window.setTimeout(() => {
          applySceneCopy(scene);
          section.classList.remove('is-changing');
          clearStableCopy();
        }, 140);
      };

      const sourceForProgress = (progress, scene) => {
        if (reduceMotion) return scene.endSource;
        const local = clamp((progress - scene.from) / Math.max(scene.to - scene.from, 0.0001), 0, 1);
        const curve = scene.sourceCurve;
        if (!Array.isArray(curve) || curve.length < 2) {
          return scene.startSource + (scene.endSource - scene.startSource) * local;
        }

        const upperIndex = curve.findIndex((point) => local <= point.at);
        if (upperIndex <= 0) return curve[0].source;
        if (upperIndex < 0) return curve[curve.length - 1].source;
        const lowerPoint = curve[upperIndex - 1];
        const upperPoint = curve[upperIndex];
        const segmentProgress = clamp(
          (local - lowerPoint.at) / Math.max(upperPoint.at - lowerPoint.at, 0.0001),
          0,
          1
        );
        return lowerPoint.source + (upperPoint.source - lowerPoint.source) * segmentProgress;
      };

      const frameForProgress = (progress, scene, direction = 0) => {
        const source = sourceForProgress(progress, scene);
        return { ...playbackTargetForSource(source, direction), source };
      };

      const sectionProgress = () => {
        if (reduceMotion) return 1;
        const rect = section.getBoundingClientRect();
        const viewportHeight = mobilePlayback ? stableViewportHeight : window.innerHeight;
        const travel = Math.max(rect.height - viewportHeight, 1);
        return clamp(-rect.top / travel, 0, 1);
      };

      const render = (timestamp = performance.now()) => {
        raf = 0;
        const progress = sectionProgress();
        const scene = sceneForProgress(progress);
        const sourceDirection = Math.sign(sourceForProgress(progress, scene) - desiredSource);
        const target = frameForProgress(progress, scene, sourceDirection);
        const targetFrame = target.index;
        const elapsed = clamp(timestamp - lastRenderTime, 8, 48);
        let frame = targetFrame;

        if (mobilePlayback && !reduceMotion) {
          const delta = target.position - visualPosition;
          if (Math.abs(delta) < 0.45) {
            visualPosition = target.position;
          } else {
            const maxStep = clamp((elapsed / 16.67) * 2.4, 1.2, 4.2);
            visualPosition += clamp(delta * 0.24, -maxStep, maxStep);
          }
          frame = playbackFrames[clamp(Math.round(visualPosition), 0, playbackFrames.length - 1)].index;
        } else {
          visualPosition = target.position;
        }

        const direction = frame >= Math.max(displayedFrame, 1) ? 1 : -1;

        section.style.setProperty('--qdx-progress', progress.toFixed(4));
        setScene(scene);
        desiredFrame = frame;
        desiredSource = target.source;
        const entry = frameLoader.schedule(frame, direction);
        const readyEntry = entry?.state === 'ready'
          ? entry
          : frameLoader.nearestReady(frame, Math.max(displayedFrame, 1));
        if (readyEntry) drawFrame(readyEntry);
        updateMotionStats(timestamp);
        lastRenderTime = timestamp;

        if (mobilePlayback && Math.abs(target.position - visualPosition) >= 0.45) {
          raf = window.requestAnimationFrame(render);
        }
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      const handleViewportResize = () => {
        const nextWidth = window.innerWidth;
        if (!mobilePlayback || Math.abs(nextWidth - stableViewportWidth) > 40) {
          stableViewportWidth = nextWidth;
          stableViewportHeight = Math.max(window.innerHeight, document.documentElement.clientHeight, 1);
        }
        requestRender();
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', handleViewportResize);
      requestRender();

      const chapterStops = [
        { progress: 0, source: scenes[0].startSource },
        ...scenes.map((scene) => ({ progress: scene.to, source: scene.endSource })),
      ].filter((stop, index, values) => index === 0 || stop.progress !== values[index - 1].progress);

      const nearestStopIndex = (progress) => {
        return chapterStops.reduce((bestIndex, stop, index) => {
          const bestDistance = Math.abs(chapterStops[bestIndex].progress - progress);
          return Math.abs(stop.progress - progress) < bestDistance ? index : bestIndex;
        }, 0);
      };

      const warmAdjacentChapters = (progress) => {
        const stopIndex = nearestStopIndex(progress);
        const current = chapterStops[stopIndex];
        const currentFrame = displayIndexForSource(current.source);
        const previous = chapterStops[stopIndex - 1];
        const next = chapterStops[stopIndex + 1];
        if (next) frameLoader.prewarmCorridor(currentFrame, displayIndexForSource(next.source, 1), false);
        if (previous) frameLoader.prewarmCorridor(currentFrame, displayIndexForSource(previous.source, -1), true);
      };

      const scheduleIdleWarm = (progress) => {
        const warm = () => {
          if (!section.isConnected || chapterTween?.isActive()) return;
          warmAdjacentChapters(progress);
        };
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(warm, { timeout: 900 });
        } else {
          window.setTimeout(warm, 160);
        }
      };

      const setChapterObserver = (enabled) => {
        if (!chapterObserver) return;
        chapterObserverEnabled = enabled;
        if (enabled) {
          chapterInputArmed = true;
          wheelActive = false;
          chapterObserver.enable();
        } else {
          chapterObserver.disable();
        }
      };

      const releaseChapterEdge = (direction) => {
        chapterInputArmed = true;
        wheelActive = false;
        setChapterObserver(false);
        window.requestAnimationFrame(() => window.scrollBy(0, direction * 4));
      };

      const handleChapterKey = (event) => {
        if (!chapterObserverEnabled) return;
        const nextKeys = ['ArrowDown', 'PageDown', ' '];
        const previousKeys = ['ArrowUp', 'PageUp'];
        if (!nextKeys.includes(event.key) && !previousKeys.includes(event.key)) return;
        event.preventDefault();
        playChapter(nextKeys.includes(event.key) ? 1 : -1);
      };

      const playChapter = (direction) => {
        if (!chapterObserver || chapterTween?.isActive()) return;

        const current = sectionProgress();
        const epsilon = 0.012;
        const target = direction > 0
          ? chapterStops.find((stop) => stop.progress > current + epsilon)
          : [...chapterStops].reverse().find((stop) => stop.progress < current - epsilon);

        if (!target) {
          releaseChapterEdge(direction);
          return;
        }

        const landingProgress = target.progress;
        const targetFrame = displayIndexForSource(target.source, direction);
        const transitionProgress = clamp(current + direction * 0.0001, 0, 1);
        const transitionScene = sceneForProgress(transitionProgress);
        frameLoader.prewarmCorridor(Math.max(displayedFrame, 1), targetFrame, false);

        const rect = section.getBoundingClientRect();
        const sectionTop = window.scrollY + rect.top;
        const travel = Math.max(section.offsetHeight - window.innerHeight, 1);
        const targetY = sectionTop + travel * landingProgress;
        const proxy = { y: window.scrollY };
        const duration = transitionScene.duration || 1.2;

        section.dataset.qdxChapterPlaying = 'true';
        section.dataset.qdxChapterTargetSource = String(target.source);
        chapterTween = window.gsap.to(proxy, {
          y: targetY,
          duration,
          ease: 'none',
          overwrite: true,
          onUpdate: () => {
            window.scrollTo(0, proxy.y);
            requestRender();
          },
          onComplete: () => {
            chapterTween = null;
            delete section.dataset.qdxChapterPlaying;
            requestRender();
            scheduleIdleWarm(landingProgress);
            if (!wheelActive) chapterInputArmed = true;
          },
          onInterrupt: () => {
            chapterTween = null;
            delete section.dataset.qdxChapterPlaying;
            if (!wheelActive) chapterInputArmed = true;
          },
        });
      };

      if (!mobilePlayback && !reduceMotion) {
        ensureMotionEngine().then((motion) => {
          if (!motion || !section.isConnected) {
            section.dataset.qdxChapterMode = 'fallback';
            return;
          }

          const { ScrollTrigger } = motion;
          section.dataset.qdxChapterMode = 'gsap';
          chapterObserver = ScrollTrigger.observe({
            target: window,
            type: 'wheel',
            preventDefault: true,
            tolerance: 18,
            onChangeY: (observer) => {
              wheelActive = true;
              if (!chapterInputArmed) return;
              chapterInputArmed = false;
              playChapter(observer.deltaY > 0 ? 1 : -1);
            },
            onStopDelay: 0.16,
            onStop: () => {
              wheelActive = false;
              if (!chapterTween?.isActive()) chapterInputArmed = true;
            },
          });
          chapterObserver.disable();

          chapterTrigger = ScrollTrigger.create({
            trigger: section,
            start: 'top top',
            end: 'bottom bottom',
            onEnter: () => setChapterObserver(true),
            onEnterBack: () => setChapterObserver(true),
            onLeave: () => setChapterObserver(false),
            onLeaveBack: () => {
              const rect = section.getBoundingClientRect();
              setChapterObserver(rect.top <= 1 && rect.bottom >= window.innerHeight);
            },
          });

          document.addEventListener('keydown', handleChapterKey);
          ScrollTrigger.refresh();
          const currentRect = section.getBoundingClientRect();
          if (currentRect.top <= 1 && currentRect.bottom >= window.innerHeight) {
            setChapterObserver(true);
          }
          scheduleIdleWarm(sectionProgress());
        });
      } else {
        section.dataset.qdxChapterMode = reduceMotion ? 'reduced-motion' : 'mobile-scrub';
        scheduleIdleWarm(sectionProgress());
      }

      section.qdxCleanup = () => {
        window.removeEventListener('scroll', requestRender);
        window.removeEventListener('resize', handleViewportResize);
        document.removeEventListener('keydown', handleChapterKey);
        if (raf) window.cancelAnimationFrame(raf);
        if (chapterTween) chapterTween.kill();
        if (chapterObserver) chapterObserver.kill();
        if (chapterTrigger) chapterTrigger.kill();
        if (frameLoader) frameLoader.destroy();
      };
    };

    const initBridge = (bridge) => {
      if (bridge.dataset.qdxBridgeReady === 'true') return;
      bridge.dataset.qdxBridgeReady = 'true';

      const setProgress = (progress) => {
        const eased = smooth(clamp(progress, 0, 1));

        bridge.style.setProperty('--qdx-bridge-photo-opacity', (0.34 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-photo-scale', (1.08 - eased * 0.035).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-copy-y', `${(28 - eased * 42).toFixed(2)}px`);
        bridge.style.setProperty('--qdx-bridge-copy-opacity', (0.72 + eased * 0.28).toFixed(3));
        bridge.style.setProperty('--qdx-bridge-line', Math.min(1, eased * 1.06).toFixed(3));
      };

      if (reduceMotion) {
        setProgress(1);
        return;
      }

      let raf = 0;

      const render = () => {
        raf = 0;
        const rect = bridge.getBoundingClientRect();
        const distance = Math.max(rect.height - window.innerHeight, 1);
        const progress = clamp(-rect.top / distance, 0, 1);
        setProgress(progress);
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initReveal = (root) => {
      const items = Array.from(root.querySelectorAll('[data-qdx-reveal]'));
      if (!items.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

      items.forEach((item) => observer.observe(item));
    };

    const initHeaderChrome = (root) => {
      if (!root || document.body.dataset.qdxHeaderReady === 'true') return;
      document.body.dataset.qdxHeaderReady = 'true';
      document.body.classList.add('qdx-cinema-active');

      let lastY = window.scrollY;
      let raf = 0;

      const render = () => {
        raf = 0;
        const y = window.scrollY;
        const rect = root.getBoundingClientRect();
        const inExplorer = rect.bottom > 80 && rect.top < window.innerHeight;
        const scrollingDown = y > lastY + 3;
        const scrollingUp = y < lastY - 10;
        const pastTop = y > 60 && rect.top < 0;

        document.body.classList.toggle('qdx-header-soft', inExplorer && pastTop);

        if (!inExplorer || !pastTop || scrollingUp) {
          document.body.classList.remove('qdx-header-hidden');
        } else if (scrollingDown) {
          document.body.classList.add('qdx-header-hidden');
        }

        lastY = y;
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initAll = (root) => {
      root.querySelectorAll('[data-qdx-scroll]').forEach(initScroll);
      root.querySelectorAll('[data-qdx-bridge]').forEach(initBridge);
      root.querySelectorAll('[data-qdx-root]').forEach(initReveal);
      root.querySelectorAll('[data-qdx-root]').forEach(initHeaderChrome);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-qdx-scroll]').forEach((section) => section.qdxCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-explorer-scroll"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const scenes = [
      {
        id: 'hero-start',
        from: 0,
        to: 0.17,
        startFrame: 1,
        endFrame: 31,
        eyebrow: 'QuadDrive',
        title: 'Build your own fast storage.',
        body: 'A compact USB4 enclosure for one to four M.2 NVMe SSDs, built for creators, engineers, and mobile workstations.',
        metric: '4-Bay USB4',
        metricNote: 'Start with the enclosure. Add the SSDs you choose.',
        backword: 'QUADDRIVE',
        ghostword: 'USB4'
      },
      {
        id: 'four-nvme',
        from: 0.17,
        to: 0.68,
        startFrame: 32,
        endFrame: 103,
        eyebrow: 'Frames 032-103',
        title: 'Four NVMe bays. One clean workspace.',
        body: 'Install 1-4 M.2 2230, 2242, or 2280 NVMe SSDs, then scale up to 32TB total when projects grow.',
        metric: '4 x NVMe',
        metricNote: 'Use JBOD or OS-managed software RAID workflows.',
        backword: '4 NVME',
        ghostword: '32TB'
      },
      {
        id: 'thunderbolt',
        from: 0.68,
        to: 0.84,
        startFrame: 127,
        endFrame: 127,
        eyebrow: 'Frame 127',
        title: 'Thunderbolt-ready USB4 I/O.',
        body: 'One USB-C port carries data. One USB-C PD port supplies stable power for multi-drive operation.',
        metric: 'USB4 + PD',
        metricNote: 'Built for USB4 and Thunderbolt 3/4 hosts.',
        backword: 'USB4',
        ghostword: 'PD'
      },
      {
        id: 'hero-return',
        from: 0.84,
        to: 1,
        startFrame: 128,
        endFrame: 151,
        eyebrow: 'Frame 151',
        title: 'Compact outside. Expandable inside.',
        body: 'The launch bundle includes QuadDrive enclosure and a 65W USB-C PD adapter. SSDs are sold separately.',
        metric: 'Ready',
        metricNote: 'A palm-size external storage system for serious files.',
        backword: 'READY',
        ghostword: 'SSD'
      }
    ];

    const preloadFrame = (cache, urls, frame) => {
      const index = clamp(frame - 1, 0, urls.length - 1);
      if (cache.has(index)) return cache.get(index);

      const image = new Image();
      image.decoding = 'async';
      image.src = urls[index];
      cache.set(index, image);
      return image;
    };

    const initSection = (section) => {
      if (section.dataset.qdExplorerReady === 'true') return;
      section.dataset.qdExplorerReady = 'true';

      const frameData = section.querySelector('[data-qd-explorer-frames]');
      const imageEl = section.querySelector('[data-qd-frame-image]');
      const titleEl = section.querySelector('[data-qd-title]');
      const bodyEl = section.querySelector('[data-qd-body]');
      const eyebrowEl = section.querySelector('[data-qd-eyebrow]');
      const metricEl = section.querySelector('[data-qd-metric]');
      const metricNoteEl = section.querySelector('[data-qd-metric-note]');
      const backwordEl = section.querySelector('[data-qd-backword]');
      const ghostwordEl = section.querySelector('[data-qd-ghostword]');
      const progressEl = section.querySelector('[data-qd-progress]');
      const markers = Array.from(section.querySelectorAll('[data-qd-scene-marker]'));
      const buyLinks = Array.from(section.querySelectorAll('[data-qd-explorer-buy-link]'));

      if (!frameData || !imageEl) return;

      let urls = [];
      try {
        urls = JSON.parse(frameData.textContent);
      } catch (error) {
        urls = [];
      }

      if (!urls.length) return;

      const cache = new Map();
      let raf = 0;
      let activeSceneId = '';
      let activeFrame = 1;
      let allPreloadStarted = false;

      [1, 32, 103, 127, 151].forEach((frame) => preloadFrame(cache, urls, frame));

      const sceneForProgress = (progress) => {
        return scenes.find((scene) => progress >= scene.from && progress <= scene.to) || scenes[scenes.length - 1];
      };

      const setText = (scene) => {
        if (activeSceneId === scene.id) return;
        activeSceneId = scene.id;
        section.dataset.scene = scene.id;

        if (eyebrowEl) eyebrowEl.textContent = scene.eyebrow;
        if (titleEl) titleEl.textContent = scene.title;
        if (bodyEl) bodyEl.textContent = scene.body;
        if (metricEl) metricEl.textContent = scene.metric;
        if (metricNoteEl) metricNoteEl.textContent = scene.metricNote;
        if (backwordEl) backwordEl.textContent = scene.backword;
        if (ghostwordEl) ghostwordEl.textContent = scene.ghostword;

        markers.forEach((marker) => {
          marker.classList.toggle('is-active', marker.dataset.qdSceneMarker === scene.id);
        });
      };

      const frameForProgress = (progress, scene) => {
        if (reduceMotion) return scene.endFrame;
        const local = clamp((progress - scene.from) / Math.max(scene.to - scene.from, 0.0001), 0, 1);
        return Math.round(scene.startFrame + (scene.endFrame - scene.startFrame) * local);
      };

      const sectionProgress = () => {
        if (reduceMotion) return 1;
        const rect = section.getBoundingClientRect();
        const travel = Math.max(rect.height - window.innerHeight, 1);
        return clamp(-rect.top / travel, 0, 1);
      };

      const swapFrame = (frame) => {
        const index = clamp(frame - 1, 0, urls.length - 1);
        if (frame === activeFrame && imageEl.src === urls[index]) return;

        activeFrame = frame;
        const cached = preloadFrame(cache, urls, frame);
        imageEl.src = cached.src;

        preloadFrame(cache, urls, clamp(frame - 2, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame - 1, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame + 1, 1, urls.length));
        preloadFrame(cache, urls, clamp(frame + 2, 1, urls.length));
      };

      const preloadAll = () => {
        if (allPreloadStarted) return;
        allPreloadStarted = true;

        const load = (index) => {
          if (index >= urls.length) return;
          preloadFrame(cache, urls, index + 1);
          const schedule = window.requestIdleCallback || window.setTimeout;
          schedule(() => load(index + 1), { timeout: 700 });
        };

        load(0);
      };

      const render = () => {
        raf = 0;
        const progress = sectionProgress();
        const scene = sceneForProgress(progress);
        const frame = frameForProgress(progress, scene);

        section.style.setProperty('--qd-explorer-progress', progress.toFixed(4));
        setText(scene);
        swapFrame(frame);
        if (progress > 0.02) preloadAll();
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      buyLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = document.querySelector('product-info[id^="MainProduct"], .product__info-container, form[action*="/cart/add"]');
          if (!target) return;

          event.preventDefault();
          target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      });

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      preloadAll();
      requestRender();
    };

    const initAll = (root) => {
      root.querySelectorAll('[data-qd-explorer-scroll]').forEach(initSection);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-scroll-3d"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const loadModelViewer = () => {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

      window.Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: () => {}
        }
      ]);
    };

    const initRoot = (root) => {
      if (root.dataset.qdScrollReady === 'true') return;
      root.dataset.qdScrollReady = 'true';

      const viewer = root.querySelector('model-viewer');
      const shell = root.querySelector('.qd-scroll-3d__viewer-shell');
      const steps = Array.from(root.querySelectorAll('[data-qd-scroll-step]'));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let ticking = false;

      const update = () => {
        ticking = false;

        if (reduceMotion) return;

        const rect = root.getBoundingClientRect();
        const range = Math.max(1, rect.height - window.innerHeight);
        const progress = clamp((0 - rect.top) / range, 0, 1);
        const eased = progress * progress * (3 - 2 * progress);

        if (viewer) {
          const orbitX = -38 + eased * 258;
          const orbitY = 64 - Math.sin(eased * Math.PI) * 13;
          const orbitZ = 114 - eased * 17;
          const fov = 34 - eased * 6;

          viewer.setAttribute('camera-orbit', `${orbitX.toFixed(1)}deg ${orbitY.toFixed(1)}deg ${orbitZ.toFixed(1)}%`);
          viewer.setAttribute('field-of-view', `${fov.toFixed(1)}deg`);
        }

        if (shell) {
          shell.style.setProperty('--qd-model-scale', (0.96 + Math.sin(eased * Math.PI) * 0.08).toFixed(3));
        }

        if (steps.length) {
          const activeIndex = clamp(Math.floor(progress * steps.length), 0, steps.length - 1);
          steps.forEach((step, index) => {
            step.classList.toggle('is-active', index === activeIndex);
          });
        }
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      loadModelViewer();
      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
    };

    const init = () => {
      document.querySelectorAll('[data-qd-scroll-3d]').forEach(initRoot);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-scroll-rendered"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const initSection = (section) => {
      if (section.dataset.qdRenderedReady === 'true') return;
      section.dataset.qdRenderedReady = 'true';

      const video = section.querySelector('[data-qd-render-video]');
      const steps = Array.from(section.querySelectorAll('[data-qd-render-step]'));
      const meter = section.querySelector('[data-qd-render-meter]');
      if (!video) return;

      let raf = 0;
      let duration = 0;

      const activateStep = (progress) => {
        if (!steps.length) return;
        const index = clamp(Math.floor(progress * steps.length), 0, steps.length - 1);
        steps.forEach((step, stepIndex) => {
          step.classList.toggle('is-active', stepIndex === index);
        });
      };

      const readProgress = () => {
        if (reduceMotion) return 0;
        const rect = section.getBoundingClientRect();
        const travel = Math.max(rect.height - window.innerHeight, 1);
        return clamp(-rect.top / travel, 0, 1);
      };

      const render = () => {
        raf = 0;
        const progress = readProgress();
        section.style.setProperty('--qd-render-progress', progress.toFixed(4));
        if (meter) meter.style.transform = 'translateZ(0)';
        activateStep(progress);

        if (duration > 0 && !reduceMotion) {
          const targetTime = clamp(progress * duration, 0, duration - 0.02);
          if (Math.abs(video.currentTime - targetTime) > 0.035) {
            video.currentTime = targetTime;
          }
        }
      };

      const requestRender = () => {
        if (raf) return;
        raf = window.requestAnimationFrame(render);
      };

      const onReady = () => {
        duration = video.duration || 0;
        video.pause();
        requestRender();
      };

      video.addEventListener('loadedmetadata', onReady, { once: true });
      video.addEventListener('canplay', onReady, { once: true });
      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender);
      requestRender();
    };

    const initAll = (root) => {
      root.querySelectorAll('[data-qd-render-scroll]').forEach(initSection);
    };

    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v10"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__copy',
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-build-cinema__media',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const start = window.innerHeight * 0.72;
            const end = -rect.height + window.innerHeight * 0.34;
            const progress = reduceMotion ? 1 : clamp((start - rect.top) / Math.max(start - end, 1), 0, 1);
            const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', progress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (progress > 0.02) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v11"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__copy',
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-build-cinema__media',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const start = window.innerHeight * 0.72;
            const end = -rect.height + window.innerHeight * 0.34;
            const progress = reduceMotion ? 1 : clamp((start - rect.top) / Math.max(start - end, 1), 0, 1);
            const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', progress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (progress > 0.02) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v12"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-build-cinema__media',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const travel = Math.max(rect.height - window.innerHeight, 1);
            const progress = reduceMotion ? 1 : clamp(-rect.top / travel, 0, 1);
            const playbackProgress = reduceMotion ? 1 : clamp((progress - 0.05) / 0.86, 0, 1);
            const eased =
              playbackProgress < 0.5
                ? 2 * playbackProgress * playbackProgress
                : 1 - Math.pow(-2 * playbackProgress + 2, 2) / 2;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', progress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (progress > 0.02) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v13"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const travel = Math.max(rect.height - window.innerHeight, 1);
            const scrollProgress = reduceMotion ? 1 : clamp(-rect.top / travel, 0, 1);
            const entryProgress = reduceMotion
              ? 1
              : clamp((window.innerHeight - rect.top) / (window.innerHeight * 0.5), 0, 1);
            const playbackProgress = reduceMotion ? 1 : clamp((scrollProgress - 0.08) / 0.88, 0, 1);
            const eased = playbackProgress;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', playbackProgress.toFixed(4));
            buildSection.style.setProperty('--qds-build-float', entryProgress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (entryProgress > 0.35) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v14"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const payLaterMessage = root.querySelector('[data-paypal-pay-later-message]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;
        if (payLaterMessage && variant.price_amount) {
          payLaterMessage.setAttribute('data-pp-amount', variant.price_amount);
        }

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-fit__negative',
            '.qds-fit__actions',
            '.qds-ssd-guide__head',
            '.qds-ssd-guide__grid article',
            '.qds-ssd-guide__note',
            '.qds-box__media',
            '.qds-included__copy',
            '.qds-box__grid li',
            '.qds-box__badges span',
            '.qds-box__notice',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const travel = Math.max(rect.height - window.innerHeight, 1);
            const scrollProgress = reduceMotion ? 1 : clamp(-rect.top / travel, 0, 1);
            const entryProgress = reduceMotion
              ? 1
              : clamp((window.innerHeight - rect.top) / (window.innerHeight * 0.5), 0, 1);
            const playbackProgress = reduceMotion ? 1 : clamp((scrollProgress - 0.08) / 0.88, 0, 1);
            const eased = playbackProgress;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', playbackProgress.toFixed(4));
            buildSection.style.setProperty('--qds-build-float', entryProgress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (entryProgress > 0.35) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v18"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const payLaterMessage = root.querySelector('[data-paypal-pay-later-message]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const checkoutButton = root.querySelector('[data-qds-checkout]');
      const tiles =Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;
        if (payLaterMessage && variant.price_amount) {
          payLaterMessage.setAttribute('data-pp-amount', variant.price_amount);
        }

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);
        if (checkoutButton) checkoutButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      /* Check out now: add the selected finish and quantity, then go straight to checkout. If the
         finish is already in the cart its quantity is set instead, so checkout shows exactly what was
         chosen here. Add to cart keeps the theme's own flow. */
      if (checkoutButton) {
        const form = checkoutButton.closest('form');
        const errorBox = root.querySelector('.qds-form__error');
        const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const cartUrl = (window.routes && window.routes.cart_url) || `${shopRoot}cart`;
        const addUrl = (window.routes && window.routes.cart_add_url) || `${shopRoot}cart/add`;
        const changeUrl = (window.routes && window.routes.cart_change_url) || `${shopRoot}cart/change`;
        const showError = (message) => {
          if (!errorBox) return;
          errorBox.hidden = !message;
          const text = errorBox.querySelector('.product-form__error-message');
          if (text) text.textContent = message || '';
        };
        const cartRequest = async (url, body) => {
          const isForm = body instanceof FormData;
          const response = await fetch(url, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest', ...(isForm ? {} : { 'Content-Type': 'application/json' }) },
            body: isForm ? body : JSON.stringify(body),
            credentials: 'same-origin',
          });
          const json = await response.json().catch(() => ({}));
          if (!response.ok || json.status) throw new Error(json.description || json.message || 'QuadDrive could not be added. Please try again.');
        };
        checkoutButton.addEventListener('click', async () => {
          if (!form || checkoutButton.getAttribute('aria-busy') === 'true' || !hiddenInput || hiddenInput.disabled) return;
          checkoutButton.setAttribute('aria-busy', 'true');
          showError('');
          const data = new FormData(form);
          const variantId = String(data.get('id'));
          const quantity = Math.max(1, parseInt(data.get('quantity'), 10) || 1);
          try {
            const cart = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
              .then((response) => response.json())
              .catch(() => null);
            const line = cart && Array.isArray(cart.items) ? cart.items.find((item) => String(item.variant_id) === variantId) : null;
            if (!line) await cartRequest(addUrl, data);
            else if (line.quantity !== quantity) await cartRequest(`${changeUrl}.js`, { id: line.key, quantity });
            window.location.href = `${shopRoot}checkout`;
          } catch (error) {
            showError(error.message || 'Something went wrong. Please try again.');
            checkoutButton.removeAttribute('aria-busy');
          }
        });
        // Coming back from checkout restores the page from cache with the button still busy.
        window.addEventListener('pageshow', (event) => {
          if (event.persisted) checkoutButton.removeAttribute('aria-busy');
        });
      }

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-fit__negative',
            '.qds-fit__actions',
            '.qds-ssd-guide__head',
            '.qds-ssd-guide__grid article',
            '.qds-ssd-guide__note',
            '.qds-box__media',
            '.qds-included__copy',
            '.qds-box__grid li',
            '.qds-box__badges span',
            '.qds-box__notice',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const travel = Math.max(rect.height - window.innerHeight, 1);
            const scrollProgress = reduceMotion ? 1 : clamp(-rect.top / travel, 0, 1);
            const entryProgress = reduceMotion
              ? 1
              : clamp((window.innerHeight - rect.top) / (window.innerHeight * 0.5), 0, 1);
            const playbackProgress = reduceMotion ? 1 : clamp((scrollProgress - 0.08) / 0.88, 0, 1);
            const eased = playbackProgress;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', playbackProgress.toFixed(4));
            buildSection.style.setProperty('--qds-build-float', entryProgress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (entryProgress > 0.35) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v5"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v6"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v7"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v8-legacy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v8"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__copy',
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-build-cinema__media',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const start = window.innerHeight * 0.72;
            const end = -rect.height + window.innerHeight * 0.34;
            const progress = reduceMotion ? 1 : clamp((start - rect.top) / Math.max(start - end, 1), 0, 1);
            const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', progress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (progress > 0.02) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page-v9"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');
      const buildFramesScript = root.querySelector('[data-qds-build-frames]');
      const buildSection = root.querySelector('[data-qds-build-scroll]');
      const buildFrame = root.querySelector('[data-qds-build-frame]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }

      const revealTargets = Array.from(
        root.querySelectorAll(
          [
            '.qds-hero__copy',
            '.qds-hero__stats div',
            '.qds-buy',
            '.qds-value__decision',
            '.qds-value-card',
            '.qds-build-cinema__panel',
            '.qds-build-cinema__media',
            '.qds-proof-grid article',
            '.qds-trusted__headline',
            '.qds-trusted__video',
            '.qds-trusted__quote',
            '.qds-trusted__cards article',
            '.qds-section__copy',
            '.qds-section__media',
            '.qds-included__copy',
            '.qds-features__grid article',
            '.qds-specs__table',
            '.qds-faq details',
            '.qds-final'
          ].join(',')
        )
      );

      revealTargets.forEach((target) => target.classList.add('qds-reveal'));

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
      } else {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                entry.target.classList.remove('is-exiting');
              } else if (entry.boundingClientRect.top < 0) {
                entry.target.classList.remove('is-visible');
                entry.target.classList.add('is-exiting');
              } else {
                entry.target.classList.remove('is-visible', 'is-exiting');
              }
            });
          },
          { threshold: 0.16, rootMargin: '-4% 0px -8% 0px' }
        );

        revealTargets.forEach((target) => revealObserver.observe(target));
      }

      if (buildFramesScript && buildSection && buildFrame) {
        let buildFrames = [];
        try {
          buildFrames = JSON.parse(buildFramesScript.textContent || '[]');
        } catch (error) {
          buildFrames = [];
        }

        if (buildFrames.length) {
          const buildCache = new Map();
          const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
          const loadFrame = (index) => {
            const safeIndex = clamp(index, 0, buildFrames.length - 1);
            const src = buildFrames[safeIndex];
            if (!src || buildCache.has(src)) return;
            const image = new Image();
            image.decoding = 'async';
            image.src = src;
            buildCache.set(src, image);
          };

          [0, 8, 17, 29, buildFrames.length - 1].forEach(loadFrame);

          let activeBuildFrame = -1;
          let buildRaf = 0;
          let allBuildFramesQueued = false;

          const queueAllBuildFrames = () => {
            if (allBuildFramesQueued) return;
            allBuildFramesQueued = true;
            buildFrames.forEach((_, index) => window.setTimeout(() => loadFrame(index), index * 18));
          };

          const updateBuildFrame = () => {
            buildRaf = 0;
            const rect = buildSection.getBoundingClientRect();
            const start = window.innerHeight * 0.72;
            const end = -rect.height + window.innerHeight * 0.34;
            const progress = reduceMotion ? 1 : clamp((start - rect.top) / Math.max(start - end, 1), 0, 1);
            const eased = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
            const index = Math.round(eased * (buildFrames.length - 1));

            buildSection.style.setProperty('--qds-build-progress', progress.toFixed(4));

            if (index !== activeBuildFrame && buildFrames[index]) {
              activeBuildFrame = index;
              buildFrame.src = buildFrames[index];
              loadFrame(index + 1);
              loadFrame(index + 2);
              loadFrame(index - 1);
            }

            if (progress > 0.02) queueAllBuildFrames();
          };

          const requestBuildFrame = () => {
            if (buildRaf) return;
            buildRaf = window.requestAnimationFrame(updateBuildFrame);
          };

          updateBuildFrame();
          window.addEventListener('scroll', requestBuildFrame, { passive: true });
          window.addEventListener('resize', requestBuildFrame);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quaddrive-shop-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-qds-root]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.qdsReady === 'true') return;
      root.dataset.qdsReady = 'true';

      const variantScript = root.querySelector('[data-qds-variants]');
      const variants = variantScript ? JSON.parse(variantScript.textContent || '[]') : [];
      const hiddenInput = root.querySelector('[data-qds-variant-id]');
      const priceEl = root.querySelector('[data-qds-price]');
      const compareEl = root.querySelector('[data-qds-compare]');
      const saveEl = root.querySelector('[data-qds-save]');
      const stickyPrice = root.querySelector('[data-qds-sticky-price]');
      const atcText = root.querySelector('[data-qds-atc-text]');
      const submitButton = root.querySelector('.qds-atc');
      const tiles = Array.from(root.querySelectorAll('[data-qds-variant-tile]'));
      const options = Array.from(root.querySelectorAll('[data-qds-variant-option]'));
      const buyPanel = root.querySelector('[data-qds-buy-panel]');
      const sticky = root.querySelector('[data-qds-sticky]');
      const stickyTrigger = root.querySelector('[data-qds-sticky-trigger]');

      const variantById = (id) => variants.find((variant) => String(variant.id) === String(id));

      const setVariant = (id) => {
        const variant = variantById(id);
        if (!variant) return;

        if (hiddenInput) {
          hiddenInput.value = variant.id;
          hiddenInput.disabled = !variant.available;
        }

        if (priceEl) priceEl.textContent = variant.price;
        if (stickyPrice) stickyPrice.textContent = variant.price;

        if (compareEl) {
          compareEl.textContent = variant.compare || '';
          compareEl.classList.toggle('is-hidden', !variant.compare);
        }

        if (saveEl) {
          saveEl.textContent = variant.save ? `Save ${variant.save}` : '';
          saveEl.classList.toggle('is-hidden', !variant.save);
        }

        if (atcText) atcText.textContent = variant.available ? 'Add QuadDrive to cart' : 'Sold out';
        if (submitButton) submitButton.toggleAttribute('disabled', !variant.available);

        tiles.forEach((tile) => {
          const input = tile.querySelector('[data-qds-variant-option]');
          tile.classList.toggle('is-selected', input && String(input.value) === String(id));
        });
      };

      options.forEach((option) => {
        option.addEventListener('change', () => setVariant(option.value));
      });

      const scrollToBuy = () => {
        if (!buyPanel) return;
        buyPanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const firstInput = buyPanel.querySelector('[data-qds-variant-option]:checked') || buyPanel.querySelector('button');
        window.setTimeout(() => firstInput && firstInput.focus && firstInput.focus(), 360);
      };

      if (stickyTrigger) stickyTrigger.addEventListener('click', scrollToBuy);

      if (sticky && buyPanel) {
        let stickyTicking = false;
        const updateSticky = () => {
          const rect = buyPanel.getBoundingClientRect();
          sticky.hidden = rect.bottom >= 0;
          stickyTicking = false;
        };
        const requestStickyUpdate = () => {
          if (stickyTicking) return;
          stickyTicking = true;
          window.requestAnimationFrame(updateSticky);
        };

        updateSticky();
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate, { passive: true });
      } else if (sticky) {
        sticky.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raiden-home-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-rdv-home]');
    if (!roots.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach((root) => {
      const carousel = root.querySelector('[data-rdv-carousel]');
      const slides = Array.from(root.querySelectorAll('[data-rdv-slide]'));
      const controls = Array.from(root.querySelectorAll('[data-rdv-slide-control]'));
      const progress = Array.from(root.querySelectorAll('[data-rdv-progress]'));
      const slideDuration = carousel ? Number.parseInt(carousel.dataset.rdvSlideDuration || '7000', 10) : 7000;
      let activeIndex = 0;
      let timer = null;

      const setSlide = (nextIndex) => {
        if (!slides.length) return;
        activeIndex = (nextIndex + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        controls.forEach((control, index) => {
          const isActive = index === activeIndex;
          control.classList.toggle('is-active', isActive);
          control.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        progress.forEach((bar, index) => {
          bar.classList.remove('is-active');
          if (index === activeIndex) {
            void bar.offsetWidth;
            bar.classList.add('is-active');
          }
        });
      };

      const scheduleNext = () => {
        if (reduceMotion || slides.length < 2) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(() => {
          setSlide(activeIndex + 1);
          scheduleNext();
        }, slideDuration);
      };

      controls.forEach((control, index) => {
        control.addEventListener('click', () => {
          setSlide(index);
          scheduleNext();
        });
      });

      setSlide(0);
      scheduleNext();

      document.addEventListener('visibilitychange', () => {
        window.clearTimeout(timer);
        if (!document.hidden) {
          scheduleNext();
        }
      });

      const revealTargets = Array.from(root.querySelectorAll('.rdv-reveal'));
      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealTargets.forEach((target) => target.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
      );

      revealTargets.forEach((target) => observer.observe(target));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raiden-shop-announcement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-rda-shop-offer]').forEach((offer) => {
      const close = offer.querySelector('[data-rda-shop-offer-close]');
      if (!close) return;

      close.addEventListener('click', () => {
        offer.classList.add('is-hidden');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raiden-static-page-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-rdv-static]');
    if (!roots.length) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach((root) => {
      const targets = Array.from(root.querySelectorAll('.rdv-static-reveal'));
      if (reduceMotion || !('IntersectionObserver' in window)) {
        targets.forEach((target) => target.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
      );

      targets.forEach((target) => observer.observe(target));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-collection-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-rdc26]').forEach((root) => {
      const motion = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      const $ = (selector) => root.querySelector(selector);
      const $$ = (selector) => Array.from(root.querySelectorAll(selector));
      root.classList.add('rdc26-js');

      /* ---------- Reveal (content already on screen is shown at once) ---------- */
      const grid = $('[data-rdc26-grid]');
      if (grid) Array.from(grid.children).forEach((card, i) => card.style.setProperty('--rd-d', `${Math.min(i, 8) * 60}ms`));
      const reveal = (node) => {
        node.classList.add('is-in');
        if (node === grid) window.setTimeout(() => Array.from(grid.children).forEach((card) => card.style.setProperty('--rd-d', '0ms')), 1200);
      };
      if (motion && 'IntersectionObserver' in window) {
        const nodes = $$('[data-rdc26-reveal]');
        nodes.forEach((node) => {
          if (node.getBoundingClientRect().top < window.innerHeight) reveal(node);
        });
        root.classList.add('rdc26-motion');
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal(entry.target);
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
        nodes.forEach((node) => {
          if (!node.classList.contains('is-in')) io.observe(node);
        });
      } else {
        $$('[data-rdc26-reveal]').forEach(reveal);
      }

      /* ---------- Category tabs (products on this page) ---------- */
      const cards = $$('[data-rdc26-grid] > [data-cat]');
      const tabs = $$('[data-rdc26-tab]');
      const status = $('[data-rdc26-status]');
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        const value = tab.dataset.rdc26Tab;
        let shown = 0;
        cards.forEach((card) => {
          const match = value === 'all' || card.dataset.cat === value;
          card.hidden = !match;
          if (match) shown += 1;
        });
        tabs.forEach((other) => other.setAttribute('aria-pressed', String(other === tab)));
        if (status) status.textContent = (shown === 1 ? status.dataset.one : status.dataset.other).replace(/\d+/, shown);
      }));

      /* ---------- Sort submits on change ---------- */
      const sort = $('[data-rdc26-sort]');
      if (sort) {
        const select = sort.querySelector('select');
        if (select) select.addEventListener('change', () => sort.submit());
      }

      /* ---------- Filter panel closes on outside click or Escape ---------- */
      const filter = $('[data-rdc26-filter]');
      if (filter) {
        document.addEventListener('click', (event) => {
          if (filter.open && !filter.contains(event.target)) filter.open = false;
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && filter.open) {
            filter.open = false;
            filter.querySelector('summary').focus();
          }
        });
      }

      /* ---------- Cursor spotlight (mouse / trackpad only) ---------- */
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        let spotEvent = null;
        let spotQueued = false;
        root.addEventListener('pointermove', (event) => {
          spotEvent = event;
          if (spotQueued) return;
          spotQueued = true;
          window.requestAnimationFrame(() => {
            spotQueued = false;
            const card = spotEvent.target.closest && spotEvent.target.closest('[data-rdc26-spot]');
            if (!card) return;
            const r = card.getBoundingClientRect();
            card.style.setProperty('--mx', `${Math.round(spotEvent.clientX - r.left)}px`);
            card.style.setProperty('--my', `${Math.round(spotEvent.clientY - r.top)}px`);
          });
        }, { passive: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rd-home-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-rd26]');
    roots.forEach((root) => {
      /* Effects are switched on here, by the script itself, so a slow or failed script load
         never leaves content hidden. Content already on screen is marked revealed first. */
      const motion = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      const $ = (selector) => root.querySelector(selector);
      const $$ = (selector) => Array.from(root.querySelectorAll(selector));
      root.classList.add('rd26-js');

      /* ---------- Reveal on scroll ---------- */
      $$('[data-rd-stagger]').forEach((group) => {
        Array.from(group.children).forEach((child, i) => child.style.setProperty('--rd-d', `${Math.min(i, 8) * 70}ms`));
      });
      const reveal = (node) => {
        node.classList.add('is-in');
        /* Drop stagger delays once the entrance is over so hover effects respond at once. */
        if (node.hasAttribute('data-rd-stagger')) {
          window.setTimeout(() => {
            Array.from(node.children).forEach((child) => child.style.setProperty('--rd-d', '0ms'));
          }, 1400);
        }
      };
      if (motion && 'IntersectionObserver' in window) {
        $$('[data-rd-reveal]').forEach((node) => {
          if (node.getBoundingClientRect().top < window.innerHeight) reveal(node);
        });
        root.classList.add('rd26-motion');
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              reveal(entry.target);
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        $$('[data-rd-reveal]').forEach((node) => {
          if (!node.classList.contains('is-in')) io.observe(node);
        });
      } else {
        $$('[data-rd-reveal]').forEach(reveal);
      }

      /* ---------- Category filter ---------- */
      const cards = $$('[data-rd-grid] > [data-cat]');
      const filterButtons = $$('[data-rd-filter]');
      const status = $('[data-rd-filter-status]');
      const applyFilter = (value) => {
        let shown = 0;
        cards.forEach((card) => {
          const match = value === 'all' || card.dataset.cat === value;
          card.hidden = !match;
          if (match) shown += 1;
        });
        filterButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.rdFilter === value)));
        const active = filterButtons.find((button) => button.dataset.rdFilter === value);
        const label = active ? active.firstChild.textContent.trim() : value;
        if (status) status.textContent = `${(shown === 1 ? status.dataset.one : status.dataset.other).replace(/\d+/, shown)}: ${label}`;
      };
      filterButtons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.rdFilter)));
      $$('[data-rd-filter-link]').forEach((link) => {
        link.addEventListener('click', () => applyFilter(link.dataset.rdFilterLink));
      });

      /* ---------- Community rail ---------- */
      const rail = $('[data-rd-rail]');
      const prev = $('[data-rd-rail-prev]');
      const next = $('[data-rd-rail-next]');
      if (rail && prev && next) {
        const step = () => {
          const first = rail.firstElementChild;
          return first ? first.getBoundingClientRect().width + 14 : rail.clientWidth * 0.8;
        };
        const update = () => {
          const max = rail.scrollWidth - rail.clientWidth - 2;
          prev.disabled = rail.scrollLeft <= 2;
          next.disabled = rail.scrollLeft >= max;
          root.querySelector('[data-rd-railnav]').style.visibility = max <= 0 ? 'hidden' : '';
        };
        prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: motion ? 'smooth' : 'auto' }));
        next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: motion ? 'smooth' : 'auto' }));
        let ticking = false;
        rail.addEventListener('scroll', () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(() => {
            update();
            ticking = false;
          });
        }, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
      }

      /* ---------- Cursor spotlight on cards (mouse / trackpad only) ---------- */
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        let spotEvent = null;
        let spotQueued = false;
        root.addEventListener('pointermove', (event) => {
          spotEvent = event;
          if (spotQueued) return;
          spotQueued = true;
          window.requestAnimationFrame(() => {
            spotQueued = false;
            const card = spotEvent.target.closest && spotEvent.target.closest('[data-rd-spot]');
            if (!card) return;
            const r = card.getBoundingClientRect();
            card.style.setProperty('--mx', `${Math.round(spotEvent.clientX - r.left)}px`);
            card.style.setProperty('--my', `${Math.round(spotEvent.clientY - r.top)}px`);
          });
        }, { passive: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
